
/*@@
  @Name: en-US.jsx
  @Description: Localization file including date formatting
  @Note: Convention. UPPER_CASE means it is also an endpoint. But this will go away

  @Usage
     Implicitly used by AppLoader
 */

import React from "react";

export default {
  digital_risk_and_compliance: "Digital Risk & Compliance",

  //error messages
  error_message_generic: 'Cannot load data. Please refresh or try again later.',
  error_message_timeout: 'Request took too long. Please refresh or try again later.',

  month_1: 'January',
  month_2: 'February',
  month_3: 'March',
  month_4: 'April',
  month_5: 'May',
  month_6: 'June',
  month_7: 'July',
  month_8: 'August',
  month_9: 'September',
  month_10: 'October',
  month_11: 'November',
  month_12: 'December',

  enable: 'Enable',
  disable: 'Disable',

  NUMBER_FORMAT: "{n, number}",
  id: 'ID',
  property: 'Property',
  logo: "Logo",
  enter_keywords: 'Enter a keyword',
  //catalog
  catalog: 'Catalog',
  //pods
  window: 'Window',
  pod_summary: 'Summary',
  pod_alerts: 'Alerts',
  pod_roi: 'ROI',
  pod_lockbox: 'Password Lockbox',
  pod_tasks: 'User Tasks',
  settings_pod: 'Pod Settings',
  pod_risk_scores_bundle: 'Risk Scores Bundle',
  pod_risk_event_summary: 'Risk Event Summary',
  top_seeds_by_detections: 'Top Seeds by Detection Count',
  top_classifications_by_detections: 'Top Domain Classifications',
  recent_changes_to_suspicious_domains: 'Recent Changes to Suspicious Domains',
  recent_tap_detections: 'Domains with Recent TAP Detections',
  //I18n
  DATE_M_Y_time: "{value, date, short}",
  DATE_short: "{value, date, short}",
  DATE_medium: "{value, date, medium}",
  DATE_long: "{value, date, long}",
  DATE_full: "{value, date, full}",
  TIME_short: "{value, time, short}",
  TIME_medium: "{value, time, medium}",
  TIME_long: "{value, time, long}",
  DATE_TIME_full: "{value, date, short} - {value, time, medium}",
  es: 'Spanish',
  'es-ES': 'Spanish (Castellano)',
  en: 'English',
  'en-US': 'English (U.S.A.)',
  cn: 'Chinese',
  'zh-CN': 'Chinese (Simplified)',
  hello: 'Hello',
  HELLO: "Hello, {name}. Welcome to {where}!",
  //nav
  total: 'Total',
  page: 'Page',
  //nav
  //forms
  submit: 'Submit',
  reset: 'Reset',
  cancel: 'Cancel',
  send_preview: 'Send Preview',
  continue: 'Continue',
  continue_ellipsis: 'Continue...',
  authorize: 'Authorize',
  authorized: 'Authorized',
  change: 'Change',
  reauthorize: 'Reauthorize',
  save: 'Save',
  update: 'Update',
  add: 'Add',
  remove: 'Remove',
  close: 'Close',
  clone: "Clone",
  value: 'Value',
  user_name: "Username",
  view: 'View',
  dismiss: 'Dismiss',
  confirm: 'Confirm',
  download: 'Download',
  assign: 'Assign',
  use_default: 'Use Default',
  optional_mark: '(optional)',
  required_mark: '(required)',
  //form
  date_from: "From",
  date_to: "To",
  from_date: "From {start, date}",
  to_date: " to {start, date}",
  goodbye: "Goodbye",
  customers: 'Customers',
  patrol_licenses: 'Licenses',
  terms: "Terms",
  privacy: "Privacy",
  copyright: "Proofpoint, Inc.",
  accounts: 'Accounts',
  tags: 'Tags',
  link: 'Link',
  links: 'Links',
  users: 'Users',
  status: 'Status',
  formatted_status: 'Status',
  prev: 'Previous',
  next: 'Next',
  pages: 'Pages',
  select_tag: 'Select Tag',
  todo_list: 'Todo List',
  under_construction: 'Under Construction',
  go_to_catalog: 'Go to Catalog',
  go_to_dashboard: 'Go to Dashboard',

  // Tables
  expand_all: 'Expand All',
  collapse_all: 'Collapse All',

  // Apps
  LANDING: 'Home',
  DASHBOARD: 'Dashboard',
  SOCIAL_DISCOVER: 'Social Discover',
  MOBILE_DISCOVER: 'Mobile Discover',
  DOMAIN_DISCOVER: 'Domain Discover',
  PASSWORD_LOCKBOX: 'Password Lockbox',
  TASKS: 'Tasks',

  //V1 page links
  find_accounts: 'Find Accounts',
  advanced_discover: 'Advanced Discover',
  add_accounts: 'Add Accounts',
  tag_view: 'Tag View',
  ignored_accounts: 'Ignored Accounts',
  image_library: 'Image Library',
  image_libraries: 'Image Libraries',
  find_apps: 'Find Apps',
  ignored_apps: 'Ignored Apps',
  configuration: 'Configuration',
  patrol_configurations: 'Patrol Configurations',
  domain_detections: 'Domain Detections',
  domain_detections_v2: 'Domain Detections (UI-v2)',
  url_detections: 'URL Detections',
  add_watched: 'Add Watched',
  ignored_domains: 'Ignored Domains',
  alerts_v1: 'Alerts',

  entities: 'Entities',
  entities_unprotected: 'Entities Unprotected',
  entities_places: "Places",
  entities_people: "People",
  entities_brand: "Brand",
  entities_hastag: "Custom",
  profiles: 'Profiles',
  content_and_incidents: 'Content/Incidents',
  content_item: 'Content Item',
  account_admins: 'Account Admins',
  app_policies: 'App Policies',
  app_policies_v2: 'App Policies V2',
  content_policies: 'Content Policies',
  custom_policies: 'Custom Classifiers',
  profile_policies: 'Profile Policies',
  profile_policies_v3: 'Profile Policies',
  patrol_entities_v2: 'Accounts',
  content_policies_v2: 'Content Policies V2',
  install_social_account: 'Add Social Account',
  install_brand: 'Add Brand',
  install_term: 'Add Custom',
  install_people: 'Add People',
  install_location: 'Add Location',

  entities_social: 'Social',

  commenters: 'Commenters',
  block_list_tab: 'Block List',
  watch_list_tab: 'Watch List',
  ignore_list_tab: 'Ignore List',
  commenter_name: 'Name',
  commenter_platform: 'Platform',
  commenter_action_move_to_watch: 'Move to Watch List',
  commenter_action_move_to_block: 'Move to Block List',
  commenter_action_remove: 'Remove',
  commenter_remove_confirm_title: 'Do you want to remove this user?',
  commenter_remove_confirm_button: 'Remove User',
  commenter_switch_to_block_confirm_title: 'Move this commenter to the Block List?',
  commenter_switch_to_block_confirm_button: 'Move to Block List',
  commenter_switch_to_block_success: 'Commenter moved to block list',
  commenter_switch_to_watch_confirm_title: 'Move this commenter to the Watch List?',
  commenter_switch_to_watch_confirm_button: 'Move to Watch List',
  commenter_switch_to_watch_success: 'Commenter moved to watch list',
  commenter_block_confirm_title: 'Block this commenter?',
  commenter_block_confirm_button: 'Block',
  commenter_block_success: 'Commenter added to block list',
  commenter_watch_confirm_title: 'Watch this commenter?',
  commenter_watch_confirm_button: 'Watch',
  commenter_watch_success: 'Commenter added to watch list',
  commenter_ignore_confirm_title: 'Ignore this commenter?',
  commenter_ignore_confirm_button: 'Ignore',
  commenter_ignore_success: 'Commenter added to ignore list',
  commenter_remove_from_block_success: 'Commenter removed from block list',
  commenter_remove_from_watch_success: 'Commenter removed from watch list',
  commenters_summary_panel: 'Lists Summary',
  commenters_yt_disclaimer: 'Block, Watch and Ignore List counts are not based on counts provided by data source APIs (e.g. YouTube API). They are solely based upon Commenters added to those lists by Proofpoint Users.',
  commenters_add_to_list: 'Add Commenter to List',
  commenters_add_to_list_title: 'Add to Block/Watch/Ignore lists',
  commenters_search_placeholder: 'Search by name or profile URL...',
  commenters_search_platform_label: 'Platform',
  commenters_search_no_results: 'No results found',
  commenters_search_min_chars: 'Type at least 2 characters to search',
  commenters_enabled_accounts: 'Enabled Accounts',
  commenters_enabled_accounts_header: '{count} Accounts with Watch/Block Lists Enabled',
  commenters_block_list_tooltip: 'These social accounts have been added to the social networking platform block list of Patrolled Accounts where block list API exists. Where block list API does not exist, content from these accounts is Deleted on Patrolled accounts.',
  commenters_watch_list_tooltip: 'Social accounts will trigger a notification anytime they comment on Patrolled Account Entities. Non-social account Commenters on will trigger a notification anytime a reference to Custom, Brand, Location, or Person Entity from the Commenter is detected.',
  commenters_enable_spam_blocking: 'Enable Spam Blocking',
  commenters_disable_spam_blocking: 'Disable Spam Blocking',
  commenters_spam_blocking_title: 'Spam List Blocking',
  commenters_spam_blocking_description: 'Users who post a significant amount of spam across many different social media accounts are added to the Proofpoint Social Media Spam List. If this option is enabled, content from any user on the list will automatically be removed from any of your accounts.',
  commenters_spam_blocking_confirm_enable: 'Enable',
  commenters_spam_blocking_confirm_disable: 'Disable',
  commenters_spam_blocking_enabled_success: 'Spam blocking enabled',
  commenters_spam_blocking_disabled_success: 'Spam blocking disabled',
  reports: 'Reports',
  takedowns: 'takedowns',

  //Dashboard
  no_data_available: 'No data available to display yet.',

  //Dashboard Titles
  dashboard_security_title: 'Security Dashboard',
  dashboard_compliance_supervisor_title: 'Reviewer Dashboard',
  dashboard_compliance_title: 'Compliance Overview',
  dashboard_program_manager_title: 'Program Manager Dashboard',
  summary: 'Summary',
  dashboard: 'Dashboard',
  dashboards: 'Dashboards',
  user_notifications: 'User Notifications',
  content_classifier_audit: "Content Classifier Audit",

  high_risk_incidents: "High Risk Incidents",
  pending_takedowns: "Pending Takedowns",
  takedowns_pending: "Takedowns Pending",
  administrative_suggestions: 'Admin Suggestions',
  administrative_recommendations: 'Administrative Recommendations',
  data_coverage: "Data Coverage",

  //Disconnected Accounts
  disconnected_accounts: "Expired Accounts",
  disconnected_accounts_modal_message: "Proofpoint cannot monitor, protect or archive data for expired accounts. You can notify your account owners to reauthorize now.",
  notify_account_owners: "NOTIFY ACCOUNT OWNERS",

  notify_account_title: "Notify Expired Account Owners",
  disconnected_accounts_message_to_dialog_users: "You have {totalDisconnectedAccounts} expired accounts. Edit the subject and message below and our system will individually email each account owner.",
  disconnected_accounts_email_intro: "Hi {leftCurlyBracket}ACCOUNT OWNER NAME{rightCurlyBracket},",
  disconnected_account_reauth_link: "Reauthorization link for {leftCurlyBracket}ACCOUNT NAME{rightCurlyBracket}: {leftCurlyBracket}REAUTHORIZATION LINK{rightCurlyBracket}",
  notify_account_button1: "DISMISS",
  notify_account_button2: "SEND NOTIFICATIONS",
  disconnected_accounts_snackbar_message: "{num_emails_sent, plural, =1 {{num_emails_sent} expired account email sent successfully.} other {{num_emails_sent} expired account emails sent successfully.}}",

  //Pending Takedown Translations, do not change unless design spec changes
  social_accounts: "Social Account",
  domains: "Domain",
  mobile_apps: "Mobile App",
  social_content: "Social Content",
  web_content: "URL",

  social_identity_searches: 'Social Searches',
  protected_assets_social_accounts: 'Social Accounts',
  domain_identity_searches: 'Domain Searches',
  people: 'People',
  locations: 'Locations',
  mobile_app_identity_searches: 'Mobile Searches',
  brand: 'Brand',
  brands: 'Brands',
  custom: 'Custom',

  policy_action_log: "Log",
  policy_action_notify: "Notify",
  policy_action_delete: "Delete",
  policy_action_hide: "Hide",
  policy_action_null: "None",

  top_incidents: "Top Incidents",
  trend_classifier_groups: "Top Classifier Groups",
  incident_remediation: "Cost Savings - Automated Remediation",
  incidents_remediated: 'Incidents Remediated',
  content_items_reviewed: 'Content Items Reviewed',
  trend_classifiers: "Top Classifiers",

  top_overall_categories: "Top Overall Categories",
  top_classifier_groups: "Top Classifier Groups",
  threat_trends: "Threat Trends",
  top_threat_actors: "Top Threat Sources",
  incidents_by_entity_type: "Incidents By Entity Type",
  top_entities: "Top Entities",
  top_entity_types: "Top Entity Types",
  top_risk_entities: "Top Entities",
  policy_action_summary: "Policy Action Summary",
  takedown_summary: "Takedown Summary",
  top_classifiers: "Top Classifiers",
  protected_assets: "Protected Assets",
  automated_remediation_roi: "Cost Savings - Automated Remediation",
  policy_action: 'Policy Action',
  policy_action_incident: "{num_incident, plural, =1 {Incident} other {Incidents} }",

  threat_center: 'Threat Center',
  discover: 'Discover',
  social_discover: 'Social Discover',
  social_discover_group_title: 'Social',
  mobile_discover: 'Mobile Discover',
  mobile_discover_group_title: 'Mobile',
  domain_discover: 'Domain Discover',
  domain_discover_group_title: 'Domain',
  common_discover_group_title: 'Common',
  patrol: 'Patrol',
  tasks: 'Tasks',
  sight: 'Sight',
  ROI: 'ROI',
  alerts: 'Alerts',
  password_lockbox: 'Password Lockbox',
  risk_scores_bundle: 'Risk Scores Bundle',
  risk_event_summary: 'Risk Event Summary',
  top_entity: 'Top Entity',

  patrol_account: 'Patrol Account',

  // Management
  management: "Management",
  user_management: "User Management",
  external_apps: "External Applications",
  audit_logs: "Audit Logs",

  // Admin Management
  admin_settings: "My Settings",
  global_settings: "Global System Settings",
  admin_account: "My Info",
  admin_clients: "Manage Clients",
  admin_users: "Manage Users",
  admin_roles: "Role Management",
  admin_teams: "Team Management",
  admin_external_apps: "External Applications",
  admin_takedowns: "Takedown Config",
  admin_audits: "Audit Logs",

  //
  help_desk: 'Help Desk',
  documentation: 'Documentation',

  user_settings: 'User Settings',
  sign_out: 'Sign Out',
  my_information: 'My Information',
  email: 'Email',
  locale: 'Locale',
  change_to: 'Change to',
  //Audit logs
  date: "Date",
  type: "Type",
  name: "Name",
  incident: "Incident",
  incidents: "Incidents",
  actor: "Actor",
  no_user: "Non System User",
  system: "System",
  details: "Details",

  //FilterDates Options
  last_day: 'Last day',
  last_7_days: 'Last 7 days',
  last_15_days: 'Last 15 days',
  last_30_days: 'Last 30 days',
  last_3_months: 'Last 3 months',
  last_6_months: 'Last 6 months',
  last_year: 'Last year',
  all: 'All',
  custom_date: 'Custom Date',

  property_TW: "Twitter",
  property_FB: "Facebook",
  property_IG: "Instagram",
  property_LI: "LinkedIn",
  property_SF: "Salesforce",
  property_YT: "YouTube",
  property_YX: "Yext",
  property_PI: "Pinterest",
  property_VK: "VKontakte",
  property_VM: "Vimeo",
  property_GB: "Google Business",
  property_MEA: "Marketing Email Accounts",
  property_MSG: "Messaging Accounts",
  property_EE: "External Accounts",
  property_PP: "DarkNet",

  // Costs chart
  over_last_D7: 'Over Last 7 days',
  over_last_D15: 'Over Last 15 days',
  over_last_D30: 'Over Last 30 days',
  over_last_M3: 'Over Last 3 months',
  over_last_M6: 'Over Last 6 months',
  over_last_Y1: 'Over Last year',
  over_last_ALL: 'Over All Time',

  //Risks
  risk_0: 'High',
  risk_1: 'Medium',
  risk_2: 'Low',

  //security dash
  log: 'Log',
  notify: 'Notify',
  hide: 'Hide',
  delete: 'Delete',
  del_review: 'Delete and Review',
  successful: 'Successful',
  failed: 'Failed',
  pending: 'Pending',
  remediated_incidents: 'Remediated Incidents',
  cost_savings: 'Cost Savings (USD)',
  vs_last_30_days: 'vs last 30 days',
  apps: 'Apps',
  social: 'Social',
  criminal: 'Criminal',
  abnormal: 'Abnormal',
  security: 'Security',
  risk: 'Risk',
  time: 'Time',
  entity: 'Entity',
  source: 'Source',
  threat_actor: 'Threat Actor',
  threat_source: 'Threat Source',
  threat_category: 'Category',
  classification: 'Classification',
  entity_type: 'Account Type',
  account: 'Account',
  place: 'Locations',
  security_and_spam: 'Security and Spam',
  impersonation: 'Impersonation', //?
  impersonations: 'Impersonations', //?
  //data coverage
  //titles
  data_coverage_title_social_account_network_search: 'Social Accounts - Network Search',
  data_coverage_title_protected_social_accounts: 'Protected Social Accounts',
  data_coverage_title_whois_domains: 'WhoisDomains',
  data_coverage_title_web_darknet: 'Web/DarkNet Content',
  data_coverage_title_breach_database: 'Breach Database',
  data_coverage_title_mobile_apps_store_search: 'Mobile Apps - Store Search',
  data_coverage_title_twitter: 'Twitter',
  data_coverage_title_other: 'Other',
  //units
  data_coverage_units_social_account_network_search: 'posts',
  data_coverage_units_protected_social_accounts: 'posts',
  data_coverage_units_whois_domains: 'domains',
  data_coverage_units_web_darknet: 'documents',
  data_coverage_units_breach_database: 'records',
  data_coverage_units_mobile_apps_store_search: 'apps',
  data_coverage_units_twitter: 'tweets',
  data_coverage_units_other: 'records',


  //pod actions
  pod_action_move: 'Move Widget',
  pod_action_delete: 'Remove Widget',
  pod_action_edit: 'Edit Widget',

  //widgets
  widgets_selected: "Widgets Selected",
  selected: "Selected",
  selection_options: "Selection Options",
  dashboard_widgets: "Dashboard Widgets",
  EDIT_LAYOUT: "EDIT LAYOUT",
  SAVE: "SAVE",
  CANCEL: "CANCEL",

  // Content Policies
  content_policies_index_title: 'Content Policy Configuration',
  // Content Policies - Content Policies Tab
  content_policies_tab: 'Content Policies',
  content_policies_sub_tab: 'Content Policies',
  accounts_view_usage_tab: 'Accounts',
  syndicate_configs_view_usage_tab: 'Syndicate Configurations',
  content_policies_template_sub_tab: 'Policy Reference',
  create_content_policy: 'Create Content Policy',
  batch_actions_content_policy: 'Batch Actions',
  content_policies_table_title: 'Content Policies',
  template_patrol_policies_table_title: 'Policy References',
  content_policies_view_usage_title: 'View Content Policy Usage',
  view_usage_accounts_tab_title: 'Accounts Using Policy',
  view_usage_syndicate_configs_tab_title: 'Syndicate Configs  Using Policy',
  content_policy: 'Content Policy',
  policy: 'Policy',
  batch_delete_content_policy: 'Delete Content Policy',
  batch_set_custom_content_policy: 'Set Custom Classifiers',
  batch_set_built_in_content_policy: 'Set Classifier Exemptions',
  batch_set_language_content_policy: 'Set Language Exemptions',
  content_policy_name: 'Policy Name',
  content_policy_view_usage: 'View Usage',
  content_policy_description: 'Description',
  content_policy_updated_at: 'Last Updated',
  content_policy_edit: 'View/Edit Content Policy',
  content_policy_export: 'Export Content Policy',
  content_policy_duplicate: 'Duplicate Content Policy',
  content_policy_copy_to_subtenant: 'Copy to Subtenant',
  content_policy_select_custom_classifiers: 'Select Custom Classifiers',
  content_policy_select_built_in_classifiers: 'Select Classifier Exemptions',
  content_policy_select_language_classifiers: 'Select Language-Based Exemptions',
  content_policy_classifier_exemption_name: 'Standard Exemption Name',
  content_policy_classifier_exemption_description: 'Description',
  content_policy_classifier_exemption_type: 'Type',
  content_policy_classifier_exemptions_table_title: "{results_count, plural, =1 {{results_count} Classifier Exemption} other {{results_count} Classifier Exemptions}}",
  content_policy_language_based_exemptions_table_title: "{results_count, plural, =1 {{results_count} Language-Based Exemption} other {{results_count} Language-Based Exemptions}}",
  content_policy_language_based_exemption_display_name: 'Language Exemption Name',
  content_policy_language_based_exemption_language: 'Language',
  content_policy_language_based_exemption_type: 'Type',
  content_policy_language_based_exemption_action: 'Policy Action',
  content_policy_language_based_exemption_risk: 'Risk Level',
  // Delete Content Policy
  content_policy_delete: 'Delete Content Policy',
  content_policy_delete_modal_title: 'Delete Content Policy',
  content_policy_delete_modal_description: 'Are you sure you want to delete the selected Content Policy? This operation cannot be undone.',
  content_policy_delete_modal_confirm_button: 'Delete Policy',
  content_policy_deleted: "The content policy ''{content_policy}'' is deleted successfully",
  content_policy_duplicated: "The content policy ''{content_policy}'' was created successfully",
  content_policy_copied_to_subtenant: "The content policy ''{content_policy}'' was copied successfully to the Subtenant",
  template_content_policy_view: 'View Policy Reference',
  template_content_policy_export: 'Export Policy Reference',
  template_content_policy_duplicate: 'Duplicate Policy Reference',
  content_policies_delete_modal_title: 'Batch Delete Content Policies',
  content_policies_delete_modal_confirm_button: 'Delete Content Policies',
  select_content_policies: 'Select Content Policies',
  content_policies_deleted: "Content policies ''{content_policies}'' are deleted successfully",
  content_policies_deleted_errors: 'Content policies failed to delete:\n {content_policies}',
  content_policies_delete_modal_confirm_message: 'Are you sure you want to delete the selected Content Policies? This action cannot be undone.',
  approval_content_policies_delete_modal_title: 'Batch Delete Content Policies - {content_policies} Selected',
  // Content Policies - Configure Custom Classifiers
  configure_custom_classifiers_modal_title: 'Configure Custom Classifiers',
  configure_custom_classifiers_modal_confirm_button: 'Set Custom Classifiers',
  select_custom_classifiers: 'Select Custom Classifiers',
  content_policies_custom_classifiers_configured: "Content policies ''{content_policies}'' configured successfully",
  content_policies_custom_classifiers_configured_errors: 'Content policies failed to configure:\n {content_policies}',
  // Content Policies - Configure Language-Based Exemptions
  configure_language_exemptions_modal_title: 'Configure Language-Based Exemptions',
  configure_language_exemptions_modal_confirm_button: 'Set Language-Based Exemptions',
  select_language_exemptions: 'Select Language-Based Exemptions',
  content_policies_language_exemptions_configured: "Content policies ''{content_policies}'' configured successfully",
  content_policies_language_exemptions_configured_errors: 'Content policies failed to configure:\n {content_policies}',
  // Content Policies - Configure Language-Based Exemptions
  configure_classifier_exemptions_modal_title: 'Configure Classifier Exemptions',
  configure_classifier_exemptions_modal_confirm_button: 'Set Classifier Exemptions',
  select_classifier_exemptions: 'Select Classifier Exemptions',
  content_policies_classifier_exemptions_configured: "Content policies ''{content_policies}'' configured successfully",
  content_policies_classifier_exemptions_configured_errors: 'Content policies failed to configure:\n {content_policies}',
  any_changes_policies_batch_action_response: 'Content policies already contain these values. No updates were made.',
  // Content Policies - Custom Classifiers Tab
  custom_classifiers_tab: 'Custom Classifiers',
  custom_classifier_exemptions_table_title: 'Custom Classifiers',
  custom_classifier_exemption_patrol_policies_count: 'Content Policies Using Custom Classifier',
  custom_classifier_exemption_description: 'Description',
  custom_classifier_exemption_name: 'Custom Classifier Name',
  custom_classifier_exemption_updated_at: 'Last Updated',
  custom_classifier_exemption_edit: 'Edit Custom Classifier',
  custom_classifier_exemption_delete: 'Delete Custom Classifier',
  custom_classifier_exemptions_view_usage: 'View ({patrol_policies_count})',
  custom_classifier_exemption_view_usage_title: 'View Custom Classifier Usage',
  custom_classifier_exemption: 'Custom Classifier',
  create_custom_classifier_exemption: 'Create Custom Classifier',
  export_custom_classifier_exemptions: 'Export Custom Classifiers',
  save_custom_classifier_exemption: 'Save Custom Classifier',
  label_custom_classifier_exemption_display_name: 'Custom Classifier Name',
  label_custom_classifier_exemption_auto_block_on_incident: 'Automatically add third parties that trigger this classifier to your blocklist.',
  label_custom_classifier_exemption_mask: 'Mask data that triggers this classifier within the interface and email notifications.',
  custom_classifier_exemption_create_title: 'Create Custom Classifier',
  custom_classifier_exemption_update_title: 'Update Custom Classifier',
  custom_classifier_exemption_created: "The Custom Classifier ''{custom_classifier}'' is created successfully",
  custom_classifier_exemption_updated: "The Custom Classifier ''{custom_classifier}'' is updated successfully",
  custom_classifier_exemption_deleted: "The Custom Classifier ''{custom_classifier}'' is deleted successfully",
  custom_classifier_exemptions_exported: "The Custom Classifier Exemptions are exported successfully",
  custom_classifier_exemption_delete_modal_title: 'Delete Custom Classifier',
  custom_classifier_exemption_delete_modal_description: 'Are you sure you want to delete the selected Custom Classifier? This operation cannot be undone.',
  custom_classifier_exemption_delete_modal_confirm_button: 'Delete Custom Classifier',
  custom_classifier_text_rule_form_title: 'Custom Classifier Rules',
  start_date: 'Start Date',
  start_date_cannot_be_in_past: 'Start Date cannot be in the past',
  end_date: 'End Date',
  end_date_cannot_be_in_past: 'End Date cannot be in the past',
  end_date_before_start_date: 'End Date should be after Start Date',
  // Content Policies - Built-In Classifier Exemptions Tab
  built_in_classifier_tab: 'Classifier Exemptions',
  classifier_exemptions_table_title: 'Exemptions',
  classifier_exemption_patrol_policies_count: 'Content Policies Using Exemption',
  classifier_exemption_description: 'Description',
  classifier_exemption_name: 'Exemptions Name',
  classifier_exemption_updated_at: 'Last Updated',
  classifier_exemption_edit: 'Edit Exemption',
  classifier_exemption_delete: 'Delete Exemption',
  classifier_exemptions_view_usage: 'View ({patrol_policies_count})',
  classifier_exemption_view_usage_title: 'View Classifier Exemption Usage',
  classifier_exemption: 'Classifier Exemption',
  classifier_exemption_policies_title: 'Content Policies',
  create_classifier_exemption: 'Create Exemption',
  label_classifier_exemption_name: 'Exemption Name',
  classifier_exemption_form_warning: 'Classifier Exemptions can be used to create exceptions to Patrol\'s built-in classifiers. Use them to exempt specific text, phrases or URLs. Note: Exemptions do not apply to custom classifiers.',
  classifier_exemption_saved: "The Classifier Exemption ''{classifier_exemption}'' is saved successfully",
  classifier_exemption_created: "The Classifier Exemption ''{classifier_exemption}'' is created successfully",
  classifier_exemption_updated: "The Classifier Exemption ''{classifier_exemption}'' is updated successfully",
  classifier_exemption_deleted: "The Classifier Exemption ''{classifier_exemption}'' is deleted successfully",
  classifier_exemption_create_title: 'Create Classifier Exemption',
  classifier_exemption_update_title: 'Update Classifier Exemption',
  classifier_exemption_delete_modal_title: 'Delete Classifier Exemption',
  classifier_exemption_delete_modal_description: 'Are you sure you want to delete the selected Classifier Exemption? This operation cannot be undone.',
  classifier_exemption_delete_modal_confirm_button: 'Delete Classifier Exemption',
  save_classifier_exemption: 'Save Exemption',
  label_text_rule_type: 'Rule Type',
  label_text_rule_rule: 'Rule Text',
  remove_text_rule: 'Remove Rule',
  add_text_rule: 'Add Rule',
  text_rule_form_title: 'Exemption Rules',
  text_rule_form_hint: 'At least one rule must be specified.',
  url_domain_only: 'URL domain only',
  regular_expression: 'Regular Expression',
  url_regular_expression: 'URL regular expression',
  basic_text: 'Basic text',
  common_misspellings: 'Common misspellings',
  // Content Policies - Language-Based Exemptions Tab
  language_based_tab: 'Language-Based Exemptions',
  language_based_exemptions_table_title: 'Exemptions',
  language_based_exemption_patrol_policies_count: 'Content Policies Using Exemption',
  language_based_exemption_description: 'Description',
  language_based_exemption_name: 'Language Exemption Name',
  language_based_exemption_language: 'Language',
  language_based_exemption_updated_at: 'Last Updated',
  language_based_exemption_edit: 'Edit Exemption',
  language_based_exemption_delete: 'Delete Exemption',
  language_based_exemptions_view_usage: 'View ({patrol_policies_count})',
  language_based_exemption_view_usage_title: 'View Language- Based Exemption Usage',
  language_based_exemption: 'Language-Based Exemption',
  create_language_based_exemption: 'Create Language Exemption',
  save_language_based_exemption: 'Save Language Exemption',
  label_language_based_exemption_language: 'Language',
  label_language_based_exemption_display_name: 'Name',
  language_based_exemption_create_title: 'Create Language Exemption',
  language_based_exemption_update_title: 'Update Language Exemption',
  language_based_exemption_form_warning: 'Language-Based Exemptions can be used to create exceptions to Patrol\'s built-in classifiers. Use them to exempt specific text, phrases or URLs. Note: Exemptions do not apply to custom classifiers.',
  language_based_exemption_created: "The Language-Based Exemption ''{language_based_exemption}'' is created successfully",
  language_based_exemption_updated: "The Language-Based Exemption ''{language_based_exemption}'' is updated successfully",
  language_based_exemption_deleted: "The Language-Based Exemption ''{language_based_exemption}'' is deleted successfully",
  language_based_exemption_delete_modal_title: 'Delete Language-Based Exemption',
  language_based_exemption_delete_modal_description: 'Are you sure you want to delete the selected Language-Based Exemption? This operation cannot be undone.',
  language_based_exemption_delete_modal_confirm_button: 'Delete Language-Based Exemption',
  export_policy_modal_title: 'Export to CSV',
  export_policy_modal_description: 'The CSV file containing the requested exported data will be downloaded as soon as it has been created, which may take more than a minute. Please confirm that you want to proceed.',
  export_policy_modal_confirm_button: 'Export to CSV',
  duplicate_policy_modal_title: 'Duplicate Content Policy',
  duplicate_policy_modal_description: 'Are you sure you want to duplicate the selected Content Policy?',
  duplicate_policy_modal_confirm_button: 'Duplicate Content Policy',
  copy_policy_to_subtenant_modal_title: 'Copy Content Policy to Subtenant',
  copy_policy_to_subtenant_modal_description: 'Are you sure you want to copy the selected Content Policy to another Subtenant?',
  copy_policy_to_subtenant_modal_confirm_button: 'Copy to Subtenant',
  ENGLISH: 'English',
  SPANISH: 'Spanish',
  FRENCH: 'French',
  PORTUGUESE: 'Portuguese',
  CHINESE: 'Chinese',
  KOREAN: 'Korean',
  VIETNAMESE: 'Vietnamese',
  JAPANESE: 'Japanese',
  // Content Policies - New Content Policy
  content_policies_create_title: 'Create Content Policy',
  content_policies_update_title: 'Content Policy Configuration',
  classifier_exemptions_sub_tab: 'Classifier Exemptions',
  language_exemptions_sub_tab: 'Language Exemptions',
  custom_classifiers_sub_tab: 'Custom Classifiers',
  customizations_tab: 'Content Policy Customizations',
  audit_changes_tab: 'Audit Content Policy Changes',
  content_policy_tab: 'Content Policy',
  save_content_policy: 'Save Content Policy',
  export_to_csv_content_policy: 'Export to CSV',
  duplicate_content_policy: 'Duplicate Policy',
  copy_to_subtenant_content_policy: 'Copy to Subtenant',
  delete_content_policy: 'Delete Policy',
  configure_custom_classifiers: 'Configure Custom Classifiers',
  configure_classifier_exemptions: 'Configure Classifier Exemptions',
  configure_language_based_exemptions: 'Configure Language-Based Exemptions',
  delete_content_policies: 'Delete Content Policies',
  label_content_policy_name: 'Content Policy Name',
  label_content_policy_type: 'Content Policy Type',
  placeholder_content_policy_random_sample_percentage: 'Enter percentage',
  label_content_policy_random_sample_percentage: 'Random Sample Percentage',
  label_content_policy_blocklist: "Automatically add third parties that trigger this content policy to your blocklist.",
  label_content_policy_incidents_count: 'Incidents Count',
  placeholder_content_policy_incidents_count: 'Incidents Count',
  label_content_policy_passed_time: 'Passed Time',
  placeholder_content_policy_passed_time: 'Passed Time',
  patrol_categories_table_title: "{results_count, plural, =1 {{results_count} Classifier} other {{results_count} Classifiers}}",
  patrol_category_name: 'Classifier Name',
  patrol_category_type: 'Classifier Type',
  patrol_category_directionality: 'Directionality',
  patrol_category_action: 'Policy Action',
  patrol_category_risk: 'Risk Level',
  batch_edit_classifier_settings: 'Edit Classifier Settings',
  batch_edit_classifier_settings_apply_button: 'Apply Settings',
  batch_edit_classifier_settings_title: 'Edit Classifier Settings',
  content_policy_saved: "The content policy ''{content_policy}'' is saved successfully",
  content_policy_created: "The content policy ''{content_policy}'' is created successfully",
  content_policy_updated: "The content policy ''{content_policy}'' is updated successfully",
  global_audits_tab: 'Audit Logs',
  direction_outbound: 'Outbound',
  direction_inbound: 'Inbound',
  direction_bidirectional: 'Bidirectional',
  patrol_category_classifier_type: 'Classifier Type',
  type_link_categorization: 'Link Categorization',
  type_text_analysis: 'Text Analysis',
  type_image_analysis: 'Image Analysis',
  type_dlp_analysis: 'DLP Analysis',
  type_custom_analysis: 'Custom Analysis',
  type_attribute_analysis: 'Attribute Analysis',
  type_profile_analysis: 'Profile Analysis',
  type_workflow_analysis: 'Workflow Analysis',
  type_node_type_category: 'Node type Category',

  // Export Modal
  export_default_modal_title: 'Export to CSV',
  export_default_modal_description: 'The CSV file containing the requested exported data will be downloaded as soon as it has been created, which may take more than a minute. Please confirm that you want to proceed.',
  export_default_modal_confirm_button: 'Export to CSV',

  // Content classifier audit app
  review_auditor: "Auditor",
  classifier_audit_report_done_title: "Audit: ",
  classifier_audit_report: "Auditor",
  auditor_item_missing_classifications: "Missing Classifications",
  auditor_item_missing_classifications_helpertext: "Select classifiers that this item should have triggered.",
  classifier_audit_modal_classifier_selection_message: "Should not trigger any policies",
  auditor_add_note: "Add Note",
  auditor_incorrent_item_note_placeholder: "Add more information about why this item was incorrectly classified",

  // Connector configuration
  connector_configuration: "Connector Configuration",
  connector_type: "Connector Type",
  connector_status: "Connector Status",
  // Teams
  step_1: "Step 1: Download the certificate and upload it to your application as described in the <a target=\"_blank\" href='https://proofpointcommunities.force.com/community/s/article/Content-Capture-for-Teams'>installation guide.</a>",
  step_2: "Step 2: Enter the following information below and continue to redirect to the Microsoft authorization page.",
  certificate: "Certificate",
  application_id: "Application ID (required)",
  application_id_helper: "Enter application (client) ID",
  certificate_thumbprint: "Certificate Thumbprint (required)",
  certificate_thumbprint_helper: "This is located in your Azure Portal after uploading the certificate in Step 1.",
  app_id_required: "You must enter an application id.",
  certificate_thumbprint_required: "You must enter a certificate thumbprint.",
  download_certificate: "Download Certificate",
  connector_installed_MT: "Teams connector successfully authorized.",
  connector_installed_BB: "Bloomberg connector successfully authorized.",
  connector_install_error_MT: "An error occurred when trying to install Teams connector.",
  connector_install_error_BB: "An error occurred when trying to install Bloomberg connector.",
  // Bloomberg
  host_name_required: "Host Name (required)",
  enter_host_name: "Enter host name",
  port_required: "Port (required)",
  enter_port: "Enter port",
  username_required: "Username (required)",
  enter_username: "Enter username",
  choose_auth: "Choose Authentication Method",
  ssh: "SSH",
  password: "Password",
  ssh_private_key_required: "SSH Private Key (required)",
  passphrase_optional: "Passphrase (optional)",
  enter_passphrase: "Enter passphrase",
  confirm_passphrase: "Confirm Passphrase",
  confirm_passphrase_min: "Confirm passphrase",
  confirm_passphrase_helper: "This field is required if a value has been entered into the Passphrase field.",
  password_required: "Password (required)",
  enter_password: "Enter password",
  confirm_password_required: "Confirm Password (required)",
  confirm_password: "Confirm password",
  pgp_private_key_required: "PGP Private Key (required)",
  pgp_passphrase_required: "PGP Passphrase (required)",
  enter_pgp_passphrase: "Enter PGP passphrase",
  confirm_pgp_passphrase: "Confirm PGP Passphrase (required)",
  confirm_pgp_passphrase_min: "Confirm PGP passphrase",
  firm_numbers_required: "Firm Numbers (required)",
  account_numbers_required: "Account Numbers (required)",
  run_at_utc: "Run At (UTC)",
  hour: "Hour",
  minute: "Minute",
  required_field_error: "This is a required field. You must enter a value.",
  missing_firm_or_account: "Please set Firm Numbers or Account Numbers",
  select_one_or_more: "Select one or more",
  values_do_not_match: "Values do not match.",

  // Patrol proxy access policies app
  proxy_access_policy_title: "Access Policies",
  proxy_access_policy_subtitle: "Access Policy: ",
  create_new_policy: "Create New Policy",
  facebook_rules: "Facebook",
  rule_name: "Rule Name",
  rule_status: "Status",
  policy_name: "Policy Name",
  policy_description: "Policy Description",
  policy_users: "Accounts using Policy",
  last_updated: "Last Modified",
  create_policy_dialog_title: "Create New Access Policy",
  edit_policy_dialog_title: "Edit Access Policy",
  create_policy_dialog_create: "Create",
  create_policy_dialog_continue: "Continue",
  create_policy_dialog_edit: "Edit",
  policy_dialog_cancel: "Cancel",
  save_policy: "Save Changes",
  discard: "Discard Changes",
  recommended_action: "Recommended Action",
  rule_content_type: "Content Type",
  compliance_consideration: "Compliance Consideration",
  rule_classification: "Classification",
  allow_rule: "Allow",
  block_rule: "Block",
  policy_name_default: "Enter Policy Name",
  policy_description_default: "Enter Policy Description",
  delete_access_policy: "Delete Policy",
  disable_toolbar: "Disable Toolbar",
  enable_toolbar: "Enable Toolbar",
  add_link: "Add Link",
  delete_policy_warning: "Are you sure you want to delete this policy? This action CANNOT be undone.",
  delete_policy_confirmation: "Delete Policy Confirmation",
  policy_under_use: "This policy is being used by one or more accounts and cannot be deleted.",
  policy_defaults_error: "There are errors on the Policy Defaults tab.",
  export_accounts_list: "Export List of Accounts",
  no_accounts: "This policy has no accounts to list",

  incidents_list: "Content",
  submitted_by: "Submitted By",
  submitted_via: "Submitted Via",
  submitted_by_delegate: "Submitted By Delegate: {name}",
  author_name: "Author Name",
  breached_domain: "Breached Domain",
  affected_entity: "Affected Entity",
  applied_action: "Applied Action",
  recipient_name: "Recipient Name",
  reviewed_by: "Reviewed By",
  policy_violations: "Policy Matches",
  informational_classifications: "Informational Classifications",
  detected_at: "Detected At",
  crawled_on: "Crawled On",
  posted_at: "Source Date",
  submitted_at: "Submission Date",
  scheduled_for: "scheduled for",
  content_type: "Content Type",
  content: "Content",
  categories: "Categories",
  show_conversation: "Show Conversation",
  hide_conversation: "Hide Conversation",
  show_previous_messages: 'Show Previous Messages',
  hide_previous_messages: 'Hide Previous Messages',

  assign_to: "Assign To",
  assign_to_me: "Assign to Me",
  unassign: "Unassign",
  task_unassigned: "Unassigned",
  assign_task: "Assign Task",
  unassign_task: "Unassign Task",

  date_archived: "Date Archived",
  date_purged: "Purge Date",
  author_emails: "Author Email(s)",
  app_name: "Posted Via",
  incident_links: "Links",
  task_assignee: "Assignee",
  workflow_status: "Workflow Status",
  applied_actions: "Applied Action(s)",
  prescribed_actions: "Prescribed Action(s)",

  extracted: "Extracted",
  video_image: "Video Image",
  image: "Image",

  task_id: "Task ID",

  //auditor table
  classifier_audit_table_audit_name: 'Audit Name',
  classifier_audit_table_created_by: 'Created By',
  classifier_audit_table_date_created: 'Date Created',
  classifier_audit_table_sample_size: 'Sample Size',
  classifier_audit_table_status: 'Status',
  classifier_audit_table_null: 'Null',
  classifier_audit_table_completed: 'Completed',
  classifier_audit_table_in_progress: 'In Progress',
  classifier_audit_table_audit: 'Audit ',

  create_new_audit: "Create Audit",
  export_results_to_csv_action: "Export Results to CSV",
  export_results_to_pdf_action: "Export Results to PDF",
  cr_view_results: "View Results",
  continue_cr_action: "Continue Audit",
  rename_cr_title: "Rename Audit",
  remove_cr_action: "Delete Audit",
  transfer_audit_action: "Transfer Audit",
  auditor_confirm_transfer: "Confirm Transfer",

  //auditor form error messages
  review_audit_error_message_audit_title: "You must enter an audit name",
  review_audit_error_message_date_range: "You must select one date range period",
  review_audit_error_message_content_sources: "You must select at least one content source category",
  review_audit_error_message_item_scope: "You must select one item scope preference",
  review_audit_error_message_content_types: "You must select at least one activity review type",
  review_audit_error_message_author_type: "You must select at least one activity direction",
  review_audit_error_message_activity_type: "You must select at least one activity category",
  auditor_error_message_percentage: "Sample percentage must be greater than 0 and less than or equal to 100",
  auditor_error_message_sample_size: "Sample size must be greater than 0 and less than or equal to 5000",
  auditor_error_message_percent_or_sample_size: "Please select sample percentage or max sample size",
  review_audit_error_message_content_classifications: "You must select at least one classification",
  review_audit_error_message_staff_reviewed_members: "You must select at least one System User or Team",

  //auditor dialog options
  create_review_audit: "Create Audit",
  create_review_enter_name: "Enter Name",
  create_review_audit_name: "Audit Name (required)",
  create_review_audit_date_range: "Date Range (required)",
  create_review_audit_content_source: "Source (required)",
  create_review_audit_items_in_audit: "Items in Audit Scope (required)",
  create_review_audit_content_type: "Activity Review Type (required)",
  create_review_audit_activity_by: "Activity Direction (required)",
  auditor_sample_percent_or_size: "Select Sample Percentage or Max Sample Size",
  create_review_audit_tags: "Tags",
  create_review_audit_activity_type: "Activity Category (required)",
  create_review_audit_content_activity_scope: "Content Activity Scope (required)",
  auditor_sample_percentage: "Sample Percentage",
  auditor_sample_size: "Max Sample Size",
  auditor_sample_max_per_reviewer: "Max Number Of items Per Reviewer",
  create_review_audit_footer: "Enter the max number of items to be generated",
  create_review_audit_reviewer_footer: "Enter the max number of items per reviewer to be generated",
  create_review_audit_percent_footer: "You may enter decimal %, e.g. .001 and up to 100",
  create_review: "Create Audit",
  create_review_select_one: "Select One",
  create_review_select_one_or_more: "Select one or more",
  create_review_search: "Type in to search",
  auditor_mark_as_correct: "Mark as Correct",
  auditor_mark_as_incorrect: "Mark as Incorrect",

  classifier_audit_report_triggered_compliance_classifiers: "Triggered Compliance Classifiers",
  classifier_audit_report_did_not_trigger_compliance_classifiers: "Did Not Trigger Compliance Classifiers",
  classifier_audit_report_include_all_items: "All Items",
  classifier_audit_report_staff_reviewed_items: "Staff Reviewed Items",
  classifier_audit_report_system_approved_items: "System Approved Items",
  review_audit_content_classifications: "Triggered specific classifiers...",
  review_audit_select_classifiers: "Select classifiers",
  review_audit_select_teams: "Select teams",
  classifier_audit_report_brand: "Outbound Activity",
  classifier_audit_report_commenter: "Inbound Activity",
  classifier_audit_report_brand_last_month: "Last Month",
  classifier_audit_report_brand_last_quarter: "Last Quarter",
  classifier_audit_report_brand_last_year: "Last Year",
  classifier_audit_report_brand_all_time: "All Time",
  classifier_audit_summary_of_results: "This audit has been completed.",
  classifier_audit_detailed_results: "Detailed Results:",
  classifier_audit_summary: "{correct, total, percent, plural, =0 {{correct} out of {total} content item classifications marked as 'Correct.' The {total} content item sample has the following attributes: } other {{correct} out of {total} content item classifications marked as 'Correct': {percent}% classification accuracy. The {total} content item sample has the following attributes:} }",
  review_audit_type_comments: "Comments",
  review_audit_type_direct_messages: "Direct Messages",
  review_audit_type_posts: "Posts",
  review_audit_type_reactions: "Reactions",
  review_audit_all_activity_types: "(4) Comments, Direct Messages, Posts, Reactions",
  review_audit_content_type_submitted_content: "Submitted Content",
  review_audit_content_type_captured_content: "Captured Content",

  delete_classifier_review: "Delete Audit",
  remove_classifier_review_description: "Are you sure you want to delete this audit? This action cannot be undone.",
  classifier_review_removed_msg: "The classifier review has been removed successfully",
  classifier_review_csv_export_description: "This export includes a large number of audit items and may take over a minute to create the CSV file. Download will begin immediately after file creation.",
  creating_audit: "Creating Audit",
  close_creating_audit_dialog: "Close",
  auditor_items_generating: "Generating the sample of items based on your criteria. This process may take some time, so the system will send you an email when the audit is ready.",
  review_audit_error_message: "There was an error while trying to create your audit",
  rename_audit: "Rename Audit",
  audit_name_label: "Audit Name (required)",
  classifier_review_title_updated_msg: "The classifier review {title} title has been updated successfully",
  auditor_transfer_audit: "The audit has been successfully transferred to {user}",
  system_user_required: "Please select a system user",
  audit_system_users: "Auditor System Users",
  cr_item_could_not_load: "Item could not be loaded",
  cr_skip_to_next_item: "Skip to Next Item?",
  cr_loading: "Loading ...",
  audit_results_summary: "Audit Results Summary",
  audit_summary_correct: "Marked Correct",
  audit_summary_incorrect: "Marked Incorrect",
  audit_summary_audit_name: "Audit Name: ",
  audit_summary_conducted_by: "Conducted By: ",
  audit_summary_completed_on: "Completed On: ",
  audit_summary_total_reviewed: "Total number of items reviewed: ",
  audit_summary_total_correct: "Total number of items marked correct: ",
  audit_summary_total_incorrect: "Total number of items marked incorrect: ",
  audit_results_summary_chart: "{item_count, plural, =1 {{item_count} Reviewed Item} other {{item_count} Reviewed Items}}",
  audit_results_chart_subtitle: "{item_count, plural, =1 {Reviewed Item} other {Reviewed Items}}",
  audit_summary_view_audit_settings: "View Audit Settings",
  audit_summary_audit_settings: "Audit Settings",
  close_audit_summary_dialog: "Close",
  audit_summary_dialog_audit_name: "Audit Name (required)",
  audit_summary_dialog_date_range: "Date Range (required)",
  audit_summary_dialog_content_source: "Source (required)",
  audit_summary_dialog_policy_match: "Items in Audit Scope (required)",
  audit_summary_dialog_content_direction: "Activity Direction (required)",
  audit_summary_dialog_activity_type: "Activity Category (required)",
  audit_summary_dialog_tags: "Tags",
  audit_summary_no_tags_selected: "No tags selected",
  audit_summary_dialog_percentage: "Sample Percentage (required)",
  auditor_summary_dialog_max_sample_size: "Max Sample Size (required)",
  audit_summary_dialog_sample_size: "Number of Generated Items",
  audit_summary_dialog_size_note: "This is the number of content items included in this audit.",
  cr_completed_badge: "Completed",
  cr_wait_status: "Your sample size is being generated. Please try again later.",
  cr_summary_FB: "Facebook",
  cr_summary_TW: "Twitter",
  cr_summary_IG: "Instagram",
  cr_summary_YT: "YouTube",
  cr_summary_LI: "LinkedIn",
  cr_summary_brand: "Outbound Activity",
  cr_summary_commenter: "Inbound Activity",
  cr_summary_correct: "Correct",
  cr_summary_incorrect: "Incorrect",
  cr_summary_item: "Item ",

  // Items
  timestamp: "Timestamp",
  //actor: "Actor",
  action: "Action",
  activity_note: "Note",
  review_code: "Review Code",
  author: "Author",
  at: "at",
  by: "by",
  patrol_incidents_table: "Patrol > Content / Incidents",
  patrol_content_item: "Patrol > Content Item",
  item_type: "Type",
  actions: "Action(s) Taken",
  permalink: "Source Link",
  view_on: "View on",
  extracted_images: "Extracted Images",
  post_multimedia_details: "Post Multimedia Details",
  extracted_video_images: "Extracted Video Images",
  page_count: " Item {current_page} of {total_pages}",
  show_images: "Show Images",
  show_extracted_video_images: "Show {count} Extracted Video Images",
  hide_images: "Hide Images",
  video: "Video",
  extracted_article_content: "Extracted Article Content",
  item_identifier: "UUID",
  video_image_timestamp: "Video Image Timestamp",
  video_transcript: "Full Video Transcript",
  item_id_ghost: "Item Identifier",
  ocr_text: "Extracted OCR Text",
  image_description_label: "Image Description",
  no_preview_available: "No Preview Available",
  masked_images: "One or more images have been masked.",

  raw_content: "Raw Content",
  matching_credit_card_numbers: "Matching Credit Card Numbers",
  download_matching_credit_card_numbers: "Download Matching Credit Card Numbers",
  download_email_addresses: "Download Email Addresses",
  download_content: "Download Content",
  approve_item: "Approve Item",
  globally_approve_item: "Globally Approve Item",
  approve_and_forward_item: "Approve & Forward Item",
  reject_item: "Reject Item",
  reject_and_forward_item: "Reject & Forward Item",
  forward_item: "Forward Item",
  close_item: "Close Item",

  more_actions: "More Actions",

  supervisor: "Reviewer",

  task_type_Item: "Content Post Publish",
  task_type_SubmittedContentItem: "Content Pre Publish",
  task_type_ReviewProfileChange: "Profile Change",
  task_type_ReviewProfileFullPrereview: "Full Pre Review",
  task_type_ReviewProfileFullExpirationReview: "Full Expiration Review",
  task_type_ReviewProfileExpiration: "Profile Expired",
  task_type_ReviewProfilePostReview: "Post Review",
  task_type_ReviewProfilePrereview: "Pre Review",

  initial_reviewer: "Initial Reviewer",
  final_reviewer: "Final Reviewer",
  edit_notes: "Edit Notes for {object_name}",
  reviewer_notes: "Reviewer Notes",
  add_new_note: "Add New Note",
  add_note: "Add Note",
  edit_note: "Edit Note",
  remove_note: "Remove Note",
  remove_note_text: "Are you sure you want to remove this note?",
  note: "Note",
  notes: "Notes",
  reviewer_code: "Reviewer Code",
  new_reviewer_code: "Other Reviewer Code",
  reviewer: "Reviewer",
  reviewer_date: "Date",
  recipient: "Recipient",

  select_users_placeholder: "Select User(s)",
  select_teams_placeholder: "Select Team(s)",
  additional_emails: "Additional Emails",
  emails: "Emails",
  copy_account_owner: "Copy account owner(s)",
  account_owner_email_not_permitted: "The account owner email is using a domain that is not permitted.",

  warning: "Warning",
  reason_required: "Reason (required)",
  reason_error: "You must record a reason for this action (500 characters max).",
  reason_hint: "You must record a reason for this action (500 characters max).",
  warning_permanently_mask_content: "You are about to permanently mask this item's content. This action cannot be reversed.",

  additional_emails_placeholder: "Enter a list of emails separated by commas",
  share_subject_placeholder: "{username} Has Shared Digital Risk Content With You",

  reviewer_placeholder: "Select Reviewer",
  reviewer_required: "Please select a reviewer",
  reviewer_code_error: "Reviewer Code must not exceed 128 characters",
  review_code_placeholder: "Select review code",
  review_code_required_upon_rejection_placeholder: "Select or enter review code",
  review_code_required_upon_rejection_helpertext: "Select from a predefined list or type in your desired review code below.",
  review_code_non_creatable_placeholder: "Select your desired review code from a predefined list.",
  review_code_required_upon_rejection_error: "You must specify a review code or introduce one below.",
  must_use_pre_defined_review_codes_error: "You must specify a review code.",
  review_codes_disabled_tab_tooltip: "You must enable Review Codes to access this tab.",

  rejection_response: "Rejection Response",
  add_rejection_response: "Add Rejection Response",
  edit_rejection_response: "Edit Rejection Response",
  delete_rejection_response: "Delete Rejection Response",
  delete_rejection_response_dialog_title: "Delete Rejection Response",
  delete_rejection_response_dialog_body: "Are you sure you want to delete this Rejection Response?",
  delete_rejection_response_dialog_confirm: "Delete Rejection Response",
  response_text_required: "Response Text (required)",
  markdown_instructions: "Use <a href=''{link}'' target= \"_blank\">Markdown</a> to style the rejection text.",
  rejection_response_configured: 'Configured',
  edit_mode: 'Edit Response',
  preview_mode: 'Preview Response',

  items_action_title_APPROVE: "Approve Content",
  items_action_text_APPROVE: "Are you sure you want to approve this item?",
  items_action_confirm_APPROVE: "Approve Content",

  items_action_title_GLOBALLY_APPROVE: "Globally Approve Content",
  items_action_text_GLOBALLY_APPROVE: "Globally approving this content will approve the current task and all future tasks with matching content. Automated approval for matching content will continue indefinitely unless you specify an expiration date for this global approval.",
  items_action_confirm_GLOBALLY_APPROVE: "Globally Approve Content",

  items_action_title_APPROVE_AND_FORWARD: "Approve and Forward Content",
  items_action_text_APPROVE_AND_FORWARD: "Are you sure you want to approve this item?",
  items_action_confirm_APPROVE_AND_FORWARD: "Approve and Forward Content",

  items_action_title_MARK_REVIEWED: 'Mark Content Reviewed',
  items_action_text_MARK_REVIEWED: "Are you sure you want to mark this item reviewed?",
  items_action_confirm_MARK_REVIEWED: "Mark Content Reviewed",

  items_action_title_REJECT: "Reject Content",
  items_action_text_REJECT: "Are you sure you want to reject this content?",
  items_action_confirm_REJECT: "Reject Content",

  items_action_title_REJECT_AND_REMOVE: "Reject and Remove Content",
  items_action_text_REJECT_AND_REMOVE: "Are you sure you want to reject and remove this content?",
  items_action_confirm_REJECT_AND_REMOVE: "Reject and Remove Content",

  items_action_title_FORWARD: "Forward Content",
  items_action_text_FORWARD: "Please select the reviewer you would like to receive this task.",
  items_action_confirm_FORWARD: "Forward Content",

  items_action_title_PERMANENTLY_MASK_CONTENT: "Permanently Mask Content",
  items_action_text_PERMANENTLY_MASK_CONTENT: "WARNING: You are about to permanently mask this item's content. This action cannot be reversed.",
  items_action_confirm_PERMANENTLY_MASK_CONTENT: "Confirm",
  permanently_masked_content_text: "This item's content has been permanently masked. Please see the item's notes.",
  permanently_already_masked_content: "This item's content was already permanently masked",

  items_action_title_REJECT_AND_FORWARD: "Reject & Forward Content",
  items_action_text_REJECT_AND_FORWARD: "Please select the reviewer you would like to receive this task.",
  items_action_confirm_REJECT_AND_FORWARD: "Reject & Forward Content",

  items_action_title_CLOSE: "Close Task",
  items_action_text_CLOSE: "Are you sure you want to close this task?",
  items_action_confirm_CLOSE: "Close Task",

  review_tasks_user_is_viewing: "{user_name} is Currently Viewing",
  previous_versions_notes: "Previous Notes",

  risk_score_BADRISK: "High Risk",
  risk_score_RISK: "Risk",
  risk_score_LOWRISK: "Low Risk",
  risk_score_NOTABLE: "Notable",
  risk_score_NONE: "None",

  risk_level: "Risk Level",
  risk_level_low: "Low",
  risk_level_medium: "Medium",
  risk_level_high: "High",

  filter_title_task_type_filter: "Task Types",

  task_type_filter_APPROVAL: "Content",
  task_type_filter_PROFILE_LOCK_REVIEW: "Profiles",

  no_task_selected: "There is no content available to review.",
  unable_to_retrieve_task: "Unable to load information for this task.",

  no_incident_item_selected: "There is no patrol content available.",
  unable_to_retrieve_incident_item: "Unable to load information for this patrol content.",

  try_to_remediate: "Remove this content from the social network where it was posted (Remediate).",

  global_approval_expiration_date: "Global Approval Expiration Date",
  global_approval_expiration_date_placeholder: "Select expiration date",

  task_table_type: "Type",
  task_table_account: "Account",
  task_table_created_at: "Opened at",
  task_table_days_opened: "Days open",
  task_table_days_action: "Action",

  // Domains
  domain: "Domain",
  change_detected: "Change Detected",
  date_changed: "Date Changed",
  seed: "Seed",
  detections: "Detections",
  remaining_seeds: "All Other Seeds",

  detection_date: "Detection Date",
  tap_categories: "TAP Categories",
  remaining_classifications: "All Other Classifications",

  add_to_pps_block_list: "Add to PPS Block List",
  remove_from_pps_block_list: "Remove from PPS Block List",
  add_to_fraud_classifier: "Add to Patrol Watch/Block List",
  remove_from_fraud_classifier: "Remove from Patrol Watch/Block List",
  change_classification: "Change Classification",
  export_to_csv: 'Export to CSV',
  export_pps_block_list: 'Export PPS Block List',

  schedule_csv_export: 'Schedule CSV Export',
  title: 'Title',
  email_recipient: 'Email Recipient',
  schedule: 'Schedule',
  run: 'Run',
  start_on: 'Start on',
  every: 'Every',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
  week: 'Week',
  weeks: 'Weeks',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',

  enter_title: "Enter title",
  enter_email_address: "Enter email address",

  schedule_csv_export_created: 'The report has been created',

  report_title_missing_validation_message: "Report title is required.",
  schedule_week_missing_validation_message: "Weekly settings are required.",
  schedule_period_missing_validation_message: "Please select a period.",
  email_recipient_missing_validation_message: "Email recipient is required.",
  scheduled_email_validation_message: "Please enter a valid email. ''{rejected_email}'' is not allowed.",

  domains_action_title_change_classification: 'Change Classification',
  domains_action_title_view_takedown: 'View Takedown',
  domains_takedown_title_create: 'Report Takedown',
  domains_takedown_title_view: 'View Takedown',
  dialog_title_for: ' for {object_name}',

  //Change Classification
  domains_current_classifications: 'Current classifications:',
  domains_new_classification: 'New classification',
  domains_update_tags_upon_change: 'Update tags upon change',

  domain_ignored_message: "''{url}'' has been ignored.",
  domain_batch_ignored_message: "{batch_selected_counter, plural, =1 {The {batch_selected_counter} selected domain has been ignored.} other" +
    "{The {batch_selected_counter} selected domains have been ignored.}}",
  domain_batch_unignored_message: "{batch_selected_counter, plural, =1 {The {batch_selected_counter} selected domain has been unignored.} other" +
    "{The {batch_selected_counter} selected domains have been unignored.}}",
  domain_unignored_message: "''{url}'' has been unignored.",
  domain_added_to_pps_block_list: "''{url}'' has been added to PPS Block List.",
  domain_removed_from_pps_block_list: "''{url}'' has been removed from PPS Block List.",
  domain_added_to_fraud_classifier: "''{url}'' has been added to Patrol Watch/Block List.",
  domain_removed_from_fraud_classifier: "''{url}'' has been removed from Patrol Watch/Block List.",
  domain_classification_changed: "Classification changed from ''{from}'' to ''{to}''.",
  batch_domain_classification_changed: "Classification changed to ''{to}'' for the selected elements.",

  domain_select_classification_default: 'Select a classification...',

  domain_screenshot: "Domain Screenshot",

  //DOMAIN TAKEDOWNS
  takedown_send_email: "Send via Email",
  takedown_download_package: "Download Package",
  view_takedown: 'View Takedown',
  create_takedown: 'Report for Takedown',
  takedown_domain: 'Takedown Domain',
  contact_email_address: 'Contact Email Address',
  destination: 'Destination',
  reason: 'Reason',
  domain_seeds: 'Domain Seed',
  affected_domain: 'Affected Domain',
  keyword: "Keyword",
  note_for_vendor: "Notes for Destination",
  internal_note: "Internal Notes",
  add_internal_note: "Add Internal Notes",
  add_note_for_vendor: "Add Notes for Destination",
  request_id: "Request ID",
  date_remediated: "Date Remediated",
  //date_submitted: "Date Submitted",
  takedown_status: "Case Status",
  resolution_status: "Resolution Status",
  assigned_analyst: "Assigned Analyst",
  destination_notes: "Destination Notes",
  takedown_completed_date: "Completed Date",
  upload_evidence: "Upload Evidence",
  uploaded_evidence: "Uploaded Evidence",
  evidence_footer_1: "Max upload: 20 files (10 MB total)",
  evidence_footer_2: "Supported filetypes: .bmp, .png, .jpg, .eml, .txt",
  submit_takedown_message: "Takedown has been submitted successfully",
  close_takedown_message: "Takedown has been closed successfully",
  close_takedown_reason: "Resolution",
  close_takedown_reason_success: "Blocklist Successful",
  close_takedown_reason_unsuccess: "Takedown Rejected",
  close_takedown_reason_other: "Other",
  close_takedown: "Close Takedown",
  proofpoint_takedown_redirection_message: "To submit this domain to the Proofpoint Takedown team, please click the link below to be redirected to the Takedown Portal. The new advanced portal has improved visibility, request tracking and communication with our Takedown team to help you throughout the takedown process: <br/> <a target='_blank' href=''{takedown_site}?site={domain}''>{takedown_site}</a>",
  download_package: "Download Package",
  download_email_file: "Download Email File",
  download_file_body_message: "Please click below to download your file",
  need_more_info: 'Need More Info?',
  add_files: "Add Files",
  error_evidence_files_message: "Evidence files must be successfully uploaded before submitting the Takedown",
  error_long_notes_for_vendor_message: "The note is over the 1,500 limit. Longer notes may be uploaded as evidence.",
  error_long_internal_notes_message: "The note is over the 1,500 limit. Please enter a shorter note and try again.",

  generic_error: "There was an error while trying to perform the operation. Please refresh the page and try again. If the problem persist contact an administrator.",
  submit_takedown_error_message: "There was an error while trying to submit the Takedown",
  close_takedown_error_message: "There was an error while trying to submit the Takedown",
  vendor_missing_validation_message: "Please select a destination option for the takedown",
  reason_missing_validation_message: "Please provide a reason for the takedown",
  resolution_missing_validation_message: "Please provide a resolution for closing the takedown",
  seed_required_validation_message: "Domain Seed is required",
  seed_format_validation_message: "Please enter a valid seed (e.g.): example.com",
  contact_email_address_required_validation_message: "Contact Email Address is required",
  add_notes_for_vendor_required_validation_message: "Add Notes for Destination is required",


  filter_title_classifications: "Classifications",
  select_classifications: "Select Classification",

  filter_title_policy_actions: "Policy Actions",
  select_policy_actions: "Select Policy Action",

  copy_link_to_clipboard: 'Copy Link to Clipboard',

  pod_filters_options: "Pod Filters Options",

  select_all_options: "Select All",

  accounts_summary: "Accounts Summary",
  active_accounts: "Active Accounts",
  inactive_accounts: "Expired Accounts",

  profiles_summary: "Profiles Summary",
  onboarding_profiles: "Onboarding",
  expired_profiles: "Expired",
  incremental_profiles: "Incremental",
  pending_reviews: "Pending Reviews",
  top_changed_fields: "Top Changed Fields",
  profiles_column_platform: "Platform",
  profiles_column_field: "Field",
  profiles_column_count: "Count (% of Total)",
  profiles_column_rejected: "Rejected",
  profiles_column_approved: "Approved",
  activity_30: "Activity over last 30 days",

  content_summary: "Content Summary",
  pre_published_review: "Pre Publish Review",
  post_published_review: "Post Publish Review",
  unreviewed: "Unreviewed",
  reviewed: "Reviewed",
  approved: "Approved",
  rejected: "Rejected",
  top_rejection_categories: "Top Rejection Categories",
  rejection_category: "Rejection Category",
  select_patrol_policies: "Content Policies",
  select_node_content_types: "Node Content Types",
  select_profile_policies: "Profile Policies",

  program_manager: "Program Manager",

  not_allowed_pod: "Not available for links shared outside your client.",

  //DOMAIN ALERTS
  alert_name: 'Alert Name',
  alert_type: 'Alert Type',
  date_created: 'Date Created',
  date_last_modified: 'Date Last Modified',
  notifications: 'Notifications',

  create_new_alert: 'Create New Alert',

  alert_type_state_change: 'State Change',
  alert_type_new_registration: 'New Detection',
  alert_type_new_detection: 'Classification Change',
  alert_type_tag_change: 'Tag Change',
  alert_type_matches_view: 'Matches View',
  alert_type_expiration: 'Expiration',

  create_alert: 'Create New Alert',

  remove_domain_alert_dialog_title: "Delete Domain Alert",
  remove_domain_alert_dialog_text: "Are you sure you wish to delete the domain alert: ''{name}''? This action cannot be undone.",
  domain_alert_removed_message: "''{name}'' has been deleted.",

  domain_alert_action_remove: 'Delete',

  domain_alert_details_title: 'Domain Alert Details',
  domain_alert_create_title: 'Create New Alert',

  domain_alert_name: 'Alert Name (required)',
  domain_alert_frequency: 'Frequency',
  domain_alert_rules_title: 'Alert Rules (at least one required)',
  domain_alert_events_title: 'Events (at least one required)',
  domain_alert_tag_changes: 'Alert Tag Changes (at least one required)',
  domain_alert_reminders_title: 'Reminder Frequency (required)',
  domain_alert_notifications_title: 'Send notifications to these people/teams (at least one required)',

  domain_alert_add_rule: 'Add Alert Rule',
  domain_alert_add_reminder: 'Add Reminder (required)',
  create_at_least_one_rule: 'You must create at least one rule for this alert',
  create_at_least_one_reminder: 'You must create at least one reminder for this alert',
  select_at_least_one_event: 'You must select at least one event for this alert',
  select_at_least_one_tag_change: 'You must choose at least one tag change',
  domain_alert_rule_already_exists_text: 'The rule already exists for this configuration',

  select_alert_frequency: 'Select Alert Frequency',
  saved_view: 'Saved View (required)',
  select_a_saved_view: 'You must select a saved view',
  domain_alert_associated_tag: 'Filter Tag(s) (required)',
  select_an_associated_tag: 'You must select at least one fiter tag',
  filter_tags: 'Filter Tag(s)',
  domain_alert_select_tags: 'Select Tag(s)',
  domain_alert_tags_added: 'Tag(s) Added',
  domain_alert_tags_removed: 'Tag(s) Removed',

  domain_state: 'State',
  domain_from_state: 'From State (required)',
  domain_to_state: 'To State (required)',
  domain_classification: 'Classification (required)',
  domain_state_change: 'State Change (required)',
  select_domain_classification: "You must select a classification",
  domain_alert_state: "Domain State",
  domain_alert_mx_record_added: 'MX record added',
  domain_alert_ssl_installed: 'SSL installed',
  domain_alert_email_activity_detected: 'Email activity detected',
  domain_alert_ssl_expiry: 'SSL certificate expiration',
  domain_alert_domain_expiry: 'Registration expiration',
  select_from_dropdown: 'Select from dropdown',

  field_must_be_selected: "'{field}' must be selected",
  domain_alert_equal_states: 'From State and To State cannot be equal',
  domain_alert_state_change: 'You Must Select a State Change',
  domain_alert_provide_a_name: 'You must provide a name for this alert',
  domain_alert_invalid_name: 'The Alert Name only allows alphanumeric characters, spaces and parenthesis',

  alert: 'Alert',

  domain_alert_saved_message: "Alert ''{name}'' has been saved.",

  //NOTIFICATIONS
  notification_users: 'User(s)',
  notification_teams: 'Team(s)',
  notification_additional_emails: 'Additional Emails',
  notification_input_required_message: 'Please ensure you have entered at least one user, team or email address',
  notification_email_validation_message: 'Please ensure you have entered correctly formatted email addresses, separated by commas',

  //Share Content
  selected_users: 'Selected User(s)',
  selected_teams: 'Selected Team(s)',

  //ROVER
  rover: 'Rover',
  rover_projects: 'Rover Projects',
  rover_settings: 'Rover Settings',
  rover_project_tabs: 'UNUSED',

  //SYNDICATE
  syndicate: 'Syndicate',
  syndicate_content: 'Content',
  syndicate_config: 'Configuration',
  syndicate_users: 'Manage Users',
  syndicate_feeds: 'Content Feeds',

  //TASKS
  user_tasks: 'Tasks',

  //LEGAL FOOTER
  legal_footer: 'Legal Footer',

  syndicate_post: "Curator Submission",

  support: 'Support',
  support_portal: 'DR Support Portal',

  //DOMAIN DETAILS
  domain_discover_details: "Domain Discover Details",
  domain_details_title: "Domain Details: ",

  web_presence: "Web Presence",
  ip_addresses: "IP Addresses & Other Domains",
  detection_metadata: "Detection Metadata",

  final_redirected_ip_address: "Final Redirected IP Address",
  http_status_code: "HTTP Status Code",
  https_status_code: "HTTPS Status Code",
  web_title: "Web Title",
  favicon: "Favicon",
  tranco_score: "TRANCO Score",
  screenshots: "Screenshots",
  ip_address: "IP Address",
  domain_count: "Domain Count",
  domain_list: "Domains",
  domain_tags: "Tags",

  hunt_name: "Hunt Name",
  classifications: "Classifications",
  first_detected: "First Detected",
  last_detected: "Last Detected",
  contains_homoglyph: "Has Homoglyph",
  not_available: "N/A",

  ssl_certificate_information: "SSL Certificate Information",
  subject: "Subject",
  issuer: "Issuer",
  dns_names: "DNS Names",
  subject_alt_name_dns: "Subject Alt. Name DNS",
  version: "Version",
  serial_number: "Serial Number",
  ocsp: "OCSP",
  issuing_certificate_url: "Issuing Certificate URL",
  ca_issuers: "CA Issuers",
  crl_distribution_points: "CRL Distribution Points",
  subject_key_id: "Subject Key ID",
  authority_key_id: "Authority Key ID",
  not_valid_before: "Not Valid Before",
  not_valid_after: "Not Valid After",
  country_name: "Country Name",
  state_or_province_name: "State or Province Name",
  locality_name: "Locality Name",
  organization_name: "Organization Name",
  organizational_unit: "Organizational Unit",
  common_name: "Common Name",

  domain_notes: "Domain Notes",

  domain_whois_record: "Domain WHOIS Record",

  registrar_name: "Registrar Name",
  registrar_ianaid: "Registrar IANAID",
  contact_email: "Contact Email",
  whois_server: "WHOIS Server",
  nameservers: "Nameservers",
  created_date: "Created Date",
  updated_date: "Updated Date",
  expires_date: "Expires Date",
  registrant_email: "Registrant Email",
  registrant_name: "Registrant Name",
  registrant_organization: "Registrant Organization",
  registrant_street: "Registrant Street",
  registrant_city: "Registrant City",
  registrant_state: "Registrant State",
  registrant_country: "Registrant Country",
  administrative_contact_email: "Administrative Contact Email",
  administrative_contact_name: "Administrative Contact Name",
  administrative_contact_organization: "Administrative Contact Organization",
  administrative_contact_street: "Administrative Contact Street",
  administrative_contact_state: "Administrative Contact State",
  administrative_contact_city: "Administrative Contact City",
  administrative_contact_country: "Country",

  asn_information: "ASN",
  asn: "ASN",
  network: "Network",
  owner: "Owner",

  dns_information: "DNS Information",
  ipv4_addresses: 'IPV4 Addresses',
  //mx_record: 'MX Record',
  soa_record: 'SOA Record',
  spf_record: 'SPF Record',
  txt_record: 'TXT Record',

  email_telemetry: "Email Telemetry",
  count: "Count",

  tap_detections: "TAP Detections",

  domain_discover_title: "Domain Discover",

  //COMMON - Actions
  actions_title: 'Actions',
  ignore: 'Ignore',
  unignore: 'Unignore',
  create: 'Create',
  edit: 'Edit',

  domain_name: "Domain Name",
  registrar: "Registrar",
  seeds_formatted: "Seeds",
  country: "Country",
  mx_record: "MX Record",
  name_servers_formatted: "Name Servers",
  tap_integration: "Has TAP",
  state_formatted: "State",
  web_state_formatted: "HTTP Status Code",
  date_submitted: "Date Submitted",
  ssl_expiry: "HTTPS",
  domain_expiry: "Expires on",
  registered_date: "Registered Date",
  oldest_tag_added_on: "Oldest Tag added on",
  newest_tag_added_on: "Latest Tag added on",
  first_detect_date: "Detected Date",
  has_telemetry: "Has Telemetry",
  special_attributes: "Special Attributes",
  registrant_email_address: "Registrant Email",
  display_only: "Display Only",
  channels: "Channels",
  ignored_on: "Ignored On",
  ignored_by: "Ignored By",

  domain_special_attributes_is_watched_tooltip: "Watched Domain",
  domain_special_attributes_is_blocked_tooltip: "Added to PPS Block List",
  domain_special_attributes_brand_fraud_tooltip: "Added to Patrol Watch/Block List",
  ignored_domain_table_unignore_action: "Unignore Domain",

  yes: "Yes",
  no: "No",

  minutes: 'minutes',
  hours: 'hours',
  days: 'days',

  filters_including: 'Including',
  filters_excluding: 'Excluding',
  filters_starts_with: 'Must begin with the term',
  filters_ends_with: 'Must end with the term',
  filters_only_mx: 'Entries with MX records ',
  filters_only_idn: 'IDN detections ',
  filters_only_watched: 'Manually entered watched domains',
  filters_only_ssl: 'HTTPS Detections ',
  filters_only_image: 'Entries with brand logos detected',
  filters_only_tap: 'Detections with TAP Details',
  filters_only_with_title: 'Detections with title',
  filters_only_under_construction: 'Ignore under construction and holding pages',
  filters_current_title_filter: 'Including in Title',
  filters_current_title_filter_exclude: 'Excluding in Title',

  blank_filter_option: '(Blanks)',

  panel_columns: 'Columns',
  panel_filters: 'Filters',
  panel_charts: 'Charts',

  domain_charts: 'Charts',
  domain_detections_by_classification: 'Detections by Classification',
  domain_detections_by_tag_name: 'Detections by Tag Name',

  domain_action_selected: "{batch_selected_counter} Selected",
  domain_action_detection: "{results_count, plural, =1 {{results_count} Detection} other " +
    "{{results_count} Detections}}",
  domain_action_ignore: 'Ignore',
  domain_action_report_for_takedown: 'Report for Takedown',
  domain_action_add_to_pps_block_list: 'Add to PPS Block List',
  domain_action_remove_from_pps_block_list: 'Remove from PPS Block List',
  domain_action_add_to_domain_fraud: 'Add to Patrol Watch/Block List',
  domain_action_remove_from_to_domain_fraud: 'Remove from Patrol Watch/Block List',
  domain_action_edit_notes: 'Edit Notes',
  domain_action_batch_add_notes: "{batch_selected_counter, plural, =1 {Add Notes for {batch_selected_counter} Detection} other " +
    "{Add Notes for {batch_selected_counter} Detections}}",
  domain_action_change_classification: 'Change Classification',
  domain_action_expiration_alerts: 'Expiration Alerts',
  domain_action_edit_tags: "Edit Tags",
  domain_action_unwatch_domain: 'Unwatch Domain',

  ignore_domain_dialog_title: "Ignore Domain",
  ignore_domain_dialog_text: "Are you sure you wish to ignore the domain: ''{url}''?",
  ignore_takedown_domain_dialog_text: "This operation will close the associated pending Takedown.",

  ignore_batch_domain_dialog_title: "Ignore Domains",
  ignore_batch_domain_dialog_text: "{batch_selected_counter, plural, =1 {Are you sure you wish to ignore this domain? Any pending takedowns associated with these domains will be closed.} other" +
    "{Are you sure you wish to ignore these {batch_selected_counter} domains? Any pending takedowns associated with these domains will be closed.}}",
  ignore_domains_modal: "Ignore Domains",
  ignore_selected_domains_modal: "{batch_selected_counter, plural, =1 {Ignore {batch_selected_counter} Domain} other" +
    "{Ignore {batch_selected_counter} Domains}}",
  add_ignored_domains_title: "Add Ignored Domains",
  add_domains_to_ignore: "Add Domains to Ignore",
  add_ignore_list_placeholder: "Enter one domain per line",
  add_ignored_classification: "Select Classification (optional):",
  add_ignored_classification_placeholder: "Select Classification",
  add_ignored_tags: "Select one or more tags to apply (optional):",
  add_ignored_tags_placeholder: "Select Tags",
  add_ignored_results_modal_title: "Add Ignored Domains - Summary",

  ignored_validation_empty: "Please enter at least one domain to look up",
  ignored_and_watched_validation_invalid: "Please enter a valid domain (e.g.: 'example.com')",

  ignored_and_watched_msg_invalid: "The domain cannot be parsed or is invalid.",
  ignored_msg_duplicated: "The domain was previously ignored.",
  ignored_msg_is_not_domain: "URLs or subdomains cannot be added.",
  ignored_msg_error_saving: "There was a problem saving the domain. Please try again later.",
  ignored_msg_success: "Domain ignored successfully.",

  unignore_domain_dialog_title: "Unignore Domain",
  unignore_domain_dialog_text: "Are you sure you wish to unignore the domain: ''{url}''?",
  unignore_takedown_domain_dialog_text: "This operation will close the associated pending Takedown.",
  unignore_batch_domain_dialog_title: "Unignore Domains",
  unignore_batch_domain_dialog_text: "Are you sure you wish to unignore the selected domains? Any pending takedowns associated with these domains will be closed.",

  change_classification_dialog_title: "Change Classification",
  batch_change_classification_dialog_title: "{batch_selected_counter, plural, =1 {Change Classification for {batch_selected_counter} Detection} other" +
    "{Change Classification for {batch_selected_counter} Detections}}",
  tag_edition_dialog_title: "Edit Tags for {object_name}",
  batch_tag_edition_dialog_title: "{batch_selected_counter, plural, =1 {Edit Tags for {batch_selected_counter} Detection} other" +
    "{Edit Tags for {batch_selected_counter} Detections}}",
  batch_remove_tag_edition_dialog_title: "Batch Remove Tags",
  error_tags_required: "At least one tag is needed for this operation",
  tags_saved_message: "Tags saved successfully for: ''{object_name}''",
  batch_tags_added_message: "Tags edited successfully for the selected elements",
  batch_tags_removed_message: "Tags removed successfully from the selected elements",
  remove_tags_instead_of_append: "Remove all selected tags from elements instead of adding them",

  note_toast_add: "Note added successfully to: ''{object_name}''",
  note_toast_add_batch: "Note added successfully to the selected elements",
  note_toast_edit: "Note updated successfully for: ''{object_name}''",
  note_toast_remove: "Note removed successfully from: ''{object_name}''",
  add_batch_note: "{batch_selected_counter, plural, =1 {Add Notes for {batch_selected_counter} Detection} other " +
    "{Add Notes for {batch_selected_counter} Detections}}",
  add_batch_action: "Add",
  error_empty_note: "The contents of the note can not be empty",
  error_empty_emails: "Emails can not be empty",

  detections_csv_export_description: "This export includes a large number of detections and may take over a minute to create the CSV file. Download will begin immediately after file creation.",
  pps_block_list_csv_export_description: "Download will begin immediately after file creation.",
  schedule_csv_export_description: "This export includes a large number of detections and may take over a minute to create the CSV file. Download will begin immediately after file creation.",
  ignored_domains_csv_export_description: "This export includes a large number of detections and may take over a minute to create the CSV file. Download will begin immediately after file creation. Please note this export is limited to 50,000 ignored domains.",

  add_watched_dialog_title: "Add Watched Domains",
  add_watched_summary_dialog_title: "Add Watched Domains - Summary",
  add_watched_list: "Add Domains To Watch",
  add_watched_list_placeholder: "Enter one Domain per line",
  add_watched_classification: "Select Classification (optional):",
  add_watched_classification_placeholder: "Select Classification",
  add_watched_tags: "Select one or more tags to apply (optional):",

  watched_validation_empty: "Please enter at least one domain to look up",

  watched_msg_duplicated: "The domain already exists.",
  watched_msg_is_not_domain: "URLs or subdomains cannot be added.",
  watched_msg_error_saving: "There was a problem saving the domain. Please try again later.",
  watched_msg_success: "Domain added successfully.",
  watched_readded_msg_success: "Domain readded successfully.",

  dts_service_error: "There has been an internal error. Please try again later.",

  views_options: "View Options",
  views_create_new: "Create New View",
  views_set_default: "Set as Default View",
  views_save_changes: "Save Changes to this View",
  views_delete_view: "Delete This View",
  views_share_view: "Share This View",

  create_view_title: "Create New View",
  edit_view_title: "Save Changes to this View",
  edit_view_name_placeholder: "Enter name for this view",
  edit_view_share: "Share view with all account users (required for use with alerts).",
  edit_view_share_alt: "Share view with all account users.",
  create_view_button: "Create View",
  update_view_description: "Are you sure you want to update this view with the current filters? You can change the name and share settings in the process",
  update_view_description_no_share: "Are you sure you want to update this view with the current filters? You can change the name in the process",
  update_view_button: "Save Changes",
  view_name: "View Name",
  view_created: "Successfully created view: ''{view_name}''",
  view_saved: "Changes saved for view: ''{view_name}''",
  domain_alert_dependency: "This view is used by one or more alerts and has to remain shared with all users unless the alerts are removed",
  view_name_empty: "Please specify a name for the Filter View",
  default_view_saved: "Default preferences saved for the current view.",
  delete_view_title: "Delete Current View",
  delete_view_description: "Are you sure you want to delete this view? This action cannot be undone.",
  delete_view_button: "Delete",
  view_deleted: "The selected view has been deleted",
  view_deleted_with_name: "The Filter View ''{view_name}'' has been deleted",
  share_view_title: "Share this View",
  share_view_button: "Share View",
  filter_view_shared: "The shared preferences have been shared successfully",
  clear_filters: "Clear all Filters",

  saved_views: "Saved Views",
  default_views: "Predefined Views",
  custom_views: "Custom Views",
  shared_views: "Shared Views",

  domain_channels_web_tooltip: "Web",
  domain_channels_email_tooltip: "Email",
  domain_channels_social_tooltip: "Social",

  domains_tab_home: "Home",
  domains_tab_alerts: "Alerts",
  domains_tab_seeds: "Seeds",
  domains_tab_ignored: "Ignored Domains",

  batch_selected_line_1: "You have selected {selected_number} element/s to apply this operation.",
  batch_selected_line_2: "Keep in mind that the maximun number of elements for which the actions can be applied is {max_number}. If you wish to proceed only the first {max_number} will have the selected action applied.",

  batch_disabled_tooltip: "You can only perform this action for {max_number} rows at a time.",
  batch_unselected_tooltip: "You need to select at least one row to perform this action.",

  batch_ignore: "Ignore",
  batch_add_note: "Add Note",
  batch_change_classification: "Change Classification",
  batch_add_tags: "Edit Tags",
  batch_unignore: "Unignore",

  batch_tags_label: "Add Tags",
  tags_label: "Tags",
  remove_tags_label: "Remove Tags",

  pivot_registrant_email_tooltip: "See domains registered under this email in a new tab.",
  pivot_registrant_email_title: "Domains with Registrant Email: ",

  created_at: "Created at",
  updated_at: "Updated at",
  expires_at: "Expires at",
  task_updated_at: 'Updated Task at {date}',

  rows_per_page: "Rows per page",
  of: "of",
  task_per_page: "Task Per Page",
  rows_in_page: "{from} - {to} of {total}",
  link_to_proofpoint_privacy_policy: "Link to Proofpoint Privacy Policy",
  link_to_proofpoint_terms_of_service: "Link to Proofpoint Terms of Service",

  search_domains: "Search Domains",
  search_ignored_domains: "Search Ignored Domains",

  domain_seed: "Seed",
  active: "Active",
  inactive: "Inactive",
  removal_in_progress: "(removal in progress)",
  added_on: "Added on",

  add_seeds_title: "Add Seed",
  add_seeds_action_button: "Add Seeds",
  add_domains_tld_instructions: "For a given parent domain it is not necessary to enter every TLD variation e.g. domain.com, domain.co.uk, domain.de.",
  activate_seed: "Activate seed",
  remaining_licenses: "{remaining_licenses} full domain seeds remaining",
  seed_licensing_tooltip: 'Full domain seeds detect new and historical domains.',
  remaining_limited_licenses: "{remaining_licenses} limited domain seeds remaining",
  seed_limited_licensing_tooltip: 'Limited domain seeds only detect new domains.',
  seed_placeholder: "Enter Domain",
  empty_seed: "The Domain can not be empty.",

  seed_created: "''{seed}'' has been added successfully. After activation please allow up to 24 hours for results to populate.",
  seed_created_activation_private: "The seed has been added successfully, please enter the required information to continue with the activation process",
  create_seed_error_1: "The service is down. Please try again later.",
  create_seed_error_2: "The domain cannot be parsed or is malformed.",
  create_seed_error_3: "The domain (or a variant with a different TLD) already exists on the server.",
  create_seed_error_4: "The domain has been added successfully.",
  create_seed_error_5: "The domain has been added successfully.",
  create_seed_error_6: "The domain is too short. Please contact a Sales Representative.",
  create_seed_error_7: "The domain already exists on the service.",
  create_seed_error_8: "The seed has been added but there we not enough licenses to perform the activation",

  edit_seed_dialog_title: "Edit Seed Configuration",
  edit_seed_dialog_description: "Please provide any details from WHOIS registrations that clearly identify domains owned by your organization. We cannot identify brand owned domains for privately registered domains without this information.",
  infrastructure: "Infrastructure",
  seed_config_field_companies: "Registrant Name",
  seed_config_field_companies_ph: "Enter name or organization",
  seed_config_field_emails: "Registrant or Administrative Email Address",
  seed_config_field_emails_ph: "e.g. user@example.com or @example.com",
  seed_config_field_ips: "IP Address or IP Address Range",
  seed_config_field_ips_ph: "e.g. 192.168.1.1 or 192.168.2.1-192.168.2.254",
  seed_config_field_asns: "ASN",
  seed_config_field_asns_ph: "e.g. 7224",
  add_entry: "Add Entry",
  private_seed: "This domain is privately registered. Please provide as much of the information below as possible. Without it, we cannot identify Brand Owned domains. ",

  edit_seed_action: "Edit",
  remove_seed_action: "Remove",
  activate_seed_action: "Activate",
  deactivate_seed_action: "Deactivate",

  invalid_seed_config_field: "One or more fields are invalid.",
  seed_saved_and_activated_msg: "The seed ''{url}'' has been activated and the configuration values have been saved",
  seed_saved_but_not_activated_msg: "The seed ''{url}'' values have been saved but the Seed was not activated for lack of licenses",
  seed_saved_msg: "The configuration values for seed ''{url}'' have been saved.",
  seed_activated_msg: "The seed ''{url}'' has been activated",
  seed_deactivated_msg: "The seed ''{url}'' has been deactivated",
  seed_license_error_msg: "You don't have enough licenses to perform this action",

  remove_seed_dialog_title: "Remove Protected Domain",
  remove_seed_description: "Are you sure you want to remove this protected domain? By removing it you will no longer be able to detect new infringing domains for this seed.",
  remove_associated_domains: "Do you want to ignore results for this seed also? All pending Takedowns associated to the seed will be closed. ",
  seed_removed_msg: "The seed ''{url}'' has been removed successfully",
  batch_seed_removed_msg: "{batch_selected_counter, plural, =1 {The seed has been removed successfully} other" +
    "{{batch_selected_counter} seeds have been removed successfully}}",
  batch_seed_removed_successes: "{successes, plural, =1 {{successes} seed has been removed successfully.} other {{successes} seeds have been removed successfully.}}",
  batch_seed_removed_failures:  "{failures,  plural, =1 {{failures} seed failed to be removed.}  other {{failures} seeds failed to be removed.}}",

  batch_remove_seed_dialog_title: "{batch_selected_counter, plural, =1 {Remove {batch_selected_counter} Protected Domain} other {Remove {batch_selected_counter} Protected Domains}}",
  batch_remove_seed_description: "{batch_selected_counter, plural, =1 {Are you sure you want to remove this protected domain? By removing it you will no longer be able to detect new infringing domains for this seed.} other {Are you sure you want to remove these {batch_selected_counter} protected domains? By removing them you will no longer be able to detect new infringing domains for these seeds.}}",
  batch_remove_associated_domains: "{batch_selected_counter, plural, =1 {Do you want to ignore results for this seed also? All pending Takedowns associated with it will be closed.} other {Do you want to ignore results for these {batch_selected_counter} seeds also? All pending Takedowns associated with them will be closed.}}",

  batch_remove: "Remove",
  batch_activate: "Activate",
  batch_deactivate: "Deactivate",

  batch_activate_seed_dialog_title: "{batch_selected_counter, plural, =1 {Activate {batch_selected_counter} Seed} other {Activate {batch_selected_counter} Seeds}}",
  batch_activate_seed_description: "{batch_selected_counter, plural, =1 {Are you sure you wish to activate this seed?} other {Are you sure you wish to activate these {batch_selected_counter} seeds?}}",
  batch_seed_activated_msg: "{batch_selected_counter, plural, =1 {{batch_selected_counter} selected seed has been activated successfully} other {{batch_selected_counter} selected seeds have been activated successfully}}",
  batch_seed_activation_successes: "{successes, plural, =1 {{successes} seed has been activated successfully.} other {{successes} seeds have been activated successfully.}}",
  batch_seed_activation_failures:  "{failures,  plural, =1 {{failures} seed failed to be activated.}  other {{failures} seeds failed to be activated.}}",
  batch_deactivate_seed_dialog_title: "{batch_selected_counter, plural, =1 {Deactivate {batch_selected_counter} Seed} other {Deactivate {batch_selected_counter} Seeds}}",
  batch_deactivate_seed_description: "{batch_selected_counter, plural, =1 {Are you sure you wish to deactivate this seed?} other {Are you sure you wish to deactivate these {batch_selected_counter} seeds?}}",
  batch_seed_deactivated_msg: "{batch_selected_counter, plural, =1 {{batch_selected_counter} selected seed has been deactivated successfully} other {{batch_selected_counter} selected seeds have been deactivated successfully}}",
  batch_seed_deactivated_successes:"{successes, plural, =1 {{successes} seed has been deactivated successfully.} other {{successes} seeds have been deactivated successfully.}}",
  batch_seed_deactivated_failures: "{failures,  plural, =1 {{failures} seed failed to be deactivated.}  other {{failures} seeds failed to be deactivated.}}",

  tag_manager: "Manage Tags",
  search_only_unused: "Show only unused",
  search_only_removable: "Show only deletable",
  enter_search_term: "Enter search term",
  tag_deleted: "The selected tag has been deleted",

  immediate_parent_tags: "Immediate Parent Tags",
  immediate_child_tags: "Immediate Child Tags",
  tags_accounts: "Accounts",
  tags_mobile_apps: "Mobile Apps",
  tags_domains: "Domains",

  none: "None",
  none_selected: "None selected",

  tag_subscriptions: "Tag Subscriptions",
  tag_subscriptions_subtitle: "Email the selected users or teams when a domain has this tag applied",
  tag_hierarchy: "Tag Hierarchy",
  save_changes: "Save Changes",
  invalid_alert_recipients: "Some of the destinations for the alerts are invalid. Please fix them to be able to proceed",
  tag_notifications_changes_saved: "Tags changes saved.",
  tag_notifications_changes_saved_partially: "Tags changes saved. The following Tags presented circular dependencies on the hierarchy so they were partially saved: _1_",

  undo: "Undo",

  tag_cell_tooltip: "Edit tags",

  filter_or_placeholder: "Enter one or more values, separated by comma",
  filter_space_terms: "Enter one or more values, separated by space",
  filter_quotes: "Use double quotes to match values exactly",
  filter_ip_help: "Single address, address ranges, and wildcards supported.",
  filter_ip_help_2: "e.g. 192.168.1.1, 192.168.2.1-192.168.2.99, 192.168.3.*",
  filter_registrant_email_address_help_2: "Use * as a wildcard, e.g. *@example.com",

  select_customer: "Select a Customer",
  support_customer_search_placeholder: "Search customer, CTS name or datacenter",
  customer_name: "Customer",
  cts_name: "CTS Name",
  datacenter: "Datacenter",
  enter_console: "Enter Console",

  footer_copyright_v2: "© Proofpoint, Inc. __CURYEAR__ All Rights Reserved",

  proofpoint_subtitle: "Digital Risk & Compliance",

  link_privacy: "Privacy",
  link_terms: "Terms of Service",
  link_support: "Support",

  login_load_failed: "The authentication service is temporarily unavailable.",
  login_try_again: "Try again",
  login_sign_in: "Sign In",
  login_password: "Password",
  login_forgot_password: "Forgot your password?",
  login_user_center: "User Center Sign In",
  login_confirmation_email: "Didn't receive confirmation email?",
  two_factor_verification_title: "2-Step Verification",
  two_factor_loading: "Loading two-factor authentication…",
  two_factor_load_failed: "Unable to load two-factor authentication. Please try again.",
  two_factor_try_again: "Try again",
  two_factor_verification_intro: "Enter the verification code to access your account.",
  two_factor_verification_help: "If you've lost your phone or need to reset your code please contact your Proofpoint Social Media Protection Suite administrator or",
  two_factor_support: "Proofpoint Social Media Protection technical support",
  two_factor_verify: "Verify",
  two_factor_setup_title: "Two Factor Authentication Setup",
  two_factor_mandatory: "You are required to use two factor authentication by your administrator.",
  two_factor_download_title: "1. Download Google Authenticator for your phone",
  two_factor_download_apple: "Download Google Authenticator from the App Store",
  two_factor_download_google: "Download Google Authenticator from Google Play",
  two_factor_account_title: "2. Set up your account",
  two_factor_account_instructions: "Scan the barcode or enter this key:",
  two_factor_time_instructions: "Make sure your phone has the correct time.",
  two_factor_qr_code: "Two-factor authentication QR code",
  two_factor_save_title: "3. Verify and Save",
  two_factor_save_instructions: "Enter the verification code to confirm that two factor authentication is set up correctly.",
  two_factor_setup_failed: "The validation failed. Please try again or",
  two_factor_new_barcode: "generate a new barcode",
  two_factor_verify_and_save: "Verify and Save",
  forgot_password: "Forgot Password",
  forgot_password_load_failed: "Unable to load the password reset page. Please try again.",
  send_password_reset_link: "Send Password Reset Link",
  user_center_sign_in_title: "Sign In via User Center",
  user_center_logout_text: "If you do not wish to sign in with User Center credentials, please log out from User Center",
  user_center_logout: "User Center Log Out",
  user_center_load_failed: "Unable to load the User Center sign-in page. Please try again.",

  unprocessed_support_customer: 'The selected customer is yet to be processed. Please sign out, wait a moment, and try again.',
  user_not_enabled: 'An error ocurred: the selected customer is not enabled.',
  user_not_processed: 'An error ocurred: the selected user processed has not been processed yet.',

  traverse_missing_warning: 'Please wait until the next group of domains is loaded before proceding with individual navigation.',

  unwatch_domain_dialog_title: "Unwatch Domain ",
  unwatch_domain_dialog_text: "Are you sure you want to unwatch this domain? It will no longer be accessible or visible in the application. Updates for this domain will also be ignored.",

  sign_in_for_more_details: "Sign In For More Details",

  audio: 'Audio',
  download_audio: "Download Audio",
  download_audio_n_transcript: "Download Audio & Transcript",
  show_transcript: "Show Transcript",
  hide_transcript: "Hide Transcript",
  download_video: "Download Video",
  download_transcript: "Download Transcript",
  download_video_and_transcript: "Download Video & Transcript",
  download_image: 'Download Image',

  ad_attributes: 'Ad Attributes',

  transcript_not_available: "Transcript not available",

  content_view_type_table: "Table View",
  content_view_type_split: "Split View",
  content_view_type_scroll: "Scroll View",

  review_tasks: "Review Tasks",
  review_tasks_title: "Review Tasks",

  patrol_content: "Incidents",
  patrol_content_title: "Incidents",

  showing_tasks: "Showing tasks",
  no_tasks: "No tasks to display",
  tasks_selected: "Tasks Selected",

  showing_incidents: "Showing incidents",
  no_incidents: "No incidents to display",
  incidents_selected: "Incidents Selected",

  review_filter_CONTENT_PROFILE: "Activity + Profile Tasks",
  review_filter_APPROVAL: "Only Activity Tasks",
  review_filter_PROFILE_LOCK_REVIEW: "Only Profile Tasks",

  review_sort_SORT_ACTIVITY_DESC: "Activity Date (New → Old)",
  review_sort_SORT_ACTIVITY_ASC: "Activity Date (Old → New)",
  review_sort_SORT_DETECTION_DESC: "Detection Date (New → Old)",
  review_sort_SORT_DETECTION_ASC: "Detection Date (Old → New)",

  review_sort_SORT_TASK_CREATED_DESC: "Task Date (New → Old)",
  review_sort_SORT_TASK_CREATED_ASC: "Task Date (Old → New)",
  review_sort_SORT_RISK_LEVEL_DESC: "Risk Level (Highest → Lowest)",
  review_sort_SORT_RISK_LEVEL_ASC: "Risk Level (Lowest → Highest)",

  search_tasks_text: "Filter tasks by text",

  tasks_per_page: "Tasks/Page",

  patrol_content_per_page: "Items/Page",

  select_all: "Select All",
  select_page: "Select Page",

  view_add_notes: "View/Add Notes",
  view_activity_notes: "View Activity/Notes",
  approve: "Approve",
  globally_approve: "Globally Approve",
  approve_and_forward: "Approve & Forward",
  reject: "Reject",
  reject_and_remove: "Reject & Remove",
  reject_and_forward: "Reject & Forward",
  forward: "Forward",
  permanently_mask_content: "Permanently Mask Content",
  flag_task: "Flag",
  unflag_task: "Unflag",
  //close: "Close"
  share: "Share",
  share_content: "Share Content",
  task_assign: "Task Assign",
  expand_task: "Expand Task",
  collapse_task: "Collapse Task",
  clear: "Clear",
  clear_status: "Clear Status",
  find_identical_items: "Show {count} Identical",

  more_filters: "More Filters",
  filter_panel: "Filter Panel",
  search_filters: "Search Filters",

  date_range: "Date Range",
  profile_task_type: "Profile Task Type",
  reviewer_attributes: "Assignment",
  task_status: "Review Task State",
  content_source: "Source",
  include_closed_tasks: "Include closed tasks in results.",
  review_tasks_text_search_info: "You can filter tasks by the following: <ul> <li> Text content (e.g. \"guarantee\") </li> <li> Account or Participant Email Address (use \"EMAIL\" prefix, e.g. \"EMAIL: jdoe@example.com\") </li> <li> Account ID (use \"ACCOUNT_ID\" prefix, e.g. \"ACCOUNT_ID: 9300193\") </li> <li> Task ID (use \"TASK_ID\" prefix, e.g. \"TASK_ID: 55555\") </li> </ul>",

  apply_filters: "Apply Filters",
  reset_filters: "Reset Filters",
  save_as_view: "Save as View",
  reset_all: "Reset",

  reset_all_filters: "Reset All Filters",
  view_name_label: "View Name (required)",
  view_name_label_required: "You must provide a name for this Filter View.",
  max_characters: "Maximum __CHARS__ characters",

  content_classifications: "Classification",
  must_match_all_classifications: "Must match all selected Classifications",

  content_task_type: "Activity Review Type",
  activity_type: "Activity Category",

  content_post_review: "Captured Activity",
  content_pre_review: "Submitted Content",
  content_post_curator: "Curator Submission",

  //Patrol Content columns
  risk_score: "Risk Score",
  entity_name: "Account Name",
  //entity_type: "Entity Type",
  //detected_at: "Detected At",
  //source: "Source",

  activity_type_comment: "Outbound Comment",
  activity_type_direct_message: "Outbound Direct Message",
  activity_type_post: "Outbound Post",
  activity_type_like: "Outbound Reaction",
  activity_type_outbound_reposts: "Outbound Reposts",
  activity_type_inbound_comment: "Inbound Comment",
  activity_type_inbound_direct_message: "Inbound Direct Message",
  activity_type_outbound_text_messages: "Outbound Text Messages",
  activity_type_inbound_text_messages: "Inbound Text Messages",
  activity_type_contextual_activity: "Contextual Activity",
  activity_type_marketing_email: "Marketing Emails",
  activity_type_outbound_post_edits: "Outbound Edited Posts",
  activity_type_channel_notifications: "Channel Notifications",
  activity_type_outbound_ads: "Outbound Ads",

  syndicate_library: "Syndicate Library",

  task_list_type_Item: "Captured Activity",
  task_list_type_SyndicateItem: "Curator Submission",
  task_list_type_SubmittedContentItem: "Submitted Content",
  task_list_type_PreReviewItem: "Submitted Content",
  task_list_type_INCREMENTAL: "Incremental Review",
  task_list_type_EXPIRATION: "Expiration Review",
  task_list_type_ONBOARDING: "Onboarding Review",
  task_list_type_REVISION: "Revision Review",

  task_list_workflow_state_APPROVED: "Approved",
  task_list_workflow_state_UNAPPROVED: "Unreviewed",
  task_list_workflow_state_PENDING: "Unreviewed",
  task_list_workflow_state_REJECTED: "Rejected",
  task_list_workflow_state_REVIEWED: "Reviewed",
  task_list_workflow_state_STOPPED: "Workflow Stopped",

  content_task_status: "Review Status",
  profile_task_status: "Profile Task Status",
  review_type: "Review Type",

  tasks_open: "Open",
  tasks_unreviewed: "Unreviewed",
  tasks_started: "Started",
  tasks_closed: "Closed",
  tasks_approved: "Approved",
  tasks_rejected: "Rejected",
  tasks_reviewed: "Reviewed",
  tasks_new: "New",

  content_note_toast_add: "Note added successfully",
  retrieve_content_notes: "Retrieve Content Notes",
  add_content_note: "Add Content Note",
  retrieve_sharing_info: "Retrieve Sharing Info",
  task_assignment_users: "Task Assignment Users",
  task_list_attributes: "Task List Attributes",

  content_share_toast: "Content shared successfully",
  content_share_rejected_email_domains: "You have included an additional email address that is not on the allowed list of domains. Please contact your system administrator.",

  item_apps: "Publishing Application",

  author_type: "Activity Direction",
  author_type_account: "Outbound Activity",
  author_type_third_party: "Inbound Activity",

  reviewer_attribute_has_notes: "Has Notes",
  reviewer_attribute_unassigned: "Unassigned",
  reviewer_attribute_assigned_to_me: "Assigned to Me",
  reviewer_attribute_assigned_to_others: "Assigned to Others",

  flagged: 'Flagged',
  flagged_option: 'Flagged',
  unflagged_option: 'Unflagged',

  select_multi_placeholder: "Select one or more filters",
  select_multi_search_placeholder: "Type at least 3 characters to perform the search",
  profile_languages_li_only: 'Profile Languages (LinkedIn Member Accounts only)',

  policy_match: "Policy Match",
  matching_text: "Matching Text",
  classifier_documentation: "Classifier Documentation",
  general_documentation: "General Documentation",
  proofpoint_radar: "Proofpoint Channel Insights",
  policy_matches: "Policy Matches",
  developer_doc: "Developer Documentation",
  efd_support_portal: "EFD Support portal",

  base_v1: "Digital Risk & Compliance",
  category_reference: "Category Reference",

  approve_content_item: "Approve {selected_items} Content Item",
  approve_content_items: "Approve {selected_items} Content Items",
  approve_content: "Approve Content",

  mark_reviewed: "Mark Reviewed",
  mark_reviewed_content_item: "Mark {selected_items} Content Item as Reviewed",
  mark_reviewed_content_items: "Mark {selected_items} Content Items as Reviewed",
  mark_reviewed_content: "Mark Content as Reviewed ",

  reject_content_item: "Reject {selected_items} Content Item",
  reject_content_items: "Reject {selected_items} Content Items",
  reject_content: "Reject Content",

  reject_remove_content_item: "Reject and Remove {selected_items} Content Item",
  reject_remove_content_items: "Reject and Remove {selected_items} Content Items",
  reject_remove_content: "Reject and Remove Content",

  task_batch_assign: "{batch_selected_counter, plural, =1 {Assign {batch_selected_counter} Task} other { Assign {batch_selected_counter} Tasks}}",
  task_batch_unassign: "{batch_selected_counter, plural, =1 {Unassign {batch_selected_counter} Task} other { Unassign {batch_selected_counter} Tasks}}",
  task_assignment_edit: "Edit Assignment",
  notes_optional: "Note (optional)",
  task_assignment_edit_notes_placeholder: "Please add a note",
  task_assignment_edit_notes_required: "Please add a note",
  task_assignment_edit_current_assignee: "Current Assignee",
  task_assignment_edit_new_assignee: "New Assignee",
  task_assignment_user: "Assignee",
  task_assignment_user_placeholder: "Please select an option",
  task_assignment_user_required: "Please select an option",

  task_note_add: "Add Note",
  task_note_add_to_task: "Add Note to {selected_items} Task",
  task_note_add_to_tasks: "Add Note to {selected_items} Tasks",

  activity_already_removed: "The activity is already removed. It may have been removed by the account owner prior to you attempting to delete it.",

  batch_content_processing_completed: "{count} content tasks completed.",
  batch_content_processing_failed_tasks: "{action} action was not allowable for {count} content tasks.",
  batch_processing_completed: "Batch processing is complete. The content list will reload with updated status.",
  batch_processing_failed: "Batch processing failed and could result into errors",
  batch_reject_remove_incomplete: "{partial} content tasks were only allowed to be rejected.",

  batch_task_assignment_processing_completed: "{count,plural,=1 {{count} task was assigned.} other {{count} tasks were assigned.}}",
  batch_task_unassignment_processing_completed: "{count,plural,=1 {{count} task was unassigned.} other {{count} tasks were unassigned.}}",
  batch_task_assignment_failed_success_tasks: "{count,plural,=1 {{username} is not authorized to review all of the tasks you have selected. Therefore 1 task for which {username} is authorized to review was assigned.} other {{username} is not authorized to review all of the tasks you have selected. Therefore {count} tasks for which {username} is authorized to review were assigned.}}",
  batch_task_assignment_failed_tasks: "{username} is not authorized to review any of the tasks you have selected.",

    reviewer_attachment: 'Reviewer Attachment',
    no_attachment: 'No attachment',
    attach_pdf: 'Attach PDF',
    remove_reviewer_attachment: 'Remove PDF',
    remove_reviewer_attachment_confirmation: 'Remove Reviewer Attachment',
    remove_reviewer_attachment_description: 'Are you sure you want to remove the attachment? This cannot be undone.',
    reviewer_attachment_error_file_size: 'File is too large. Maximum size is 10MB',
    reviewer_attachment_error_file_type: 'File format is incorrect. Please upload a PDF file.',

    custom_category_postfix: " (Custom)",

  beta: "Beta",

  remediation_time: "Remediation Time (minutes per incident)",
  review_time: "Review Time (minutes per content item)",
  labor_cost: "Labor Cost (USD per hour)",
  roi_validation_message: "Only positive numbers are accepted.",
  cost_savings_formula: "Cost Savings Formula",
  update_cost_savings_estimates: "Update Cost Savings Estimates",
  savings_formula: "Savings = [ Remediation Time (mins) * Incidents Remediated + Review Time (mins) * Content Items Reviewed ] * [ Labor Cost (USD per hour) ÷ 60 (mins) ]",

  patrol_content_tab: "Incidents",
  accounts_tab: "Accounts",
  threat_sources_tab: "Threat Sources",

  user_management_title: "User Management",
  participants_tab: "Participant Users",
  system_user: "System User",
  system_users_tab: "System Users",
  participants_text_search: "Search by name, email or account name",
  system_users_text_search: "Search by name or email address",
  role_placeholder: "Select a Role",

  filters_panel_2: "Filter Panel",
  columns_panel_2: "Columns Panel",

  participant_users: "Participant Users",
  system_users: "System Users",
  email_address: "Email Address",
  auth_method: "Auth Method",
  assigned_subtenants: "Assigned Subtenants",
  teams: "Teams",
  select_teams: "Select one or more teams",
  select_users: "Select one or more users",
  select_reviewers: "Select one or more System Users or Teams",
  role: "Role",
  is_user_center_user: "Require user to authenticate against User Center",

  participant_state_PROVISIONED: "Provisioned",
  participant_state_ACTIVE: "Active",
  participant_state_PARTIALLY_ACTIVE: "Partially Active",
  participant_state_EXPIRED: "Expired",
  participant_state_DEACTIVATED: "Deactivated",
  participant_state_UNINSTALLED: "Uninstalled",
  participant_state_ISSUES: "Issues",

  participant_profile_state_active: "Active",
  participant_profile_state_expired: "Expired",
  participant_profile_state_deactivated: "Deactivated",
  participant_profile_state_uninstalled: "Uninstalled",

  participant_action_terminate: "Remove Participant User",
  participant_batch_action_terminate: "{selection_counter, plural, =1 {Remove {selection_counter} Participant User} other " +
    "{Remove {selection_counter} Participant Users}}",
  participant_terminate_button: "Remove Participant",
  participant_terminate_button_plural: "Remove Participants",
  participant_terminate_dialog_text: "Are you sure you want to remove {name} ({email}) as a participant user? This operation cannot be undone.",
  participant_terminate_message: "{name} ({email}) has been removed as a participant user.",
  participant_batch_terminate_dialog_text: "{selection_counter, plural, =1 {Are you sure you want to remove this participant user? This operation cannot be undone.} other " +
    "{Are you sure you want to remove these {selection_counter} participant users? This operation cannot be undone.}}",
  batch_terminate_participants: "Remove Participant Users",
  participant_batch_action_uninstall_all_accounts: "{selection_counter, plural, =1 {Uninstall All Accounts from {selection_counter} Participant User} other " +
    "{Uninstall All Accounts from {selection_counter} Participant Users}}",
  participant_uninstall_all_accounts_button: "Uninstall All Accounts",
  participant_uninstall_all_accounts_button_plural: "Uninstall All Accounts",
  participant_uninstall_all_accounts_dialog_text: "Are you sure you want to uninstall all accounts from {name} participant user?",
  participant_uninstall_all_accounts_message: "All accounts have been uninstalled from {name}.",
  participant_batch_uninstall_all_accounts_dialog_text: "{selection_counter, plural, =1 {Are you sure you want to uninstall all accounts from the selected Participant User?} other " +
    "{Are you sure you want to uninstall all accounts from the {selection_counter} selected Participant Users?}}",
  batch_uninstall_participant_all_accounts: "Uninstall All Accounts",
  link_accounts: 'Link Accounts',
  unlink_accounts: 'Unlink All Accounts',
  batch_link_accounts: 'Link Accounts',
  batch_unlink_accounts: 'Unlink All Accounts',
  participant_batch_terminate_message: '{count} participant user has been removed.',
  participant_batch_terminate_message_plural: '{count} participant users have been removed.',
  participant_batch_uninstall_all_accounts_message: 'All accounts have been uninstalled from {count} Participant User.',
  participant_batch_uninstall_all_accounts_message_plural: 'All accounts have been uninstalled from {count} Participant Users.',

  participant_link_accounts_toast_plural: 'Found accounts have been linked to {count} Participant Users. ',
  participant_link_accounts_toast_singular: 'Found accounts have been linked to the selected Participant User. ',
  participant_link_accounts_title: "{selection_counter, plural, =1 {Link accounts to the selected Participant User} other " +
    "{Link accounts to the {selection_counter} selected Participant Users }}",
  participant_link_accounts_message: 'By continuing, the system will find all unlinked accounts within the Participants subtenant with an email address matching the Participant\'s email address and link them. This action will also overwrite all configurations on any newly linked accounts with the settings defined from the Participant user. Would you like to continue?',
  participant_link_accounts_confirm_button: 'Continue Linking',

  participant_unlink_accounts_toast_plural: 'All accounts have been unlinked from {count} Participant Users. ',
  participant_unlink_accounts_toast_singular: 'All accounts have been unlinked from the selected Participant User. ',
  participant_unlink_accounts_title: "{selection_counter, plural, =1 {Unlink accounts from the selected Participant User} other " +
    "{Unlink accounts from the {selection_counter} selected Participant Users }}",
  participant_unlink_accounts_message: 'By continuing, the system will unlink all currently linked accounts from the selected Participant(s). Would you like to continue?',
  participant_unlink_accounts_confirm_button: 'Continue Unlinking',

  participant_action_error_L02: 'No email associated accounts were found for the selected Participant User.',

  batch_edit_participants: "Edit Participant Users",

  participant_name_cell_accounts: "{accounts_count, plural, =1 {View Account ({accounts_count})} other {View Accounts ({accounts_count})}}",
  participant_name_cell_no_accounts: "No Linked Accounts",

  batch_edit_system_users: "Edit System Users",

  participant_action_move: "Move Participant User",
  participant_action_move_description: "Select the Subtenant you wish to move the participant to, and then select the Entity Config to apply. You will receive an email upon completion of the move of the participant and all associated accounts.",
  participant_action_edit_business_associations: "Edit Business Associations",
  participant_action_uninstall_all_accounts: "Uninstall All Accounts",
  required_client_view: "You need to select a valid Subtenant",
  required_entity_config: "You need to select a valid Entity Config",
  required_policy_config: "You need to select a valid Policy Config",
  participant_move_success: "Move Participant User request received. An email will be sent to you when processing is complete.",
  move_participant: "Move Participant",
  participant_batch_action_edit: "{selection_counter, plural, =1 {Edit {selection_counter} Participant User} other " +
    "{Edit {selection_counter} Participant Users}}",

  participant_business_association: "Business Association",
  add_business_association: "Add Business Association",
  participant_enter_business_association: "Enter business association",
  default: "Default",
  participant_business_association_empty: "There are no business associations.",
  participant_business_association_updated: "Business associations updated for participant {participant_name}",
  participant_business_association_fields_tooltip: "Separate association name and value with a colon, e.g. “Primary:jane.doe@acme.com”",

  language: 'language',
  language_subtitle: 'Language',
  participant_secondary_language: 'Alternate Language',
  participant_secondary_language_disabled_helper: 'This option will be available once the participant’s LinkedIn profile review is complete',
  participant_secondary_language_helper: 'This only applies to LinkedIn Member profiles',

  error_required_business_association: "Inputs must separate association name and value with a colon, e.g. “Primary:jane.doe@acme.com”",
  error_malformed_business_association: "Inputs must separate association name and value with a colon, e.g. “Primary:jane.doe@acme.com”",
  error_duplicated_business_association_name: "You cannot use the same business association name in multiple entries.",
  error_response_malformed_business_association: "Inputs must separate association name and value with a colon, e.g. “Primary:jane.doe@acme.com”",
  error_response_duplicated_business_association_name: "You cannot use the same business association name in multiple entries.",
  error_invalid_business_association: "There is at least one newly added Business Association that is not formatted correctly",

  system_user_batch_action_edit: "{selection_counter, plural, =1 {Edit {selection_counter} System User} other " +
    "{Edit {selection_counter} System Users}}",

  participant_action_edit: "Edit Participant User",

  participant_action_send_token_reauth_email: "Send Token Reauthorization Email",
  participant_token_reauth_email_sent: "Token reauthorization email sent to {email}",

  add_participant_groups: "Add Labels",
  remove_participant_groups: "Remove Labels",

  add_assigned_subtenants: "Add Assigned Subtenants",
  remove_assigned_subtenants: "Remove Assigned Subtenants",

  add_teams: "Add Teams",
  remove_teams: "Remove Teams",

  system_user_status_ENABLED: "Enabled",
  system_user_status_DISABLED: "Disabled",
  system_user_status_TERMINATED: "Terminated",

  system_user_action_disable: "Disable System User",
  system_user_action_enable: "Enable System User",
  system_user_action_reset_password: "Reset Password",
  system_action_terminate: "Remove System User",
  system_terminate_dialog_text: "Are you sure you want to remove {name} ({email}) as a system user? This operation cannot be undone.",
  system_user_terminate_button: "Remove System User",
  system_user_terminate_message: "{name} ({email}) has been removed as a system user.",

  system_user_enabled_message: "{name} has been enabled.",
  system_user_disabled_message: "{name} has been disabled.",
  system_user_reset_password_message: "Password reset initiated for {name}.",

  system_user_auth_method_SSO: "SSO",
  system_user_auth_method_USER_CENTER: "User Center",
  system_user_auth_method_ONE_FACTOR: "One Factor",
  system_user_auth_method_TWO_FACTOR: "Two Factor",

  entity_config: "Entity Config",
  policy_config: 'Policy Config',
  access_policy: "Access Policy",
  proxy_policy: "Access Policy",
  subtenant: "Subtenant",
  auth_state: "Account State",
  profile_account_status: "Profile State",
  profile_issues: "Profile Issues",
  grouping_values: "Labels",
  participant_groups: "Labels",
  select_existing_participant_groups: "Select existing Labels",
  introduce_new_participant_groups: "Create new Labels",
  business_associations: "Business Associations",
  must_match_all_groups: "Must match all selected Labels.",
  certifications: "Credential Name",
  certifications_organization: "Credential Organization",
  certifications_url: "Credential URL",
  formatted_certifications_status: "Credential Status",

  account_auth_state_active: "Active",
  account_auth_state_expired: "Expired",
  account_auth_state_deactivated: "Deactivated",
  account_auth_state_uninstalled: "Uninstalled",
  account_auth_state_unprotected: "Unprotected",

  issues_counter: "{count, plural, =1 {{count} Issue} other {{count} Issues}}",
  participant_empty_accounts: "The selected participant does not have associated accounts",

  uninstall: "Uninstall",
  uninstall_patrol: "Uninstall Patrol",
  send_token_reauth_email: "Send Reauth Email",
  create_profile_review: "Create Profile Review",

  account_tags: "Account Tags",
  account_status: "Account Authorization Status",
  edit_columns: "Edit Columns",
  apply_changes: "Apply Changes",
  reset_columns: "Reset to Default",

  new_user: "New User",
  add_user: "Add User",
  export_data: "Export Data",
  import_data: "Import Data",
  import_users: "Import Users",
  choose_file: "Choose File",
  file_not_selected_error: "Please select a file to continue",
  add_participant_user: "Add Participant User",
  edit_participant_user: "Edit Participant User",
  participant_import_data_description: "Select and import a CSV file to update your user data.",
  cpum_upload_successful: "Your User file has been successfully uploaded and may take time to process. An email will be sent to you when processing is complete.",

  system_user_report: "System User Report",
  participant_user_report: "Participant User Report",

  export_all_users: "Export All Users",
  export_system_users: "Export System Users",
  export_participant_users: "Export Participant Users",

  //export_users_description: "The system will produce the requested user export as a CSV file, and send it to you via email as an attachment when it completes. Please confirm you want to export users.",
  export_users_description: "The CSV file containing the requested exported data will be downloaded as soon as it has been created, which may take more than a minute. Please confirm that you want to proceed.",

  users_csv_export_description: "This export may take over a minute to create the CSV File. Download will begin immediately after file creation.",

  add_system_user: "Add System User",
  edit_system_user: "Edit System User",

  first_name: "First Name",
  last_name: "Last Name",

  select: "Select",
  enter: "Enter",

  participant_created: "{name} ({email}) has been added. Any existing accounts using this email will link to this user momentarily.",
  participant_updated: "{name} ({email}) has been updated. Changes on install configurations might take a couple of minutes to propagate to existing accounts.",

  error_saving_user:   "{error_count, plural, =1{Error saving user. Please fix the issue below.} other {Error saving user. Please fix the issues below.}}",
  system_user_created: "{name} has been created.",
  system_user_updated: "{name} has been updated.",

  invalid_email_address: "Invalid Email Address",

  required: "Required",
  invalid_first_name: "Invalid First Name",
  invalid_last_name: "Invalid Last Name",
  invalid_role: "Please select a Role",
  empty_subtenants: "Please assign at least one subtenant to this user.",
  invalid_participant_groups: "There is at least one newly added Label that is not formatted correctly",
  email_address_in_use: "The email address is already in use",
  update_no_changes: "There were no changes applied to the Participant User",

  records_with_errors: "There have been {records_with_errors} record(s) with errors.",

  user_single: 'user',
  users_plural: 'users',
  participant_batch_edit_records_with_errors_single: "1 participant user could not be updated because its entity config is in a different subtenant. ",
  participant_batch_edit_records_with_errors_plural: "{records_with_errors} participant users could not be updated because their entity config is in a different subtenant. ",
  participant_batch_edit_records_unchanged_single: "1 participant user was not modified",
  participant_batch_edit_records_unchanged_plural: "{records_unchanged} participant users were not modified",
  participant_batch_edit_records_successful: "Changes saved for {records_successful} participant {users}",

  system_user_batch_edit_records_with_errors: "{records_with_errors} {users} could not be updated.",
  system_user_batch_edit_records_unchanged_single: "{records_unchanged} system user was not modified.",
  system_user_batch_edit_records_unchanged_plural: "{records_unchanged} system users were not modified.",
  system_user_batch_edit_records_successful: "Changes saved for {records_successful} system {users}.",

  create_profile_review_button: 'Create Review',
  participant_account_empty_review_disabled: 'A profile review is already pending for this account',
  participant_account_empty_review_description: 'Are you sure you want to create a profile review for {account_name}?',
  participant_account_empty_review_created: 'A profile review was created for {account_name}',

  uninstall_patrol_from_account_description: 'Are you sure you want to Uninstall Patrol from {account_name}?',
  participant_account_uninstalled: 'Patrol uninstalled from {account_name}',

  set_to_none: "(Set to none)",
  edit_access_policy: "Edit Access Policy",
  edit_entity_config: "Edit Entity Config",

  select_a_filter: "Select a filter",

  participant_action_send_welcome_email: "Send Welcome Email",
  participant_welcome_mail_sent: "The welcome email has been sent to the participant.",

  section: "Section",
  profile_field: "Sections",
  before_value: "Before Value",
  after_value: "After Value",
  section_value: "Section Value",

  add_profile_section: "Add Profile Section",
  finalize_review: "Finalize Review",
  forward_review: "Forward Review",
  profile_for: "for",
  disabled_finalize_tooltip: "Please correct any errors and ensure all required sections have been reviewed.",
  required_fields_empty_error: 'No profile sections require review. Under Review Configuration, uncheck "Show Only Sections Requiring Review" to view the full profile.',
  activity_deleted: "Activity Deleted",

  remove_language: 'Remove Language',
  remove_language_description_1: "Removing this section will show your primary profile's information instead.",
  remove_language_description_2: 'To remove it entirely, delete the section from your primary profile.',

  select_one_or_more_reviewers: 'Select one or more reviewers',
  reviewer_error: 'You must select at least one reviewer.',
  summary_note: "Summary Note",
  review_submitted: "The review has been forwarded to the selected recipients",
  review_finalized: "Review Finalized",
  review_item_message_success: "was successfully updated",
  review_item_message_failed: "update attempt failed",

  message_exclusion_rules_title: "RRA Exclusion Rules",
  create_new_rule: "Create New Rule",
  rule_criteria: "Rule Criteria",
  rule_basis: "Rule Basis",
  office_tenants_using_rule: "Office Tenants Using Rule",
  messages_matching_rule: "# Messages Matching Rule",
  edit_rule: "Edit Rule",
  edit_tenants: "Edit Tenants",
  delete_rule: "Delete Rule",
  rule: "Rules",
  create_rule_title: "Edit Rule : Untitled",
  edit_rule_title: "Edit Rule: {rulename}",
  save_rule: "Save Rule",
  exclusion_rule_name: "Rule Name (required)",
  add_condition: "Add Condition",
  message_header: "Message Header",
  matching_logic: "Matching Logic",
  remove_condition: "Remove Condition",
  matching_value: "Matching Value (required)",
  select_message_header: "Select or enter a custom header value",
  select_matching_logic: "Select matching logic",
  enter_name: "Enter name",
  message_exclusion_rules: "Message Exclusion Rules",
  message_exclusion_contains: 'contains',
  message_exclusion_not_contain: 'does not contain',
  message_header_values: 'Message Header Values',
  envelope_recipient_values: 'Envelope Recipient Values',
  message_exclusion_header_edit_rule_text: "Exclude Messages from the Rapid Risk Assessment when ALL the following conditions are met:",
  message_exclusion_recipient_edit_rule_text: "Exclude Messages from the Rapid Risk Assessment when the envelope recipient...",
  message_exclusion_rule_provide_a_name: 'You must enter a rule name',
  message_exclusion_rule_provide_a_value: 'You must enter a valid value',
  message_exclusion_rule_invalid_name: 'Please enter a valid name',
  create_at_least_one_condition: 'You must enter at least one condition',
  matching_header_invalid_value: 'You must select or enter a header name',
  matching_logic_invalid_value: 'You must select the matching logic',
  matching_value_invalid_value: 'you must enter a matching value',
  message_exclusion_delete_dialog_text: 'Are you sure you want to delete this message exclusion rule?This operation cannot be undone.',
  message_exclusion_delete_dialog_title: 'Delete Rule Confirmation',
  message_exclusion_rule_saved_message: "Message Exclusion Rule {name} has been saved.",
  message_exclusion_rule_removed_message: "Message Exclusion Rule {name} has been removed.",
  message_exclusion_edit_tenant_dialog_title: "Edit Tenants",
  message_exclusion_edit_tenants_dialog_text: "Select the tenants that you want this rule to apply to.",
  message_exclusion_edit_tenants_message: "Message Exclusion tenants have been changed.",
  message_exclusion_no_edit_tenants_dialog_text: "There are no tenants available to apply this rule to.",

  profile_policies_title: "Profile Policy Configuration",

  profile_options_tab_title: "Profile Policies",
  profile_options_reviewer_notifications_title: "Profile Notifications",
  profile_options_disclaimers_tab_title: "Disclaimer Sets",
  profile_options_audits_tab_title: "Audit Logs",

  profile_policies_table_title: "{results_count, plural, =1 {{results_count} Profile Policy} other {{results_count} Profile Policies}}",

  accounts_count: "Accounts using Policy",
  customer_install_requests_count: "Entity Configs using Policy",

  create_profile_policy: "Create Profile Policy",
  create_disclaimer: "Create Disclaimer Set",

  untitled: "Untitled",

  general_settings: "General Settings",
  channel_settings: "Channel Settings",
  notification_reviewer_settings: "Notification/Reviewer Settings",
  audit_policy_changes: "Audit Policy Changes",

  policy_name_description: "Policy Name and Description",
  profile_lock_settings: "Profile Lock Settings",
  profile_manager_settings: "Profile Manager Settings",
  profile_manager_settings_intro: "The settings below only apply to channels in this policy that have Profile Manager enabled.",

  policies_description_helper: "Please limit the description to 400 characters.",

  grace_period_for_lock_down: "Lockdown Grace Period (in minutes)",
  grace_period_for_lock_down_helper: "Must be a whole number greater than or equal to 30.",

  suspicious_item_detection: "Detect Suspicious Activity",
  suspicious_item_detection_helper: "<span> Receive alerts to take action on detected profile changes or potentially harmful posted content.  <a href=''{link}'' target= \"_blank\">Learn more</a> about suspicious activity. </span>",

  profile_expiration: "Profile Expiration",
  profile_expiration_period_in_days: "Profile Expiration Period (in days)",
  profile_expiration_period_in_hours: "Profile Expiration Period (in hours)",
  specify_prior_to_expiration_days: "Days Before Expiration",
  notify_participant_prior_to_expiration: "Notify Participant Prior to Expiration",
  submit_profile_for_review_prior_to_expiration: "Submit Profile for Review Prior to Expiration",
  reset_expiration_on_incremental: "Reset Expiration When Changed Sections Are Approved",
  reset_expiration_on_incremental_description: "By default, the profile expiration date resets only if all fields are approved. Enable this to also reset expiration when only the changed fields are approved in an incremental review.",
  reset_expiration_on_reviewer_generated: "Reset Expiration on Reviewer-Initiated Incremental Review",
  reset_expiration_on_reviewer_generated_description: "When enabled, completing a reviewer-initiated incremental review will reset the profile’s expiration date. Disable to preserve the original expiration date unless a full review is completed.",
  edit_loopback: "Edit Loopback for Multi-Tier Reviews",
  enforce_pre_review: "Enforce Profile Pre-Review",
  pre_review_url: "Pre-Review URL",
  auto_submit_profiles: "Auto-Submit Profiles after Installing Patrol",
  auto_revert_native_changes: "Post Review Auto Reversion",
  specify_how_many_days_auto_revert: "Auto Revert Grace Period (in days)",
  display_compliance_id: "Display Compliance ID in Published Profile",
  compliance_id_format: "Compliance ID Format",
  remind_reviewers_profile_review_not_started: "Remind Reviewers if Profile Review Not Started",
  remind_reviewers_profile_review_not_started_schedule: "Specify Reminder Schedule (in days)",
  specify_ascending_days_placeholder: "1,3,5",
  specify_ascending_days: "Separate ascending day values with commas. Only whole numbers greater than zero accepted.",
  specify_ascending_days_error: "Day values must be whole numbers greater than zero.",

  enforce_pre_review_helper: "Require profile changes to be submitted and approved before publication.",
  auto_submit_profiles_helper: "When disabled, participants can make changes in profile form first and then manually submit for review. Can only be changed when 'Enforce Pre-Review' is enabled.",
  auto_revert_native_changes_helper: "When Post Review mode is in use, auto-revert profile updates if the review is not started after the defined grace period.",
  enable_profile_expiration_helper: "Require profiles to be periodically re-reviewed in their entirety. Upon expiration, profiles will be automatically submitted for review.",
  profile_expiration_period_helper: "Set how long an approved profile will be valid for (in days or hours). Changing this value for any existing accounts using this policy will dynamically adjust their expiration date.",
  submit_profile_for_review_prior_to_expiration_helper: "Automatically submit profiles for review prior to actual expiration date.",
  notify_participant_prior_to_expiration_helper: "Notify participants via email that their Profile will be expiring soon.",
  notify_participant_prior_to_expiration_days_helper: "Must be greater than any number of days specified to submit profiles for review before expiration.",
  edit_loopback_helper: "<span> When using multi-tier profile review, require each tier of reviewers to mutually approve Reviewer Edits to profile sections. <a href=''{link}'' target= \"_blank\">Learn more</a> about multi-tier review. </span>",
  compliance_id_format_helper: "<span> <a href=''{link}'' target= \"_blank\">Learn more</a> about how the ID format works. </span>",
  remind_reviewers_profile_review_not_started_helper: "Send reminder emails to reviewers about unopened Profile Reviews in their queue after a series of days.",
  display_compliance_id_helper: "When enabled, automatically publish a Patrol generated \"Review ID\" for each review on to the Live Profile.",

  cant_be_greater_than_expiration_period: "Cannot be equal or greater than the Profile Expiration Period",

  invalid_name: 'Please enter a valid name.',
  invalid_content: 'Please enter valid content.',
  profile_policy_invalid_description: 'You must limit the description to 400 characters.',
  invalid_profile_expiration_period: 'Please select a valid expiration period.',
  profile_policy_created: 'Profile Policy created',
  profile_policy_updated: 'Profile Policy updated',
  profile_policy_save_success: 'The Changes have been applied to the Profile Policy',

  name_and_description: 'Name and Description',

  disclaimers_table_title: "{results_count, plural, =1 {{results_count} Disclaimer Set} other {{results_count} Disclaimer Sets}}",
  disclaimer_name: 'Disclaimer Set Name',
  profile_policy_action_edit: 'Edit Profile Policy',
  disclaimer_action_edit: 'Edit Disclaimer Set',
  disclaimer_action_delete: 'Delete Disclaimer Set',
  invalid_value: 'Please enter a valid value',
  higher_than_0: 'Please enter a value higher than 0',
  expiration_notice_should_be_greated_than_autosubmit: "Should be greater than Auto Submission days",
  invalid_regex_compliance_id: "Should include #YYYY#-#ID#",

  enter_disclaimer_text: 'Enter Disclaimer Text',

  disclaimer_label: "Disclaimer",


  facebook_page_disclaimer: 'Facebook Page Disclaimer Text',
  facebook_page_disclaimer_helper: 'This Disclaimer is appended to the “Impressum” section of a Facebook Page. Any characters added by a participant to their impressum will reduce the maximum characters available for this disclaimer.',

  facebook_page_disclaimer_subtitle: 'This Disclaimer is appended to the “Impressum” section of a Facebook Page. ',
  twitter_profile_disclaimer_subtitle: 'This Disclaimer is appended to the “Bio” section of a Twitter Profile.',
  google_profile_disclaimer_subtitle: 'This Disclaimer is appended to the “Description” section of a Google Business Profile.',
  youtube_channel_disclaimer_subtitle: 'This Disclaimer is appended to the “Channel Description” section of a YouTube Channel.',
  linkedin_individual_profile_subtitle: 'This Disclaimer is appended to the “Summary” section of a LinkedIn Profile. LinkedIn Profiles can be created in different languages. Set up disclaimers in multiple languages to be published in profiles in that language.',
  linkedin_individual_profile_disclaimer: 'LinkedIn Member Profile Disclaimer Text',
  linkedin_individual_profile_disclaimer_helper: 'This Disclaimer is appended to the “Summary” section of a LinkedIn Profile. Any characters added by a participant to their summary will reduce the maximum characters available for this disclaimer.',

  remove_disclaimer: 'Remove Disclaimer',

  add_secondary_dialog_title: 'Add Secondary Language Profile Disclaimer',
  add_secondary_dialog_subtitle: 'This Disclaimer is appended to the “Summary” section of a LinkedIn Profile',
  language_required: 'Language (required)',
  add_disclaimer: 'Add Disclaimer',
  add_secondary_language_profile_disclaimer: 'Add Secondary Language Profile Disclaimer',
  twitter_profile_disclaimer: 'Twitter Profile Disclaimer Text',
  twitter_profile_disclaimer_helper: 'This Disclaimer is appended to the “Bio” section of a Twitter Profile. Any characters added by a participant to their bio will reduce the maximum characters available for this disclaimer.',
  google_profile_disclaimer: 'Google Business Profile Disclaimer Text',
  google_profile_disclaimer_helper: 'This Disclaimer is appended to the “Description” section of a Google Business Profile. Any characters added by a participant to their bio will reduce the maximum characters available for this disclaimer.',
  youtube_channel_disclaimer: 'YouTube Channel Disclaimer Text',
  youtube_channel_disclaimer_helper: 'This Disclaimer is appended to the “Channel Description” section of a YouTube Channel. Any characters added by a participant to their description will reduce the maximum characters available for this disclaimer.',

  content_review_teams: 'Activity Review Teams',
  profile_review_teams: 'Profile Review Teams',
  activity_review_teams: 'Activity Review Teams',
  content_review_users: 'Activity Review System Users',
  profile_review_users: 'Profile Review System Users',
  activity_review_users: 'Activity Review System Users',
  content_reviewers: 'Activity Reviewers',
  activity_reviewers: 'Activity Reviewers',
  profile_reviewers: 'Profile Reviewers',

  description: 'Description',
  save_disclaimer: 'Save Disclaimer Set',
  disclaimer_rollout_in_progress_warning: 'This disclaimer is currently being pushed out to accounts and can not be edited until that finishes. Try again in a few minutes.',

  disclaimer_section_helper_text: 'You can select a Disclaimer Set from the Profile Policy Configuration > Profile Policies tab.',
  disclaimer_section_text_helper_text: 'You can edit the Disclaimer Set text from the Profile Policy Configuration > Disclaimer Sets tab.',

  remaining_chars: "{current_chars, plural, =1 {{current_chars} characters remaining} other {{current_chars} characters remaining}}.",
  learn_more: "Learn more",
  create_new_disclaimer: "Create New Disclaimer Set",

  generic_created_message: "{name} successfully created.",
  generic_updated_message: "{name} successfully updated.",
  generic_deleted_message: "{name} successfully deleted.",

  delete_disclaimer: "Delete Disclaimer Set",
  delete_disclaimer_confirmation: "Delete Disclaimer Set Confirmation",
  disclaimer_destroy_dialog_text: "Are you sure you want to delete Disclaimer Set, ''{name}''?  This action cannot be undone.",
  disclaimer_in_use: "You cannot delete a Disclaimer Set that is currently in use",
  disclaimer_destroy_message: "{name} has been deleted.",

  accounts_using_profile_policy: "Accounts Using Profile Policy",

  policies_using_disclaimer: "Policies Using Disclaimer Set",
  disclaimer_policies_count: "Policies Using Disclaimer Set",

  policies_using_profile_notification: "Policies Using Profile Notification",
  profile_notifications_policies_count: "Policies Using  Profile Notification",

  profile_notifications: "Profile Notifications",
  create_profile_notification: "Create Profile Notification",
  profile_notifications_table_title: "{results_count, plural, =1 {{results_count} Profile Notification} other {{results_count} Profile Notifications}}",
  profile_notification_name: 'Profile Notification Name',
  profile_notification_action_edit: 'Edit Profile Notification',
  profile_notification_action_duplicate: 'Duplicate Profile Notification',
  profile_notification_action_delete: 'Delete Profile Notification',
  save_profile_notification: 'Save Profile Notification',

  delete_profile_notification_confirmation: "Delete Profile Notification Confirmation",
  profile_notification_destroy_dialog_text: "Are you sure you want to delete Profile Notification, ''{name}''?  This action cannot be undone.",
  profile_notification_destroy_message: "{name} has been deleted.",
  profile_notification_in_use: "You cannot delete a Profile Notification that is currently in use",
  delete_profile_notification: 'Delete Profile Notification',

  notification_rules: 'Notification Rules',
  notification_rules_caption: 'At least one rule must be specified. At least one recipient must be specified for each rule.',

  for_all_changes_notify: "For <b> All Changes </b> notify:",
  for_incidents_classified_as: "For incidents classified as:",

  add_rule: "Add Rule",
  remove_rule: "Delete Rule",
  has_missing_recipients: "At least one recipient must be specified for each rule.",

  copy_of: "Copy of",

  disallowed_email_domains: "The following Domains for Emails are not allowed: {domains}",

  edit_disclaimer: "Select Disclaimer Set",
  disclaimer: "Disclaimer Set",
  disclaimer_text: "Disclaimer Text",

  disclaimer_updated_for: "Disclaimer Set updated for {name}.",

  profile_policy_notification_missing: "Accounts and Entities Configs cannot use this Profile Policy unless a Profile Notification is selected.",

  edit_profile_notification: "Select Profile Notification",
  profile_notification: "Profile Notification",

  profile_notification_updated_for: "Profile Notification updated for {name}.",

  profile_policy_action_duplicate: 'Duplicate Profile Policy',
  delete_profile_policy_confirmation: "Delete Profile Policy Confirmation",
  profile_policy_destroy_dialog_text: "Are you sure you want to delete Profile Policy, ''{name}''?  This action cannot be undone.",
  profile_policy_destroy_message: "{name} has been deleted.",
  profile_policy_in_use: "You cannot delete a Profile Policy that is currently in use",
  delete_profile_policy: 'Delete Profile Policy',

  batch_update_profile_notification: 'Select Profile Notification',
  batch_update_disclaimer: 'Select Disclaimer Set',

  disclaimer_batch_updated: "{records_updated, plural, =1 {Disclaimer Set updated for {records_updated} Profile Policy.} other {Disclaimer Set updated for {records_updated} Profile Policies.}}",
  disclaimer_batch_updated_empty: "No Profile Policies updated for the current selection",
  disclaimer_batch_update_blocked: "Skipped the following Profile Policies because a referenced Disclaimer Set has a rollout in progress -- try again once it completes: {policy_names}",

  profile_notification_batch_updated: "{records_updated, plural, =1 {Profile Notification updated for {records_updated} Profile Policy.} other {Profile Notification updated for {records_updated} Profile Policies.}}",
  profile_notification_batch_updated_empty: "No Profile Policies updated for the current selection",

  profile_type_100: 'Facebook Pages',
  profile_type_200: 'Twitter Profiles',
  profile_type_300: 'LinkedIn Member Profiles',
  profile_type_301: 'LinkedIn Page Profiles',
  profile_type_800: 'Instagram Profiles',
  profile_type_10000: 'Google Business Profiles',
  profile_type_400: 'YouTube Channel Profiles',
  digital_profiles: 'Digital Profiles',

  snapshot_100: 'Facebook Snapshots',
  snapshot_200: 'Twitter Snapshots',
  snapshot_300: 'LinkedIn Profile Snapshots',
  snapshot_301: 'LinkedIn Company Snapshots',
  snapshot_800: 'Instagram Snapshots',
  snapshot_FB: 'Facebook Snapshots',
  snapshot_TW: 'Twitter Snapshots',
  snapshot_LI: 'LinkedIn Snapshots',
  snapshot_IG: 'Instagram Snapshots',
  snapshot_GB: 'Google Business Snapshots',
  snapshot_digital: 'Digital Snapshots',

  twitter_profiles_title: 'Twitter Profile Settings',
  twitter_profiles_section_options: 'Twitter Profile Sections',

  linkedin_profiles_title: 'LinkedIn Member Profile Settings',
  linkedin_profiles_section_options: 'LinkedIn Member Profile Sections',

  linkedin_companies_title: 'LinkedIn Page Profile Settings',
  linkedin_companies_section_options: 'LinkedIn Page Profile Sections',

  facebook_pages_title: 'Facebook Page Settings',
  facebook_pages_section_options: 'Facebook Page Sections',

  instagram_profiles_title: 'Instagram Profile Settings',
  instagram_profiles_section_options: 'Instagram Profile Sections',

  google_business_profiles_title: 'Google Business Profile Settings',
  google_business_profiles_section_options: 'Google Business Profile Sections',

  youtube_channel_profiles_title: 'YouTube Channel Settings',
  youtube_channel_section_options: 'YouTube Channel Sections',

  profile_field_7000: 'Channel Name',
  profile_field_7001: 'Channel Description',
  profile_field_7002: 'Banner Image',
  profile_field_7003: 'Profile Thumbnail',
  profile_field_7004: 'Custom URL',
  profile_field_7005: 'Country',
  profile_field_7006: 'Default Language',
  profile_field_7007: 'Channel Status',

  enable_profile_features: 'Enable Profile Features',

  profile_features_none: 'We recommend at a minimum enabling "Snapshot Only" mode so that basic profile changes, e.g. Account Name and Image, are reflected within Patrol.',

  NONE: 'None',
  NOT_SET: 'Not Set',
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
  not_set: 'Not Set',
  low: 'Low',
  medium: 'Medium',
  high: 'High',
  PROFILE_LOCK: 'Profile Lock',
  PROFILE_MANAGER: 'Profile Manager',

  banner_selection_mode: 'Banner Selection Mode',
  DO_NOT_REQUIRE_BANNER_IMAGES: 'Do not require banner image',
  DEFAULT_BANNER_IMAGE: 'Participant must use the default banner image',
  BANNER_IMAGE_SELECTION: 'Users must select from the image library',

  banner_library: 'Banner Library',
  banner_library_description: 'When given the option, users can select up to six banner images specified here.',
  upload_banners: 'Upload Banners',

  conditions: 'Conditions',
  section_option: 'Select Options',

  profile_images: 'Profile Images',
  profile_information: 'Profile Information',
  settings: 'Settings',
  intro: 'Intro',
  contact_info: 'Contact Info',
  contact_and_basic_info: 'Contact and Basic Info',
  about: 'About',
  privacy_and_legal_info: 'Privacy and Legal Info',
  details_about_you: 'Details About You',
  page_information: 'Page Information',
  overview: 'Overview',
  community: 'Community',
  legacy: 'Legacy',
  images: 'Images',
  contact: 'Contact Info',
  location: 'Location',
  hours_group: 'Hours',
  more_details: 'More Details',

  section_options_selected: "{results_count} Sections",

  CUSTOM: 'Custom',
  ALL_CHANGES: 'All Changes',

  NOTIFY: 'Notify',
  LOG: 'Log',
  HIDE: 'Hide',
  DELETE: 'Delete',
  DEL_REVIEW: 'Delete and Review',
  SNAPSHOT_ONLY: 'Snapshot Only',
  REVIEW: 'Review',
  LOCKDOWN: 'Lockdown',

  profile_field_3000: 'Name',
  profile_field_3001: 'Location',
  profile_field_3002: 'Website',
  profile_field_3003: 'Bio',
  profile_field_3004: 'Username',
  profile_field_3005: 'Language',
  profile_field_3007: 'Geo Enabled',
  profile_field_3009: 'Protected Tweets',
  profile_field_3020: 'Profile Image',
  profile_field_3022: 'Banner',
  profile_field_3023: 'Verified',

  profile_field_2035: 'Background Photo',
  profile_field_2026: 'Profile Photo',
  profile_field_2008: 'First Name',
  profile_field_2009: 'Last Name',
  profile_field_2064: 'Additional Name',
  profile_field_2013: 'Headline',
  profile_field_2015: 'Industry',
  profile_field_2022: 'Country/Region',
  profile_field_2023: 'City/District',
  profile_field_2028: 'Profile URL',
  profile_field_2007: 'Email Address',
  profile_field_2020: 'Phone',
  profile_field_2019: 'Address',
  profile_field_2036: 'Birthday',
  profile_field_2032: 'Website',
  profile_field_2012: 'Instant Messenger',
  profile_field_2014: 'Summary',
  profile_field_2021: 'Experience',
  profile_field_2006: 'Education',
  profile_field_2001: 'Licenses and Certification',
  profile_field_2031: 'Volunteering',
  profile_field_2030: 'Skills',
  profile_field_2029: 'Publications',
  profile_field_2018: 'Patents',
  profile_field_2002: 'Courses',
  profile_field_2027: 'Projects',
  profile_field_2011: 'Honors & Awards',
  profile_field_2037: 'Test Scores',
  profile_field_2017: 'Languages',
  profile_field_2034: 'Organizations',
  profile_field_2063: 'Geo Location',
  profile_field_2038: 'Featured',

  profile_field_2060: 'Cover Image',
  profile_field_2048: 'Page Logo',
  profile_field_2040: 'Name',
  profile_field_2057: 'Vanity Name',
  profile_field_2045: 'Description',
  profile_field_2044: 'Website',
  profile_field_2046: 'Industry',
  profile_field_2047: 'Company Size',
  profile_field_2051: 'Locations',
  profile_field_2052: 'Founded',
  profile_field_2054: 'Specialties',
  profile_field_2042: 'Company Type',
  profile_field_2059: 'Featured Groups',
  profile_field_2043: 'Status',
  profile_field_2055: 'Ticker',
  profile_field_2050: 'Twitter Handle',

  profile_field_4020: 'Cover Photo',
  profile_field_4019: 'Profile Image',
  profile_field_4000: 'Name',
  profile_field_4004: 'Username',
  profile_field_4007: 'Bio',
  profile_field_4047: 'About You',
  profile_field_4046: 'Impressum',
  profile_field_4001: 'Category',
  profile_field_4002: 'Phone Number',
  profile_field_4003: 'Website',
  profile_field_4050: 'Email',
  profile_field_4011: 'Address',
  profile_field_4053: 'Hours',
  profile_field_4008: 'Products',
  profile_field_4018: 'Page Settings',
  profile_field_4057: 'Page is Reviewable',
  profile_field_4054: 'Link',
  profile_field_4021: 'Roles',
  profile_field_4017: 'Page is Published',
  profile_field_4022: 'Admins',
  profile_field_4048: 'Subcategory',
  profile_field_4055: 'Business Always Open',
  profile_field_4056: 'Business Permanently Closed',
  profile_field_4023: 'Tabs',

  profile_field_5004: 'Profile Image',
  profile_field_5001: 'Username',
  profile_field_5000: 'Name',
  profile_field_5002: 'Bio',
  profile_field_5003: 'Website',

  profile_field_6000: 'Logo',
  profile_field_6001: 'Cover Photo',
  profile_field_6002: 'Business Name',
  profile_field_6003: 'Primary Category',
  profile_field_6004: 'Additional Categories',
  profile_field_6005: 'Business Description',
  profile_field_6006: 'Phone Number',
  profile_field_6007: 'Website',
  profile_field_6008: 'Social Profiles',
  profile_field_6009: 'Business Location',
  profile_field_6010: 'Service Areas',
  profile_field_6011: 'Business Hours',
  profile_field_6012: 'Special Hours',
  profile_field_6013: 'More Hours',
  profile_field_6014: 'Attributes',
  profile_field_6015: 'Services',
  profile_field_6016: 'Verification Status',
  profile_field_6017: 'Google Profile Status',

  review_blockers_title: 'Remaining Review Items',
  review_blockers_description: 'The following must be addressed before you can finalize the review',
  field_with_error: 'Error',
  field_review_required: 'Review Required',
  issue: 'Issue',

  facebook_npe_alert: "Per Facebook’s announcement, all pages will be transitioned to the New Pages Experience in the coming months. <a href='https://www.facebook.com/business/help/2752670058165459?id=418112142508425'  target='_blank' >Read more</a> about what is changing for Facebook Pages. The Facebook Pre-Review form has been updated to accommodate these changes. Is my Facebook Page in the New Page Experience? {is_facebook_page_npe, select, true {Yes} false {No}}",

  hide_received_recommendations: 'Hide Received Recommendations',
  remove_given_recommendations: 'Remove Given Recommendations',
  hide_received_endorsements: 'Hide Received Endorsements',
  remove_given_endorsements: 'Remove Given Endorsements',
  remove_rich_media: 'Remove all content from the Featured section',
  remove_rich_media_helper_text: 'Automatically remove posts, media, and links to prevent them from being displayed on profiles.',

  certifications_condition_modal_title: 'Edit Conditions: Licenses & Certifications',
  review_condition: 'Review Conditions',

  certifications_text: 'Specify Certification Key Text (required)',
  certifications_text_placeholder: 'Enter certification key text',
  certifications_text_helper: 'Define the text for profile manager to use when updating a participant’s list of registered states.',
  certifications_text_helper_error: 'Invalid certification key text',

  review_condition_ALL_CHANGES: 'Use Default',
  review_condition_CUSTOM: 'Enable Custom Certification Key Text',

  skills_condition_ALL_CHANGES: 'Do not use Defined Skills List',
  skills_condition_CUSTOM: 'Use Defined Skills List',

  skills_condition_modal_title: 'Edit Conditions: Skills',

  skill_option_ALLOWED: 'Allowed',
  skill_option_BLOCKED: 'Blocked',

  defined_skills_list: 'Defined Skills List',

  add_skill: 'Add Skill',

  skill_required: 'At least one skill must be defined.',
  invalid_skill: "Invalid Skill",

  other_profiles: 'Other Profiles',
  profile_snapshots: 'Profile Snapshots',
  profile_section: 'Profile Section',
  snapshot_value: 'Snapshot Value',

  authentication_settings_tab_title: 'Authentication Settings',
  email_notifications_tab_title: 'Email Notifications',
  social_discover_authorization_tab_title: 'Social Discover Authorization',

  admin_settings_title: 'My Settings',
  global_settings_title: 'Global System Settings',
  two_factor_authentication: 'My Two Factor Authentication (2FA)',
  two_factor_status: '2FA Status',
  two_factor_status_enabled: 'Enabled',
  two_factor_status_disabled: 'Disabled',
  two_factor_status_enabled_helper_text:'To use only email and password login, disable 2FA.',
  two_factor_status_disabled_helper_text:'To enable 2FA, complete the 2FA setup process.',
  disable_2fa: 'Disable 2FA',
  setup_2fa: 'Setup 2FA',
  reset_2fa: 'Reset 2FA',
  two_factor_reset_description: 'Moving to a new device? You will need to reset your two factor authentication before configuring it for the new device.',

  setup_two_factor_authentication: 'Setup Two Factor Authentication (2FA)',
  setup_two_factor_step1_title: '1. Download Google Authenticator for your phone',
  setup_two_factor_step2_title: '2. Set up account',
  setup_two_factor_step3_title: '3. Verify and Save',

  setup_two_factor_step2_text1: 'Please scan the following QR code OR enter this key',
  setup_two_factor_step2_text2: 'to set up your account. It is important to make sure that your phone has the correct time.',
  setup_two_factor_step3_text: 'Enter the verification code to confirm that your Two Factor Authentication has been set up correctly.',

  apple_app_store_alt: 'Apple App Store',
  google_app_store_alt: 'Google Play',

  verification_code: "Verification Code (required)",
  verification_code_placeholder: 'Enter verification code',
  verification_code_required_error: "Please enter the verification code.",

  verify_and_save: "Verify and Save",
  two_factor_code_error1: 'The validation failed. Please try again or ',
  two_factor_code_error_link1: 'generate a new barcode',
  two_factor_code_error2: ', scan it, and then try again.<br><br>' +
    'If you still cannot validate the code please contact your Proofpoint Social Media Protection administrator or ' +
    '<a target="_blank" href="https://proofpointcommunities.force.com/community/s/digital-risk">Proofpoint Social Media Protection technical support</a>.',

  disable_two_factor_action_title: 'Disable Two Factor Authentication',
  disable_two_factor_action_description: 'Are you sure you want to disable your Two Factor Authentication?',
  reset_two_factor_action_title: 'Reset Two Factor Authentication',
  reset_two_factor_action_description: 'Are you sure you want to reset your Two Factor Authentication?',

  change_password: 'Change Password',
  current_password: 'Current Password (required)',
  new_password: 'New Password (required)',
  confirm_new_password: 'Confirm New Password (required)',

  current_password_is_required: 'Current Password is required.',
  new_password_is_required: 'New Password is required.',
  confirmation_password_does_not_match: 'Confirm New Password does not match.',
  confirmation_password_is_required: 'Confirm New Password is required.',
  password_changes_saved: 'Your changes have been saved.',

  email_notifications_updated_success_message: "Email Notifications have been updated",

  email_notifications_config_title: 'Send me emails for the following:',

  social_discover_authorization_disclosure_title: 'Why connect your accounts to Proofpoint SocialDiscover?',
  social_discover_authorization_disclosure_body: 'Facebook, Twitter and YouTube will provide more accurate results when a current account holder requests a search with an authorized application. Letting Proofpoint SocialDiscover be an authorized application on your Facebook, Twitter or YouTube account allows us to search on your behalf and comply with terms and conditions set out by social network providers. Your activity in Proofpoint SocialDiscover will be completely anonymous. Your friends and connections will not be able to see that you are using Proofpoint.',

  tos_label: 'YouTube ToS',
  youtube_tos: "To revoke Social Discover\'s access to your YouTube data, click <a class='UnderlinedLink' href='https://myaccount.google.com/permissions' target='_blank'>here</a>",
  authorized_text: "{property} connected by {user_name} {time_ago} ago",

  social_entities: 'Social Accounts',

  global_authentication_settings_tab_title: 'Global Authentication Settings',
  global_email_domain_control_tab_title: 'Global Email/Domain Control',

  builtin_authentication_title: 'Built-in Authentication',
  builtin_authentication_subtitle: 'Customize your Patrol security settings or revert back to the default values.',

  global_two_factor_authentication_title: 'Global Two Factor Authentication (2FA)',
  global_two_factor_authentication_subtitle: 'Controls whether System users may optionally enable two-factor authentication or are required to do so. Note: If SSO is enabled below, two-factor authentication is required for any system user allowed to bypass SSO.',

  single_sign_on_title: 'Single Sign On Settings',

  min_password_length_label: 'Minimum Password Length',
  min_password_length_helper_text: 'Value must be at least 6.',
  password_regex_label: 'Password Regex',
  password_regex_helper_text: 'Do not include leading and trailing forward slashes (/).',
  password_message_label: 'Password Message',
  password_message_helper_text: 'Used to inform users about the password rules.',
  max_failed_logins_label: 'Failed Login Attempts',
  max_failed_logins_helper_text: 'Number of failed logins before a user account is locked.',
  expire_password_after_label: 'Days Until Password Expires',
  expire_password_after_helper_text: 'Number of days a password can be used before it must be changed.',
  session_timeout_in_label: 'Session Time Out Period',
  session_timeout_in_helper_text: 'Number of minutes until a session times out.',

  two_factor_required: '2FA Required',
  two_factor_optional: '2FA Optional',

  single_sign_on_enabled_label: 'Enable Single Sign On',

  saml_provider_label: 'Provider',
  saml_consumer_url_label: 'SAML Consumer URL',
  saml_idp_encryption_label: 'SAML Signature Algorithm',
  saml_idp_cert_fingerprint_label: 'SAML Certificate Fingerprint (required)',
  saml_idp_cert_fingerprint_helper_text: '',
  saml_idp_certificate_label: 'SAML Certificate (required)',
  saml_idp_certificate_helper_text: 'Only the SAML SHA Fingerprint is required if the Certificate is provided in the SAML Response. If not provided, the SAML Certificate is required and will be used to validate the SAML Response.',
  saml_idp_sso_target_url_label: 'SAML Endpoint (required)',
  enable_participant_sso_label: 'Enable Participant SSO.',
  cpum_sso_signin_endpoint_label: 'Participant SSO Access Endpoint',
  cpum_sso_signin_endpoint_placeholder: 'Enter custom string',
  disable_participant_unsigned_access_label: 'Disable Unauthenticated Participant Sign-up URL.',
  send_new_participants_welcome_email_label: 'Send newly created Participants a Welcome Email.',

  saml_idp_cert_fingerprint_is_required: 'SAML Certificate Fingerprint is required.',
  saml_idp_certificate_is_required: 'SAML Certificate is required.',
  saml_idp_sso_target_url_is_required: 'SAML Endpoint is required.',
  saml_idp_sso_target_url_length_error: 'SAML Endpoint must not exceed 255 characters.',

  global_authentication_settings_success_message: "Global Authentication Settings have been updated",

  system_notification_control_title: 'System Notification Control',
  user_login_email_control_title: 'User Login Email Control',
  patrol_installation_control_title: 'Patrol Installation Control',
  patrol_installation_control_subtitle: 'You can specify a list of email domains to restrict Patrol installation, or upload a specific list of allowed emails.',

  restricted_email_domains_label: 'Allowed Email Domains for Incident Notifications',
  restricted_email_domains_reports_label: 'Allowed Email Domains for Scheduled Report Recipients',
  allowed_email_domains_system_users_label: 'Allowed System User Email Domains',
  allowed_email_domains_participants_label: 'Allowed Participant User Email Domains',

  allowed_email_domains_patrol_installation_label: 'Allowed Email Domains for Patrol Installation',

  domains_helper_text: 'Domains should not include the at symbol (@), e.g. gmail.com, outlook.com. Multiple domains must be separated by commas.',

  upload_patrol_install_list_label: 'Upload Patrol Install List',
  use_to_restrict_patrol_installation_label: 'Use to restrict Patrol installation.',

  email_addresses_for_upload_summaries_label: 'Email Addresses to Receive Upload Summaries',
  email_addresses_for_upload_summaries_helper_text: 'Multiple email addresses must be separated by commas.',

  global_email_domain_settings_success_message: "Global Email/Domain Control has been updated",

  field_length_exceeded_error: "{field} must not exceed {length} characters.",
  invalid_emails_error: "Enter proper formatted email separated by commas",

  patrol_entities_title: 'Accounts',
  entities_text_search: 'Find an Account',
  include_hidden_entities: 'Show Hidden Accounts',

  patrol_entities_table_title: 'Accounts',

  policy_configuration_page: 'Master Policies',

  patrol_status: 'Patrol Status',
  patrol_status_active: 'Active',
  patrol_status_deactivated: 'Deactivated',
  patrol_status_expired: 'Expired',
  patrol_status_uninstalled: 'Uninstalled',

  enabled_features: 'Enabled Features',
  feature_activity_monitoring: 'Activity Monitoring Enabled',
  feature_profile_monitoring: 'Profile Monitoring Enabled',
  feature_archive_options: 'Archive Options Enabled',
  feature_workflow_disabled: 'Workflow Disabled',
  feature_workflow_outbound: 'Workflow: Review Outbound Activity (based on policy)',
  feature_workflow_outbound_inbound: 'Workflow: Review Outbound/Inbound Activity (based on policy)',
  feature_workflow_all_outbound: 'Workflow: Review All Outbound Activity (unless auto-rejected)',

  profile_status: 'Profile Status',

  managed_email: 'Managed Email',

  must_match_all_tags: 'Must match all selected Tags',

  batch_actions: 'Batch Actions',

  account_action_deactivate: 'Deactivate',
  account_action_deactivate_confirm: 'Deactivate Account',
  account_action_deactivate_description: 'Are you sure you want to deactivate Patrol for the selected accounts?',
  account_deactivate_title: "{selection_counter, plural, =1 {Deactivate Patrol} other " +
    "{Deactivate Patrol for {selection_counter} Accounts }}",

  account_action_batch_deactivate: 'Deactivate Patrol',

  account_action_batch_install: 'Re-Install Patrol',
  account_action_batch_install_description: 'For the selected Accounts, you may optionally choose a Policy Configuration.',

  account_action_batch_uninstall: 'Uninstall Patrol',

  account_action_uninstall: 'Uninstall',
  account_action_uninstall_confirm: 'Uninstall Patrol',
  account_action_uninstall_description: 'Are you sure you want to uninstall Patrol from this account? This cannot be undone.',
  account_uninstall_title: "{selection_counter, plural, =1 {Uninstall Patrol} other " +
    "{Uninstall Patrol for {selection_counter} Accounts }}",

  account_action_delete: 'Delete Account',
  account_action_delete_confirm: 'Delete Permanently',
  account_action_delete_description: "<span class='WarningDialog'>WARNING:</span> You are about to delete this account and all of the content that has been captured for this entity from the Patrol database. This action cannot be reversed. <br/> <br/> The deletion process may also take some time to complete. You will receive a confirmation email upon completion.",
  account_delete_title: 'Delete Account',
  account_delete_reason: 'Delete Reason (required)',
  account_delete_reason_helper: 'You must record a reason for this action (500 characters max).',

  account_action_move: 'Move Account',
  account_action_move_confirm: 'Move Account',
  account_move_title: "{selection_counter, plural, =1 {Move Account} other " +
    "{Move {selection_counter} Accounts }}",
  account_action_move_description: 'In order to move the selected Accounts, select the destination Subtenant and Policy Configuration to apply.',

  account_action_batch_move: 'Move Accounts',

  account_action_activate: 'Re-Activate Patrol',
  account_action_activate_confirm: 'Re-Activate Patrol',
  account_action_activate_description: 'For this account, you may optionally choose a Policy Configuration. Entities with expired authorization will not be re-activated.',
  account_activate_title: "{selection_counter, plural, =1 {Re-Activate Patrol} other " +
    "{Re-Activate Patrol for {selection_counter} Accounts }}",

  account_action_batch_activate: 'Re-Activate Patrol',
  account_action_batch_activate_description: 'For the selected Accounts, you may optionally choose a Policy Configuration. Accounts with expired authorization will not be activated.',

  account_action_apply_entity_config: 'Apply Master policy',
  account_action_apply_entity_config_confirm: 'Apply Master policy',
  account_action_apply_entity_config_description: 'Select the Master policy you would like to apply to the selected accounts.',
  account_apply_entity_config_title: "{selection_counter, plural, =1 {Apply Master policy} other " +
    "{Apply Master policy to {selection_counter} Accounts }}",

  account_action_batch_apply_config: 'Apply Master policy',

  account_action_install: 'Re-Install Patrol',
  account_action_install_confirm: 'Re-Install Patrol',
  account_action_install_description: 'For this account, you may optionally choose a Policy Configuration',
  account_install_title: 'Re-Install Patrol',

  account_action_hide: 'Hide Account',
  account_action_hide_confirm: 'Hide Account',
  account_action_hide_description: 'Are you sure you want to hide this account?',
  account_hide_title: "{selection_counter, plural, =1 {Hide Account} other " +
    "{Hide {selection_counter} Accounts }}",

  account_action_unhide: 'Unhide Account',
  account_action_unhide_confirm: 'Unhide Account',
  account_action_unhide_description: 'Are you sure you want to unhide this account?',
  account_unhide_title: "{selection_counter, plural, =1 {Unhide Account} other " +
    "{Unhide {selection_counter} Accounts }}",

  account_action_send_profile_revision_reminder: 'Remind of Revision Required Profiles',
  account_profile_reminder_title: 'Remind Profile Revisions Required',
  account_profile_reminder_customization: 'You can customize this notification in the Account Owner Notifications page.',
  account_action_profile_reminder_description: 'The system will individually email each account owner with profiles in the Revision Required state',
  account_action_profile_reminder_confirm: 'Remind Profile Revisions Required',

  account_action_batch_send_profile_revision_reminder: 'Remind of Revision Required Profiles',

  policy_configuration: 'Master policy',
  select_policy_configuration: 'Select a Master policy',

  show_chart_view: 'Show Chart View',
  hide_chart_view: 'Hide Chart View',

  filter_by_entity_types: 'Filter By Account Types',
  filter_by_patrol_status: 'Filter By Patrol Status',
  filter_by_profile_status: 'Filter By Profile Status',

  export_accounts: 'Export Accounts',

  active_operation_moving: 'Moving...',
  active_operation_deleting: 'Deleting...',
  active_operation_activating: 'Re-Activating...',
  active_operation_deactivating: 'Deactivating...',
  active_operation_uninstalling: 'Uninstalling...',
  active_operation_installing: 'Re-Installing...',
  active_operation_updating: 'Applying Master Configuration...',
  account_hidden_mark: '(Hidden)',

  //landing routes
  landing: "landing",
  pivot: "pivot",
  customer_support: "customer_support",
  set_support_customer: "set_support_customer",
  download_breach_email_addresses: "download_breach_email_addresses",
  download_darknet_credit_cards: "download_darknet_credit_cards",
  add_content_context: "add_content_context",
  review_item: "review_item",
  redirect_to_profile_review: "redirect_to_profile_review",
  register: "register",
  sign_in: "sign_in",
  proofpoint_sign_in: "proofpoint_sign_in",
  customer_file: "customer_file",
  customer_file_bin: "customer_file_bin",
  customer_file_takedown_evidence: "customer_file_takedown_evidence",
  customer_file_upload: "customer_file_upload",
  configuration_v2: "configuration_v2",
  entities_expired: "entities_expired",
  connector_config_install: "connector_config_install",
  connector_config_success: "connector_config_success",
  teams_certificate: "teams_certificate",
  cpum_csv_upload: "cpum_csv_upload",

  //tenant_management
  subtenant_management: "Subtenant Management",
  create_new_sub_tenant: "Create New Subtenant",
  search_by_subtenant_name: "Search by subtenant name",
  sub_tenant_name: "Subtenant Name",
  sub_tenant_name_required: "Subtenant Name (required)",
  assigned_users: "Assigned Users",
  time_zone: "Time Zone",
  sub_tenants: "Subtenants",
  db_retention_period: "Patrol Database Retention Period",
  edit_retention_period: "Edit Retention Period",
  db_retention_period_warning: "WARNING: You are about to change the Patrol database retention settings. By changing this value, the existing purge date for all existing content will be re-calculated. This may lead to existing data being instantly deleted if the value you set results in a purge date in the past.\n",
  db_retention_period_warning2: "If you are certain you wish to make this change, please enter your reason below, and confirm.",
  patrol_db_retention_period: "Patrol Database Retention Period (required)",
  update_db_retention_period: "Update Database Retention Period",
  retention_period_helper: "Must be an integer value between 12 and 120 (months).",
  reason_helper: "Must be between 6 and 500 characters in length.",
  edit_db_retention_period_dialog_title: "Edit Patrol Database Retention Period",
  update_db_retention_period_dialog_title: "Update Patrol Database Retention Period",
  edit_subtenant: "Edit Subtenant",
  clone_subtenant: "Clone Subtenant",
  view_selective_capture_id: "View Selective Capture ID",
  selective_capture_id: "Selective Capture ID",
  copy_selective_capture_id: "Copy Selective Capture ID",
  subtenant_to_clone: "Subtenant to Clone",
  new_subtenant_name: "New Subtenant Name (Required)",
  delete_subtenant: "Delete Subtenant",
  create_subtenant: "Create Subtenant",
  enter_subtenant_name: "Enter Subtenant name",
  select_more_users: "Select one or more users",
  select_more_options: "Select one or more options",
  subtenant_provide_a_name: "This field is required",
  subtenant_with_invalid_length : "Subtenant Name must not exceed 256 characters.",
  select_assigned_users: "Select atleast one assigned user",
  subtenant_destroy_dialog_text: "Are you sure you want to delete subtenant: {name}? This operation cannot be undone.",
  edit_subtenant_success_message: "Subtenant {name} has been updated",
  create_subtenant_success_message: "Subtenant {name} has been created",
  edit_retention_period_success_message: "Retention Period for Subtenant \"{name}\" has been updated.",
  edit_batch_retention_period_success_message: "Retention Period for {counter} Subtenants has been updated.",
  audits_table_title: "{results_count, plural, =1 {{results_count} Event} other {{results_count} Events}}",
  export_audits_modal_title: 'Export to CSV',
  export_audits_modal_description: 'The CSV file containing the requested exported data will be downloaded as soon as it has been created, which may take more than a minute. Please confirm that you want to proceed.',
  export_audits_modal_confirm_button: 'Export to CSV',
  cannot_delete_parent_subtenant: "This Subtenant is also the Parent Subtenant and cannot be deleted.",
  cannot_delete_same_current_customer: "This is the Subtenant you are currently using. Please change to another Subtenant if you wish to delete it.",

  date_of_change: "Date of Change",
  audit_changes: "Changes",

  audit_entry_profile_policy_v3: 'Profile Policy',
  audit_entry_profile_lock_notification: 'Profile Notification',
  audit_entry_disclaimer: 'Disclaimer Set',
  audit_entry_patrol_policy: 'Content Policy',
  audit_entry_exclusion_rule_set: 'Classifier Exemptions',
  audit_entry_language_based_exemption: 'Language-Based Exemptions',
  audit_entry_custom_policy: 'Custom Classifier',
  audit_entry_account: 'Account',
  audit_entry_entity: 'Entity',
  audit_entry_brand: 'Brand',
  audit_entry_person: 'Person',
  audit_entry_place: 'Location',
  audit_entry_api: 'API',
  audit_entry_application_policy: 'Application Policy',
  audit_entry_archive: 'Archive',
  audit_entry_archive_credential: 'Archive',
  audit_entry_audit_credential: 'SIEM',
  audit_entry_comment: 'Comment',
  audit_entry_commenter_list: 'Commenter List',
  audit_entry_commenter_policy: 'Commenter Policy',
  audit_entry_content: 'Content',
  audit_entry_incident: 'Incident',
  audit_entry_official_disclosure: 'Official Disclosure',
  audit_entry_patrol: 'Patrol',
  audit_entry_profile_lock: 'ProfileLock',
  audit_entry_protect: 'Protection',
  audit_entry_submitted_content: 'Submitted Content',
  audit_entry_workflow: 'Workflow',
  audit_entry_syndicate_content: 'Syndicate Content',
  audit_entry_syndicate_config: 'Syndicate Configuration',
  audit_entry_team: 'Team',
  audit_entry_patrol_config: 'Patrol Config',
  audit_entry_notification_template: 'Notification Policy',
  audit_entry_notification_setting: 'Notification Setting',
  audit_entry_email_customization: 'Email Customization',
  audit_entry_user: 'User',
  audit_entry_syndicate_landing: 'Syndicate Landing Page',
  audit_entry_syndicate_user: 'Syndicate User',
  audit_entry_customer_image_library: 'Image Library',
  audit_entry_customer_image: 'Image',
  audit_entry_tag: 'Tag',
  audit_entry_user_role: 'Role',
  audit_entry_company: 'Company',
  audit_entry_customer: 'Customer',
  audit_entry_client: 'Subtenant',
  audit_entry_subtenant: 'Subtenant',
  audit_entry_search: 'Discover',
  audit_entry_saved_search: 'Discover',
  audit_entry_search_result_node: 'Search Result',
  audit_entry_mobile_saved_search: 'Mobile Discover',
  audit_entry_global_lockdown: 'Global Social Lockdown',
  audit_entry_profile_policy: 'Profile Policy',
  audit_entry_profile_manager: 'Profile Manager',
  audit_entry_customer_digital_stake_out_event: 'Security Event',
  audit_entry_review_profile_change: 'Review Profile Change',
  audit_entry_review_profile_expiration: 'Review Profile Expiration',
  audit_entry_review_profile_prereview: 'Profile Pre-review',
  audit_entry_review_profile_change_auto_revert: 'Profile Change Review Auto Revert',
  audit_entry_review_profile_change_submission: 'Profile Change Review Submission',
  audit_entry_pre_review_profile_revert_unauthorized_change: 'Review Profile Revert Unauthorized Change',
  audit_entry_pre_review_profile_pre_approved_change: 'Pre-review Profile Pre Approved Change',
  audit_entry_post_review_profile_auto_remove_change: 'Post-review Profile Auto Removed Change',
  audit_entry_profile_change_flap: 'Profile Change Detected As Flap',
  audit_entry_profile_change_flood: 'Profile Change Detected As Flood',
  audit_entry_profile_change_reverted_flood: 'Reverted Unauthorized Change Detected As Flood',
  audit_entry_profile_change_reverted_flap: 'Reverted Unauthorized Change Detected As Flap',
  audit_entry_customer_web_url: 'Customer Web Url',
  audit_entry_customer_protected_domain: 'Customer Protected Domain',
  audit_entry_submitted_event: 'Submitted event',
  audit_entry_submitted_untyped_event: 'Submitted Untyped Event',
  audit_entry_profile_content: 'Profile Content',
  audit_entry_web_takedown: 'Web Takedown',
  audit_entry_social_takedown: 'Social Takedown',
  audit_entry_mobile_takedown: 'Mobile Takedown',
  audit_entry_social_takedown_vendor_config: 'Social Takedown Destination Config',
  audit_entry_mobile_takedown_vendor_config: 'Mobile Takedown Destination Config',
  audit_entry_web_takedown_vendor_config: 'Web Takedown Destination Config',
  audit_entry_policy_template: 'Policy Template',
  audit_entry_customer_install_request: 'Master Policy',
  audit_entry_domain_alert: 'Domain Alert',
  audit_entry_domain_alert_rule: 'Domain Alert Rule',
  audit_entry_domain_tag_alert: 'Domain Tag Alert',
  audit_entry_content_spike: 'Commenter Content Spike Notifications',
  audit_entry_profile_review_notification: 'Profile Review Notification',
  audit_entry_disclaimer_added_to_profile: 'Disclaimer added to profile',
  audit_entry_auto_approved_profile_attribute: 'Profile auto approved attribute',
  audit_entry_profile_api_request: 'Profile API Request',
  audit_entry_review_profile_full_prereview: 'Review Profile Full Pre-review',
  audit_entry_review_profile_full_expiration_review: 'Review Profile Full Expiration Review',
  audit_entry_user_task: 'User Task',
  audit_entry_review_profile_post_review: 'Review Profile Post Review',
  audit_entry_user_email_opt_in: 'User Email Opt-In',
  audit_entry_user_email_opt_out: 'User Email Opt-Out',
  audit_entry_participant: 'Participant User',
  audit_entry_rra_exclusion_rule: 'RRA Exclusion Rule',
  audit_entry_message_exclusion_rule_set: 'Message Exclusion Rule',
  audit_entry_classifier_review: 'Auditor',
  audit_entry_review_codes: 'Review Codes',

  entry_types: "Type",

  confirmation_unsaved_title: "Unsaved Changes Warning",
  confirmation_unsaved_text: "Do you want to save your changes before exiting this page? Unsaved changes cannot be restored after exiting this page.",
  confirmation_unsaved_continue_button: "Exit Without Saving",

  last_reviewed: 'Last Reviewed',
  on: 'on',
  review_result: 'Review Result',
  profile_expires: 'Profile Expires',

  pm_field_status_APPROVE: 'Approved',
  pm_field_status_AUTO_APPROVE: 'Auto-Approved',
  pm_field_status_REJECT: 'Rejected',
  pm_field_status_NOT_REVIEWED: 'Not Reviewed',

  show_only_sections_requiring_review: 'Show Only Sections Requiring Review',
  show_before_value_column: 'Show Before Value Column',
  show_row_quick_actions: 'Show Row Quick Actions',
  show_only_sections_requiring_review_tooltip: 'All sections must be reviewed for onboarding, expiration or reviewer-generated profile reviews.',

  readonly_field_tooltip: 'Updates to this field cannot be made via Proofpoint Social Patrol, please refer to your company’s policies for guidance.',

  review_configuration_title: "Review Configuration",
  archive_config_title: "Archive Configuration",
  archived_accounts_tab: "Archived Accounts",
  archive_connector_settings: "Archive Connector Settings",
  archive_connector: "Archive Connector",
  archive_connector_enabled: "Archive Connector Enabled",
  archive_connector_not_configured: "Archive Connector Not Configured",
  archive_connector_disabled: "Archive Connector Disabled",
  archive_connector_to_enable: "To enable, please contact your Proofpoint representative or go to",
  patrol_archive_enabled: "Patrol Archive Enabled",
  patrol_archive: "Patrol Archive",
  patrol_archive_not_licensed: "Patrol Archive is not Licensed",
  patrol_archive_retention_period: "Retention Period",
  patrol_archive_auto_archive_all: "Automatically archive all protected accounts.",
  patrol_archive_historical_content: "Archive all historical content.",
  patrol_archive_contact_note: "To disable Patrol Archive, contact your Proofpoint representative or go to",
  archive_mailbox: "Mailbox",
  archive_mailbox_placeholder: "Enter email for archiving",
  archive_mailbox_required: "Email address is required",
  archive_journal_mailbox: "Journal Mailbox",
  archive_deliver_to_account_owner: "Also deliver archive messages to account owner",
  archive_provider: "Provider",
  archive_other_archives: "Other Archives",
  archive_accounts: "Accounts",
  archive_auto_archive_all: "Automatically archive all protected accounts.",
  archive_historical_content: "Archive all historical content.",
  archive_historical_content_tooltip: "The retention period for historical content begins when the content is archived",
  archive_enable_journal_report: "Enable Journal Report Format.",
  archive_disable_archiving: "Disable Archiving",
  archive_enable_archiving: "Enable Archiving",
  archive_test_configuration: "Test Configuration",
  archive_test_message: "Test Message",
  archive_test_configuration_description: "To test your configuration, enter an email address registered with your archive. Proofpoint will send a generic test message to ensure we can successfully deliver real messages.",
  archive_registered_from_email: "Registered \"From\" Email Address",
  archive_test_email_required: "Email address is required",
  archive_enter_email_address: "Enter email address",
  archive_send_test_message: "Send Test Message",
  archive_archived: "Archived",
  archive_col_account_name: "Account Name",
  archive_col_account_type: "Account Type",
  archive_col_description: "Description",
  archive_col_managed_email: "Managed Email",
  archive_col_enabled_features: "Enabled Features",
  archive_no_accounts_archived: "No Accounts Archived",
  archive_archived_account: "Archived Account",
  archive_archived_accounts: "Archived Accounts",
  archive_test_success: "Test message sent successfully.",
  archive_test_failed: "Test message failed. Please check your configuration.",
  archive_config_saved: "The archive configuration was saved.",
  archive_enabled_success: "Archiving was enabled successfully.",
  archive_disabled_success: "Archiving was disabled successfully.",
  review_configuration: "Review Configuration",
  archive_configuration: "Archive Configuration",
  general_settings_tab: "General Settings",
  review_codes_tab: "Review Codes",
  review_codes: "Review Codes",
  review_code_type: "Review Code Type",
  select_one_or_more_types: "Select one or more types",
  review_code_REJECTION: "Rejection Code",
  review_code_APPROVAL: "Approval Code",
  review_code_MARK_REVIEWED: "Mark Reviewed Code",
  review_code_description: "Review Code Description",
  enter_review_code: "Enter code",
  enter_code_description: "Enter Description",
  code_updated_at: "Last Updated",
  add_review_code: "Add Review Code",
  delete_review_code: "Delete Review Code",
  edit_review_code: "Edit Review Code",
  review_code_cannot_be_modified: "Review Code Type can no longer be modified for this Review Code because it has already been used in one or more reviews.",
  code_required: "Code Required",
  invalid_duplicate_review_code: "Code is already in use",
  invalid_review_code_length: "Invalid review code length",
  invalid_review_code_description_length: "Invalid code description length",
  invalid_review_code_type: "Select review code type(s)",
  review_code_edited_msg: "The review code {code} with description {description} has been updated successfully.",
  review_code_created_msg: "The review code {code} with description {description} has been created successfully.",
  delete_review_code_description: "Are you sure you want to delete this Review Code? This operation cannot be undone.",
  review_code_delete_msg: "The review code was successfully deleted.",
  enable_review_tasks_auto_assign: "Enable automatic self-assignment when viewing unassigned tasks.",
  enable_review_tasks_auto_assign_helpertext: "When enabled, as reviewers click to view each task that does not already have an assignee, the task will be assigned to the reviewer opening the task.",
  enable_review_codes: "Enable Review Codes.",
  enable_review_codes_helpertext: "When enabled, a list of predefined “review codes” will be available when actioning a task.",
  general_settings_save_changes: "Save Changes",
  general_settings_saved: "Changes to General Settings have been saved.",

  choose_image: "Choose Image",
  remove_image: "Remove Image",

  review_history: "Review Action History",
  review_action_history: "Review Action History",
  empty_field_review_history: "There are no Review Entries for this field",

  invalid_field_value_warning: "This value has an error that requires manual revision. You will need to correct this error before completing the review.",

  reviewer_notes_saved: "Reviewer notes saved.",
  add_field_note: "Add Field Note",

  pre_approved: 'Pre-approved',
  reviewer_edit: 'Reviewer Edit',

  undo_reviewer_changes: 'Undo Reviewer Changes',
  reviewer_changes_undone: 'Reviewer Changes have been reverted',

  view_notes: 'View Notes',

  review_status_new: 'Unreviewed',
  review_status_started: 'Started',
  review_status_completed: 'Completed',
  review_status_cleared: 'Completed',

  field_notes_alert: 'Notes are only visible to other reviewers and are not visible to the account owner',
  profile_manager_external_alert: 'Any feedback added will be visible to the account owner when the review is finalized.',
  overall_feedback: 'Overall Feedback',
  reject_feedback_optional: 'Reject Feedback (optional)',
  feedback_optional: 'Feedback (optional)',
  section_feedback_optional: 'Section Feedback (optional)',
  remove_section: 'Remove Section',
  feedback: 'Feedback',

  reviewer_generated_review: 'Reviewer Generated Review',
  system_generated_review: 'System Generated Review',

  share_profile_review: 'Share Profile Review',
  export_profile_review: 'Export to PDF',
  include_internal_notes: 'Include Internal Notes',
  message: 'Message',
  share_review_notes_helper_text: 'This text will appear in the email body above the profile review.',
  profile_review_shared_success: 'Profile Review shared successfully.',
  profile_review_shared_subject: '{username} Has Shared a Previously Completed Profile Review With You',

  edit_profile: 'Edit Profile:',

  unsubmitted_profile_alert: 'FYI: Unsubmittted profile edits will be cleared in {time_left}. New sessions begin midnight Eastern Standard Time.',

  submit_changes: 'Submit Changes for Review',
  submit_changes_title: 'Submit Changes for Review',
  submit_changes_description: "Your updates will be submitted for processing in accordance with your organization's profile review policy. You can continue to submit changes to your profile until a reviewer begins the review.",
  submit_changes_confirm: 'Continue',

  profile_update_process_title: 'Profile Submission',
  profile_update_process_greeting: 'Hello,',
  profile_update_process_warning: "As per your company's policy, any updates to your profile need to be reviewed and approved before they can be published on your social profiles. If the social network you want to update is not listed, please refer to your company's policy for instructions on how to make updates to the profile. ",
  profile_update_process_description: 'To update your profile, click on a social network from the provided link(s) and sign in. Then, fill out the Profile Submission form with your updates. Once finished, click the "Submit Changes for Review" button to send your proposed changes for review. After the review process is complete, you will receive an email summarizing the status of your profile changes.',

  sign_in_FB: 'Sign in to Facebook',
  sign_in_LI: 'Sign in to LinkedIn',
  sign_in_TW: 'Sign in to Twitter',
  sign_in_GB: 'Sign in to Google Business',

  profile_pre_review: 'Profile Submission:',
  completed_reviews_header: "Completed Reviews (showing last {reviews_to_display} of {reviews_total} total)",

  compliance_id: 'Compliance ID',
  started: 'Started',
  completed: 'Completed',

  back_to_sign_in: 'Back to Sign In',
  update_your_profile: 'Update Your Profile',

  error_updating_profile_title: 'Cannot Update Your Profile',
  generic_error_update_profile: 'An unknown error has occurred. Modifying your profile is not permitted at this time.',

  error_submitting_profile_title: 'Your Form Needs a Refresh',

  submission_complete_title: 'Submission Complete',
  submission_complete_description: 'Your changes have been successfully submitted. You will receive an email confirmation when processing is complete.',

  pre_review_error_profile_manager_not_enabled: 'Modifying your profile is not permitted at this time. Profile Manager may have been uninstalled from this account or may have an expired authorization.',
  pre_review_error_pre_review_not_enabled: 'Your account is not configured to use pre-review for profile changes. You can edit your profile on the social network directly.',
  account_last_updated: 'Last Updated:',
  profile_will_expire: 'Profile will expire {expire_in_words} ({expiration_date})',
  profile_expired: 'Profile expired {expire_in_words} ({expiration_date})',

  select_account_description: "Multiple pages are associated with your Facebook account {account_name}. Please select one to continue:",
  back: 'Back',

  revision_required_info_title: 'Your profile requires revisions',
  revision_required_info_subtitle: 'One or more sections were rejected during your previous review and require updates. Please revise the sections and feedback below to resubmit for approval.',
  overall_review_feedback: 'Overall Review Feedback',
  rejected_section_value: 'Rejected Section Value',
  rejected_field_tooltip: 'This field was rejected in the previous review',
  rejected_section_tooltip: 'One or more entries in this section were rejected in the previous review',
  see_more: 'See more',
  see_less: 'See less',
  section_feedback: 'Section Feedback',

  profile_field_suffix_compliance_id: "Compliance ID",
  profile_field_suffix_disclaimer: "Disclaimer",
  profile_field_suffix_url_prefix: "URL Prefix",

  review_error_ERROR_FIELD: "We could not load the profile review because an invalid data format was submitted for one or more fields. To resolve this issue, please contact the support team and include the following Task ID: {task_id}",
  review_error_ERROR_EXPIRED: "We could not load the profile review because Patrol is not connected to the account anymore. Please ask the account owner to reauthorize Patrol.",
  review_error_ERROR_GENERIC: "To resolve this issue, please contact the support team and include the Task ID {task_id}",

  token_expired: "Token Expired",

  mea_content_html: "Marketing Email HTML",
  email_body: "Email Body",

  create_new_team: "Create New Team",
  manage_teams: "Team Management",
  save_team: "Save Team",
  team_name: "Team Name",
  also_send_notifications_to: "Also Send Notifications To",
  team_members: "Team Members",
  one_or_more_emails: "one or more emails",
  team_email_helper_text: "Use commas to separate multiple values",
  invalid_team_email: "Enter proper formatted email separated by commas",
  invalid_domain: "The following domains were rejected: {rejected_domains}",
  invalid_team_members: "Please provide at least one user to this team",
  edit_team_title: "Edit Team : {name}",
  delete_team:"Delete Team",
  edit_team: "Edit Team",
  delete_team_dialog_text: "Are you sure you want to delete team: ''{name}''?  This operation cannot be undone.",
  create_team_success_message : "{name} has been created",
  edit_team_success_message: "{name} has been updated",

  account_owner_notifications: "Account Owner Notifications",
  branding_settings: "Branding Settings",
  notification_settings: "Notification Settings",
  notification_preview: "Notification Preview",
  notification_name: "Notification Name",
  notifications_title: 'Account Owner Notifications',
  patrol_config_title: 'Patrol Configuration',
  incident_notifications_tab: 'Incident Notifications',
  content_notifications_title: 'Incident Notifications',
  cn_create_button: 'Create Incident Notification',
  cn_create_title: 'Create Incident Notification',
  cn_edit_title: 'Edit Incident Notification',
  cn_col_name: 'Name',
  cn_col_accounts_using: 'Accounts Using Policy',
  cn_col_entity_config_using: 'Entity Configs Using Policy',
  cn_col_last_modified: 'Last Modified',
  cn_action_edit: 'Edit Incident Notification',
  cn_action_duplicate: 'Duplicate Incident Notification',
  cn_action_delete: 'Delete Incident Notification',
  cn_form_title: 'Incident Notification',
  cn_name_label: 'Name',
  cn_name_placeholder: 'Enter notification name',
  cn_notification_rules: 'Notification Rules',
  cn_rules_helper: 'At least one rule must be specified. At least one recipient must be specified for each rule.',
  cn_for: 'For',
  cn_all_incidents: 'All Classifications',
  cn_all_actions: 'All Actions',
  cn_and: 'and',
  cn_notify: 'notify',
  cn_classified_as: 'Classified As',
  cn_for_actions: 'For Actions',
  cn_selected_users: 'Users',
  cn_select_users: 'Select users...',
  cn_selected_teams: 'Teams',
  cn_select_teams: 'Select teams...',
  cn_additional_emails: 'Additional Email Addresses',
  cn_additional_emails_placeholder: 'Enter email addresses separated by commas',
  cn_add_rule: '+ Add Rule',
  cn_delete_rule: 'Delete Rule',
  cn_save_notification: 'Save Incident Notification',
  cn_delete_notification: 'Delete',
  cn_category_all: 'All Classifications',
  cn_action_all: 'All Actions',
  cn_action_notify: 'Notify',
  cn_action_hide: 'Hide',
  cn_action_delete_action: 'Delete',
  cn_include_commenter_content: 'Send notifications for commenter content and not a daily summary.',
  cn_brand_content_summary: "Send a daily summary for brand content and don't send notifications.",
  cn_save_error: 'An error occurred while saving. Please try again.',
  cn_delete_error: 'An error occurred while deleting. Please try again.',
  cn_delete_dialog_title: 'Delete Incident Notification',
  cn_delete_dialog_body: 'Are you sure you want to delete "{name}"? This action cannot be undone.',
  cn_delete_dialog_confirm: 'Delete',
  cn_created_message: '"{name}" has been created.',
  cn_updated_message: '"{name}" has been updated.',
  cn_deleted_message: '"{name}" has been deleted.',
  overview_pages_tab: 'Install Overview Pages',
  op_new_page: 'New Page',
  op_new_page_title: 'New Install Overview Page',
  op_create_button: 'Create Install Overview Page',
  op_create_title: 'New Install Overview Page',
  op_edit_title: 'Edit Install Overview Page',
  op_col_name: 'Name',
  op_col_last_modified: 'Last Modified',
  op_action_edit: 'Edit Install Overview Page',
  op_action_delete: 'Delete Install Overview Page',
  op_section_label: 'Install Overview Pages',
  op_select_or_create: 'Select a page from the list or create a new one.',
  op_markdown_helper: 'Overview Pages can be formatted using Markdown.',
  op_name_label: 'Name',
  op_name_placeholder: 'Enter page name',
  op_content_label: 'Content',
  op_content_placeholder: 'Enter Markdown content...',
  op_create_page: 'Create Install Overview Page',
  op_save_page: 'Save Install Overview Page',
  op_delete_page: 'Delete Install Overview Page',
  op_untitled: 'Untitled Page',
  op_preview_link: 'Overview Page Preview',
  op_preview_dialog_title: 'Overview Page Preview',
  op_delete_dialog_title: 'Delete Install Overview Page',
  op_delete_dialog_body: 'Are you sure you want to delete "{name}"?',
  op_delete_dialog_confirm: 'Delete',
  op_created_message: 'Install Overview Page "{name}" was created',
  op_updated_message: 'Install Overview Page "{name}" was updated',
  op_deleted_message: 'Install Overview Page "{name}" was deleted',
  notifications_table_title: 'Notifications',

  branding_settings_parent_warning: 'This is the parent subtenant. All child subtenants will inherit customizations made here, unless Branding Settings Inheritance is disabled within the child subtenant.',
  branding_settings_disabled_warning: 'Customised Branding disabled as no Email Domains entered via the Admin Application.',
  branding_settings_children_enabled_warning: 'The Branding settings of this subtenant are currently inherited from the parent subtenant. If inheritance is disabled, this subtenant will initially retain the inherited Branding settings until they are further customized here.',
  branding_settings_disabled_info: 'Branding is not enabled in this tenant. You may still customize several aspects of each notification, but none of the branding elements. <a href="https://help.proofpoint.com/DigitalRisk/Documentation/Account_Owner_Notifications" target= \"_blank\">Learn more</a>',
  branding_set_from_email_info: 'You can only change the settings below if setting a custom From address.',
  branding_copyright_enabled: 'Include copyright (© {year} Proofpoint, Inc.) in notification footer',
  restore_defaults: 'Restore Defaults',

  branding_inheritance_enabled: 'Branding Inheritance Enabled',
  branding_edit_mode: 'Set custom From address',
  branding_inheritance_enabled_helper: 'With Branding Inheritance Enabled, all changes to these notifications must be made in the parent subtenant. Disable this option to customize notifications for this subtenant only.',
  branding_from_email_name: 'Email Display Name (required)',
  branding_from_email_name_hint:'This will appear before the email in the From field.',
  branding_from_email_name_placeholder: 'Enter display name',
  branding_from_email_local_part: 'Email Local-Part (required)',
  branding_from_email_domain: 'Email Domain (required)',
  branding_from_email: 'From Address',
  branding_email_from_local_part_placeholder: 'e.g. no-reply',
  branding_product_name: 'Product Name',
  branding_product_name_helper_text: 'The product name is displayed in the upper right hand corner of all notifications.',
  branding_from_email_name_is_required: 'Email Display Name is required',
  branding_from_email_is_required: 'From Address is required',
  notification_logo: 'Notification Logo',
  upload_notification_logo_description: 'Logo must be in svg format. Logo size must be a maximum of 60 pixels in height and 300 pixels in width.',
  branding_settings_update_success_message: 'Branding Settings have been updated',
  preview_send_success_message: 'Preview has been sent',
  re_enable_inheritance_dialog_title: 'Re-enable Branding Settings Inheritance',
  re_enable_inheritance_dialog_warning: 'You are about to re-enable Branding Settings Inheritance. This action will cause this subtenant to inherit the Branding  settings from the parent, and permanently delete any customizations made here.',
  re_enable_inheritance_dialog_text: 'Are you sure you want to re-enable Branding Settings inheritance? This action cannot be undone.',
  re_enable_inheritance_dialog_confirm: 'Re-enable Inheritance',

  replace_not_allowed_tags_dialog_title: 'Unsupported Tags or Attributes detected',
  replace_not_allowed_tags_dialog_warning: 'Unsupported Tags or Attributes were detected in your text. The following Tags or Attributes have been removed and the content has been sanitized for safety: ',
  replace_not_allowed_tags_dialog_text: 'Click the Tooltip to view the list of supported Tags and Attributes.',
  replace_not_allowed_tags_dialog_confirm: 'Continue',
  supported_tags: 'Supported tags',
  supported_attrs: 'Supported attributes',

  disable_template_inheritance_dialog_title: 'Disable Inheritance Confirmation',
  disable_template_inheritance_dialog_warning: 'You are about to disable inheritance for this notification. This means that any changes made within the parent subtenant for this notification will no longer be inherited.',
  disable_template_inheritance_dialog_text: 'Are you sure you want to disable inheritance? This action cannot be undone.',
  disable_template_inheritance_dialog_confirm: 'Disable Inheritance',

  re_enable_template_inheritance_dialog_title: 'Re-enable Inheritance Confirmation',
  re_enable_template_inheritance_dialog_warning: 'You are about to re-enable Notification Inheritance. This action will overwrite any modifications made to this notifications settings with the settings within the parent subtenant.',
  re_enable_template_inheritance_dialog_text: 'Are you sure you want to re-enable inheritance for this notification? This action cannot be undone.',
  re_enable_template_inheritance_dialog_confirm: 'Re-enable Inheritance',

  restore_default_template_dialog_title: 'Restore Default Notification Settings',
  restore_default_template_dialog_warning: 'You are about to restore the default Patrol settings to this notification. This will restore the notifications options, subject, and body content to the Proofpoint defaults.',
  restore_default_template_dialog_text: 'Are you sure you want to restore defaults? This action cannot be undone.',
  restore_default_template_dialog_confirm: 'Restore Defaults',

  notifications_action_re_enable_inheritance: 'Re-enable Inheritance',
  notifications_action_disable_inheritance: 'Disable Inheritance',
  notifications_action_edit: 'Modify Notification',
  notifications_action_preview: 'Send Preview Notification',
  checkbox_bcc_to_system_users: 'Bcc this notification to system users',
  checkbox_include_reviewer_name: 'Include Reviewer Name',
  checkbox_include_policy_matches: 'Include Policy Matches',

  notification_field_subject: 'Email Subject (required)',
  notification_field_title_text: 'Email Title Text',
  notification_field_closing_text: 'Closing Text',
  notification_field_status: 'Enable this notification',
  notification_field_main_body: 'Main Body Text (optional)',
  notification_field_reviewers: 'Reviewers',
  notification_field_warning_text: 'Warning Text (Red)',
  notification_field_interval: 'Send Interval (required)',
  notification_field_interval_countdown_helper_text: 'Days prior to token expiration. Use commas to send at desired intervals.',
  notification_field_interval_countdown_validation_error: 'Must be comma separated integers between 1 and 31 (days).',
  notification_field_interval_countforward_helper_text: 'Days after token expiration. Use commas to send at desired intervals.',
  notification_field_interval_countforward_validation_error: 'Must be comma separated integers between 0 and 31 (days).',
  notification_field_interval_countforward_single_helper_text: 'Reminds every [X] days after revision is required.',
  notification_field_interval_countforward_single_validation_error: 'Must be a single integer between 1 and 31 (days).',

  notification_updated: 'Notification has been updated',

  notification_settings_parent_warning: 'This is the parent subtenant. All child subtenants will inherit customizations made here, unless inheritance is disabled within the child subtenant for this specific notification.',

  restore_branding_defaults_dialog_title: 'Restore Default Branding Settings',
  restore_branding_defaults_dialog_warning: 'You are about to restore the default Patrol settings to this notification. This will restore the notifications options, subject, and body content to the Proofpoint defaults.',
  restore_branding_defaults_dialog_text: 'Are you sure you want to restore defaults? This action cannot be undone.',
  restore_branding_defaults_dialog_confirm: 'Restore Defaults',

  email_identifier: 'Email Identifier',
  //status: 'Status',
  inheritance_enabled: 'Inheritance Enabled',
  inheritance: 'Inheritance',
  bcc_to_system_users: 'Bcc System Users',
  notifications_interval: 'Send Interval',
  notifications_last_updated: 'Last Updated',
  preview_email: 'Recipient Email',
  preview_email_hint: 'Enter a valid email address',
  preview_email_placeholder: 'Enter a recipient email address',

  email_field_boolean_TRUE: 'True',
  email_field_boolean_FALSE: 'False',
  email_field_boolean_NOT_AVAILABLE: 'N/A',

  email_field_enabled_TRUE: 'Enabled',
  email_field_enabled_FALSE: 'Disabled',

  email_field_status_ENABLED: 'Enabled',
  email_field_status_DISABLED: 'Disabled',
  email_field_status_POLICY: 'Policy Controlled',

  email_field_interval_ONCE: 'Once',
  email_field_interval_COUNTDOWN: 'Countdown',
  email_field_interval_COUNTFORWARD: 'Count Forward',
  email_field_interval_COUNTDOWN_SINGLE: 'Countdown',

  activity_policies: "Activity Policies",
  granular_activity_policies: "Granular Activity Policies",
  activity_policies_title: "Granular Activity Policy Configuration",
  view_usage: "View Usage",
  policy_configurations: "Policy Configurations",
  view_granular_activity_policy: "View Granular Activity Policy Usage",
  granular_activity_policy: "Granular Activity Policy: {activity_policy_name}",
  accounts_using_policy: "Accounts Using Policy",
  policy_configs_using_policy: "Policy Configurations Using policy",
  create_granular_activity_policy: "Create Granular Activity Policy",
  edit_granular_activity_policy: "Edit Granular Activity Policy",
  save_granular_activity_policy: "Save Granular Activity Policy",
  granular_activity_policy_name: "Granular Activity Policy Name",
  enter_description: "Enter description",
  activity_category: "Activity Category",
  application_policy: "Application Policy",
  enforce_publish_pre_screening: "Enforce Publish Pre Screening",
  use_default_outbound_policy: "Use Default Outbound Policy",
  select_default_outbound_policy: "Select {policy_name} Policy (required)",
  use_default_inbound_policy: "Use Default Inbound Policy",
  enabled: "Enabled",
  disabled: "Disabled",
  define_content_policy_enforce_publish: "Must define a Content Policy to Enforce Publish Flag",
  define_content_policy_app_policy: "Must define a Content Policy to set Application Policy",
  define_content_policy_default: "Must define a Content Policy for {node_type_category}",
  required_field: "This field is required",
  to_long_string: "This field must be no more than {count} characters",
  max_value: "This field must be no more than {count}",
  min_value: "This field must be no less than {count}",
  invalid_type: "Invalid file type: {invalid_type}. Only {valid_type} files are allowed.",
  invalid_size: "File size is too large {invalid_size}. Maximum allowed is {valid_size}.",
  activity_policy_created: "The granular activity policy ''{activity_policy}'' was created successfully.",
  activity_policy_updated: "The granular activity policy ''{activity_policy}'' was updated successfully.",
  activity_policy_destroyed: "The granular activity policy ''{activity_policy}'' was deleted successfully.",
  view_edit_activity_policy: "View/Edit Granular Activity Policy",
  delete_granular_activity_policy: "Delete Granular Activity Policy",
  delete_granular_activity_disclaimer: "Are you sure you want to delete ''{activity_policy}''?\nThis operation cannot be undone.",
  activity_policy_cannot_delete: "This policy is currently in use and cannot be deleted.",
  select_app_policy_optional: "Select Application Policy (optional)",
  copy_token: "copy token",
  duplicate_granular_activity_policy: "Duplicate Granular Activity Policy",
  copy_of_activity_policy_name: "Copy of {name}",
    primary_language: 'Primary',
    secondary_language: 'Secondary',

    profile_language: 'Profile Language',
    field_issue_secondary: '(Secondary)',

    ar_AE: 'Arabic',
    bn_IN: 'Bangla',
    cs_CZ: 'Czech',
    da_DK: 'Danish',
    de_DE: 'German',
    el_GR: 'Greek',
    en_US: 'English',
    es_ES: 'Spanish',
    fi_FI: 'Finnish',
    fr_FR: 'French',
    hi_IN: 'Hindi',
    hu_HU: 'Hungarian',
    id_ID: 'Indonesian',
    it_IT: 'Italian',
    ja_JP: 'Japanese',
    ko_KR: 'Korean',
    ms_MY: 'Malay',
    nl_NL: 'Dutch',
    no_NO: 'Norwegian',
    pa_IN: 'Punjabi',
    pl_PL: 'Polish',
    pt_BR: 'Portuguese',
    ro_RO: 'Romanian',
    ru_RU: 'Russian',
    sv_SE: 'Swedish',
    te_IN: 'Telugu',
    th_TH: 'Thai',
    tl_PH: 'Tagalog',
    tr_TR: 'Turkish',
    uk_UA: 'Ukrainian',
    vi_VN: 'Vietnamese',
    zh_CN: 'Chinese',
    zh_TW: 'Chinese',
    sq_AL: 'Albanian',
    hy_AM: 'Armenian',
    bs_BA: 'Bosnian',
    my_MM: 'Burmese',
    hr_HR: 'Croatian',
    is_IS: 'Icelandic',
    jv_ID: 'Javanese',
    kn_IN: 'Kannada',
    lv_LV: 'Latvian',
    lt_LT: 'Lithuanian',
    ml_IN: 'Malayalam',
    sr_RS: 'Serbian',
    sk_SK: 'Slovak',
    ta_IN: 'Tamil',
    iw_IL: 'Hebrew',
    mr_IN: 'Marathi',
    fa_IR: 'Persian',
    sr_BA: 'Serbian',
    jv_JV: 'Javanese',
    xx_XX: 'Other',

    alternate_edition_title: 'Profile changes Saved',
    alternate_edition_body: 'Your profile changes have been saved. Do you also want to update your alternate language profile?',
    alternate_edition_confirm: 'Update Alternate Language',
    empty_items_for_action: 'No applicable fields were found for the selected action.',

  patrol_install_title: 'Patrol Installation',
  patrol_install_button: 'Install Patrol on {selected_count} Selected Accounts',
  search_by_name: 'Search by Name',
  show_all: 'Show All',

  title_account_install_descriptor_GB: 'locations',
  account_install_descriptor_GB: 'Google Business Profiles',

  patrol_install_subtitle: 'Select {descriptor} to grant Patrol access to',
  install_header_line: 'We found {count} Google Business Profiles for your account. Some Profiles are already connected. Selecting them ensures Patrol has up-to-date access.',
  non_connected: 'Not Connected',
  connected: 'Connected',
  back_to_install: 'Back to Install Acounts',
  load_more: 'Load More Results',
  install_total_vs_loaded_text: '{loaded} Accounts loaded from a total of {total}',
  install_new_accounts_text: 'New locations are selected automatically as they appear. Load more to include additional locations.',
  install_loaded_accounts_text: 'Connected locations can also be selected to ensure patrol has up-to-date access and updated permissions. ',
  account_name: 'Account Name',
  patrol_install_complete_message: 'Your accounts are being set up. You will receive an email when the operation is completed. You can install more accounts by clicking the button at the top right. ',
  patrol_install_error_message: 'There has been an error with your installation. Please click the button at the top right to try again.',

  // GBP Regular Hours Editor
  gbp_hours_day_monday: 'Monday',
  gbp_hours_day_tuesday: 'Tuesday',
  gbp_hours_day_wednesday: 'Wednesday',
  gbp_hours_day_thursday: 'Thursday',
  gbp_hours_day_friday: 'Friday',
  gbp_hours_day_saturday: 'Saturday',
  gbp_hours_day_sunday: 'Sunday',
  gbp_hours_closed: 'Closed',
  gbp_hours_opens_at: 'Opens',
  gbp_hours_closes_at: 'Closes',
  gbp_hours_open_24_hours: 'Open 24 hours',
  gbp_special_hours_add_date: 'Add Special Date',
  gbp_special_hours_remove_date: 'Remove Special Date',

  // Syndicate
  syndicate_tab_content: 'Content',
  syndicate_tab_configuration: 'Configuration',
  syndicate_tab_content_feeds: 'Content Feeds',
  syndicate_col_submitter:  'Submitter',
  syndicate_col_native_ids: 'Native IDs',
  syndicate_col_has_image:  'Image',
  syndicate_col_expiration_date: 'Expiration Date',
  syndicate_col_workflow: 'Workflow',
  syndicate_col_route_notifications_by: 'Route Notifications By',
  syndicate_col_external_identifier: 'External Identifier',
  syndicate_col_note: 'Note',
  syndicate_col_reviewer_code: 'Reviewer Code',
  syndicate_col_reviewer: 'Reviewer',
  syndicate_col_native_id: 'Native ID',
  syndicate_native_ids: 'Native IDs',
  syndicate_action_view_details: 'View Details',
  syndicate_action_retire: 'Retire',
  syndicate_action_restore: 'Restore',
  syndicate_confirm_retire_title: 'Retire Content',
  syndicate_confirm_retire_message: 'Are you sure you want to retire this content item? It will no longer be visible to end users.',
  syndicate_confirm_restore_title: 'Restore Content',
  syndicate_confirm_restore_message: 'Are you sure you want to restore this content item?',
  syndicate_retire_success: 'Content item retired successfully.',
  syndicate_restore_success: 'Content item restored successfully.',
  syndicate_action_native_ids: 'Native IDs',
  syndicate_action_edit_content: 'Edit Expiration and Tags',
  syndicate_action_edit_tags: 'Edit Tags',
  syndicate_edit_content: 'Edit Expiration and Tags',
  syndicate_edit_tags: 'Edit Tags',
  syndicate_edit_success: 'Content item updated successfully.',
  syndicate_action_change_expiration_date: 'Change Expiration Date',
  syndicate_action_remove: 'Remove',
  syndicate_status_unapproved: 'Unapproved',
  syndicate_status_pending: 'Pending',
  syndicate_search_placeholder: 'Search content',
  syndicate_create_new_content: 'New Content',
  syndicate_export_csv: 'Export CSV',
  syndicate_export_csv_modal_title: 'Export Content Library',
  syndicate_export_csv_modal_description: 'The CSV file containing the exported content library will be downloaded once it has been created, which may take a moment. Please confirm that you want to proceed.',
  syndicate_export_csv_modal_confirm: 'Export to CSV',
  syndicate_import_content: 'Import CSV File',
  syndicate_import_csv_title: 'Import CSV File',
  syndicate_import_csv_instructions: 'Bulk upload your content from a spreadsheet that you save to a CSV file. Do not use headers. Your content should be in the following format:',
  syndicate_import_csv_col_name: 'Column 1: Name',
  syndicate_import_csv_col_content: 'Column 2: Content text',
  syndicate_import_csv_col_comments: 'Column 3: Comment (not required)',
  syndicate_import_csv_col_image_url: 'Column 4: Image URL (not required)',
  syndicate_import_csv_select_file: 'Select CSV File',
  syndicate_import_csv_submit: 'Submit CSV',
  syndicate_import_csv_submitting: 'Importing your content...',
  syndicate_import_csv_details: 'CSV Import Details:',
  syndicate_import_csv_added_correctly: 'Added correctly:',
  syndicate_import_csv_errors: 'Errors:',
  syndicate_import_csv_col_header_name: 'Name',
  syndicate_import_csv_col_header_categories: 'Categories',
  syndicate_import_csv_col_header_content: 'Content',
  syndicate_import_csv_col_header_image: 'Image',
  syndicate_import_csv_col_header_matches: 'Matches',
  syndicate_import_csv_col_header_error: 'Error',
  syndicate_filter_date_range: 'Date Range',
  syndicate_filter_status_open_approved: 'Open and Approved',
  syndicate_filter_status_unapproved_pending: 'Unapproved/Pending',
  syndicate_filter_status_rejected: 'Rejected',
  syndicate_filter_status_retired: 'Retired',
  syndicate_filter_tag_campaign: 'Campaign',
  syndicate_filter_tag_promo: 'Promo',
  syndicate_filter_tag_q4: 'Q4',
  syndicate_filter_tag_holiday: 'Holiday',
  syndicate_submit_new_content: 'Submit New Content',
  syndicate_policy_configuration: 'Policy Configuration',
  syndicate_native_id: 'Native ID',
  syndicate_native_id_helper: 'Use this field to enter the native ID of social activity for auto-approval.',
  syndicate_additional_comments: 'Additional Comments',
  syndicate_image_url: 'Image URL',
  syndicate_content_placeholder: 'Add text and any full or shortened links',
  syndicate_image_url_placeholder: 'Enter URL image',
  syndicate_select_image: 'Select image',
  syndicate_or: 'OR',
  syndicate_approval_expiration_date: 'Approval Expiration Date',
  syndicate_check_against_policy: 'Check Against Policy',
  syndicate_submit_content: 'Submit Content',
  syndicate_form_required_fields: 'Please fill in: {fields}',
  syndicate_form_required_content_or_image: 'content or an image',
  syndicate_check_back: '< Back',
  syndicate_check_checking: 'Checking your content against the policy...',
  syndicate_check_approved: 'If your content was submitted as is, it would be approved.',
  syndicate_check_needs_approval_all: 'If your content was submitted as is, it would need to undergo a manual review. This is because all content in your organization must be reviewed, and not necessarily because of a specific issue with your content.',
  syndicate_check_needs_approval_incident: 'If your content was submitted as is, it would need to undergo a manual review. This is because your content triggered on these policy categories: {categories}',
  syndicate_check_rejected: 'If your content was submitted as is, it would be rejected. This is because your content triggered on these policy categories: {categories}',
  syndicate_submit_success: 'Content submitted successfully.',
  syndicate_content_details: 'Content Details',
  syndicate_current_status: 'Current Status',
  syndicate_policy_categories: 'Policy Categories',
  syndicate_submitted_by: 'Submitted By',
  syndicate_submitted_at: 'Submitted At',
  syndicate_images: 'Images',
  syndicate_reviewer_notes: 'Reviewer Notes',
  syndicate_new_policy_config: 'New Policy Config',
  syndicate_new_policy_configuration: 'New Policy Configuration',
  syndicate_edit_policy_configuration: 'Edit Policy Configuration',
  syndicate_configuration_name: 'Configuration Name',
  syndicate_content_policy: 'Content Policy',
  syndicate_official_disclosure: 'Content will be posted to an official disclosure account',
  syndicate_financial_institution: 'Content will be posted to accounts for a financial institution',
  syndicate_use_for_api: 'Use this configuration for content submitted by external applications',
  syndicate_use_for_api_col: 'External Applications',
  syndicate_route_notifications_by_label: 'Route Notifications by:',
  syndicate_all_approvers: 'All Approvers',
  syndicate_notification_policy: 'Notification Policy',
  syndicate_apply_notification_policy: 'Apply Notification Policy',
  syndicate_create_configuration: 'Create Configuration',
  syndicate_config_created: 'Policy configuration created successfully.',
  syndicate_config_updated: 'Policy configuration updated successfully.',
  syndicate_config_deleted: 'Policy configuration deleted successfully.',
  syndicate_confirm_delete_config_title: 'Delete Policy Configuration',
  syndicate_confirm_delete_config_message: 'Are you sure you want to delete this policy configuration? This action cannot be undone.',
  syndicate_policy_none_selected: '-- none selected --',
  syndicate_policy_baseline_general: 'Baseline / General',
  syndicate_policy_default: 'Default Policy',
  syndicate_policy_finance: 'Finance Policy',
  syndicate_policy_mr_puto: 'Mr Puto Policy',
  syndicate_workflow_none: 'None',
  syndicate_workflow_type_approve_incidents: 'Review Outbound Activity (if set to Notify)',
  syndicate_workflow_type_brand_and_commenter: 'Review Outbound/Inbound Activity (if set to Notify)',
  syndicate_workflow_type_approve_all: 'Review All Outbound Activity (unless Auto-Rejected)',
  syndicate_workflow_type_use_main: 'Use Main Workflow selection',
  syndicate_workflow_type_takedown: 'Takedown',
  syndicate_notification_policy_my: 'My Notification Policy',
  syndicate_new_content_feed: 'New Content Feed',
  syndicate_edit_content_feed: 'Edit Content Feed',
  syndicate_feed_title: 'Feed Title',
  syndicate_feed_url: 'Feed URL',
  syndicate_feed_policy: 'Feed Policy',
  syndicate_add_feed: 'Add Feed',
  syndicate_create_feed: 'Create Feed',
  syndicate_feed_identifier: 'Content Feed Identifier',
  syndicate_feed_created: 'Feed subscription created successfully.',
  syndicate_feed_updated: 'Feed subscription updated successfully.',
  syndicate_feed_deleted: 'Feed subscription deleted successfully.',
  syndicate_feed_col_title: 'Title',
  syndicate_feed_col_url: 'URL',
  syndicate_feed_col_policy: 'Policy',
  syndicate_feed_url_invalid: 'Must start with https://, http://, or feed:// and must not include a port.',
  syndicate_confirm_delete_feed_title: 'Delete Content Feed',
  syndicate_confirm_delete_feed_message: 'Are you sure you want to delete this content feed? This action cannot be undone.',
  syndicate_push_to_amplify: 'Push to Hootsuite Amplify',
  syndicate_amplify_topics: 'Amplify Topics',
};
